import React, { useEffect, useRef, useState } from "react";

import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import ErrorIcon from "@mui/icons-material/Error";
import {
  Box,
  Dialog,
  DialogActions,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  ListSubheader,
  MenuItem,
  Popover,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  CircularProgress,
} from "@mui/material";
import Sidebar from "../comman/Sidebar";
import Navbar from "../comman/Navbar";
import dayjs from "dayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import AttachmentRed from "../../images/attachment-red.svg";
import AttachmentGreen from "../../images/attachment-green.svg";
import Download from "../../images/Download.svg";
import Print from "../../images/Print.svg";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import {
  CircleGreenFillIcon,
  CircleGreenIcon,
  CircleIcon,
  DownloadIcon,
} from "../../images/SvgIcons";
import { useFormik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import {
  ATTACH_DETACH_INVOICE_URL,
  DELETE_INVOICE_ATTATCHMENTS,
  DELETE_INVOICE_LINE_ITEM_URL,
  GET_ALL_BROKERS,
  GET_ATTACH_URL,
  GET_BILLING_STATEMENT_BY_ID_URL,
  GET_BILLING_STATEMENT_DETAILS_BY_ID_URL,
  GET_CUSTOMER_BY_ID_URL,
  GET_DAY_AND_MILEAGE_RATE_URL,
  GET_INVOICE_ATTATCHMENT_LIST_URL,
  GET_INVOICE_DETAILS_BY_ID,
  GET_INVOICE_SELECTED_PERIOD_URL,
  GET_PROJECT_DETAILS_BY_ID_URL,
  GET_PROJECTS_ID,
  SYSTEM_LOG_INSERT_URL,
  UPDATE_DAY_AND_MILEAGE_RATE_INVOICE_URL,
  UPDATE_INVOICE_BILLING_ADDRESS,
  UPDATE_INVOICE_STATUS_URL,
  UPSERT_INVOICE_DETAILS_URL,
  UPSERT_INVOICE_STATEMENT_URL,
  GET_ATTACH_NEW_STATEMENT_INVOICE_URL,
  GET_ATTACHMENT_BY_BILLING_PROJECT_ID_URL,
} from "../../constants/ApiRoute";
import { authHeader, getLogUserId, getLogUserName } from "../comman/MainFunction";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import API from "../comman/API";
import { useToast } from "../comman/CustomMessages";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import {
  getAllStatesList,
  getAlluserList,
  getPerDiemList,
} from "../../redux/action";
import DetachConfirmation from "./DetachConfirmation";
import CircleGreenIconSvg from "../../images/Nodes-green-circle.svg";
import AttachConfirmation from "./AttachConfirmation";
import InvoiceAttachment from "../model/InvoiceAttachment";
import { INVOICE_LIST, PAGE_NOT_FOUND_PATH } from "../../constants/RoutePath";
import axios from "axios";
import sampleimg from "../../images/myw3schoolsimage.jpg";
import CustomPageLoading from "../comman/CustomPageLoading";
import JSZip from "jszip";
import PrintConsolidatedInvoiceModel from "../model/PrintConsolidatedInvoiceModel";
import {
  getLineDayRateOptions,
  getLineRatePayload,
  getInvoiceSelectionRate,
  getSelectedRateFields,
  getPersistedSelectedDayRate,
  isEnabledRateFlag,
  normalizeProjectRateData,
  normalizeSelectedDayRate,
  resolveNewLineItemDayRate,
  resolveExistingLineItemDayRate,
  buildNewLineItemRatePayload,
  buildExistingLineItemRatePayload,
} from "./dayRateUtils";
const today = dayjs();
const yesterday = dayjs().subtract(1, "day");
const todayStartOfTheDay = today.startOf("day");
const steps = [
  "Statement Open",
  "Statement Closed",
  "Invoice Started",
  "Invoice Closed",
];
const billTypeList = [
  { id: 1, name: "Abstract" },
  { id: 2, name: "Mineral" },
  { id: 3, name: "Tract" },
  { id: 4, name: "Cursory Title" },
  { id: 5, name: "Due Dilligence" },
  { id: 6, name: "Area Checks" },
  { id: 7, name: "Curative" },
  { id: 8, name: "Other" },
];
const DAY_RATE_OPTIONS = [
  "Billable Rate",
  "Principal Rate",
  "Project Manager Rate",
  "Field Agent Rate",
];

const getDayRateForSelection = (selection, project, fallback, preferSelectedRate = false) => {
  const sourceBySelection = {
    "Billable Rate": [
      "BillingDayRate",
      "BillableDayRate",
      "billingDayRate",
      "billableDayRate",
      "MatchedDayRate",
      "dayRate",
    ],
    "Principal Rate": [
      ...(preferSelectedRate ? ["SelectedPrincipalRate", "selectedPrincipalRate"] : []),
      "PrincipalRate",
      "principalRate",
    ],
    "Project Manager Rate": [
      ...(preferSelectedRate ? ["SelectedProjectManagerRate", "selectedProjectManagerRate"] : []),
      "ProjectManagerRate",
      "projectManagerRate",
    ],
    "Field Agent Rate": [
      ...(preferSelectedRate ? ["SelectedFieldAgentRate", "selectedFieldAgentRate"] : []),
      "FieldAgentRate",
      "fieldAgentRate",
    ],
  };
  const value =
    (sourceBySelection[selection] || sourceBySelection["Billable Rate"])
    .map((key) => project?.[key])
    .find(
      (item) =>
        item !== null &&
        item !== undefined &&
        item !== "" &&
        Number.isFinite(Number(item))
    );

  return value === undefined ? fallback : value;
};

const formatPopulatedDayRate = (value) =>
  value !== null &&
  value !== undefined &&
  value !== "" &&
  Number.isFinite(Number(value))
    ? Number(value).toFixed(2)
    : value;

const getExistingDayRate = (...rates) =>
  rates.find(
    (rate) =>
      rate !== null &&
      rate !== undefined &&
      rate !== "" &&
      Number.isFinite(Number(rate))
  );
const getProjectHeaderRateFields = (source = {}, selection, selectedRate) => ({
  selectedPrincipalRate: formatPopulatedDayRate(
    source.selectedPrincipalRate ?? source.SelectedPrincipalRate ?? 0
  ),
  selectedProjectManagerRate: formatPopulatedDayRate(
    source.selectedProjectManagerRate ?? source.SelectedProjectManagerRate ?? 0
  ),
  selectedFieldAgentRate: formatPopulatedDayRate(
    source.selectedFieldAgentRate ?? source.SelectedFieldAgentRate ?? 0
  ),
  ...getSelectedRateFields(selection, selectedRate),
});
const getInvoiceLineChargeBreakdown = (lineItems = [], invoiceRates = {}) => {
  const grouped = new Map();

  (Array.isArray(lineItems) ? lineItems : []).forEach((item) => {
    const selection = normalizeSelectedDayRate(
      item?.selectedDayRate ??
        item?.SelectedDayRate ??
        item?.InvSelectedDayRate
    );
    const hours = Number(item?.Hours ?? item?.hours ?? 0);
    if (!Number.isFinite(hours)) return;

    grouped.set(selection, (grouped.get(selection) || 0) + hours);
  });

  return DAY_RATE_OPTIONS.filter((selection) => grouped.has(selection)).map(
    (selection) => {
      const hours = grouped.get(selection);
      const rate = Number(
        getDayRateForSelection(selection, invoiceRates, 0, true)
      );
      const billableDays = hours / 8;

      return {
        selection,
        label: selection.replace(" Rate", " day rate"),
        hours,
        billableDays,
        rate: Number.isFinite(rate) ? rate : 0,
        charge: Number.isFinite(rate) ? billableDays * rate : 0,
      };
    }
  );
};
const initialValues = {
  street1: "",
  street2: "",
  city: "",
  state: 1,
  zipcode: "",
  invoiceDate: dayjs(),
  createDate: dayjs(),
  invoiceNo: "",
  invoiceTotal: "",
  projectName: "",
  startDate: "",
  endDate: "",
  brokerName: "",
  totalPerDiem: "0",
  totalExpenses: "",
  totalMileage: "",
  totalCharges: "",
  totalLodging: "",
  totalCopies: "",
  totalMisc: "",
  totalHours: "0",
  dayRate: "1",
  mileageRate: "",
  totalMiles: "0",
  perMile: "1",
};
const initialLineItem = {
  invoiceDetailsId: "",
  invoiceHeaderId: "",
  billingHeaderId: "",
  billingDetailId: "",
  brokerId: "",
  billingType: "",
  dayRate: "",
  selectedDayRate: "Billable Rate",
  hours: "0.00",
  miles: "0",
  lodging: "0.00",
  description: "",
  perDiem: "0.00",
  copies: "0.00",
  misc: "0.00",
  perDiemRate: "0.00",
  // date: moment(new Date()).format("MM/DD/YYYY"),
  date: "",
};
const initialArrayOfLines = {
  brokerId: "",
  brokerName: "",
  hours: "",
  lastModify: "",
  status: "",
  total: "",
  billingType: "",
};
export default function ConsolidatedInvoiceForm() {
  const location = useLocation();

  // Get the full pathname (e.g., '/invoice-form/10449')
  const fullPath = location.pathname;

  // Split the pathname to get 'invoice-form'
  const pathSegments = fullPath.split("/");

  // Get the second segment of the path (invoice-form)
  const currentPathSegment = pathSegments[1];

  console.log(currentPathSegment, "currentPathSegmentcurrentPathSegment");
  const gridRef = useRef(null);
  const gridRefDay = useRef(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const invoiceid = id;
  const invoiceLoadRef = useRef(0);
  const invoiceDetailsLoadedRef = useRef(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl1, setAnchorEl1] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const [anchorElPerDiem, setAnchorElPerDiem] = React.useState(null);
  const [anchorExpenses, setAnchorExpenses] = React.useState(null);
  const [anchorBilling1, setAnchorBilling1] = React.useState(null);
  const [activeStep, setActiveStep] = React.useState(2);
  const [completed, setCompleted] = React.useState({});
  const [LineItemArr, setLineItemArr] = React.useState({});
  const [LineItemArrIni, setLineItemArrIni] = React.useState({});
  const [invoiceStatus, setInvoiceStatus] = useState(false);
  const [detachOpen, setDetachOpen] = useState(false);
  const [AtachOpen, setAttachOpen] = useState(false);
  const [isAttach, setIsAttach] = useState(false);
  const perList = deCryptFun(useSelector((s) => s.AllPerDiemListReducer));
  const [rateFlag, setRateFlag] = useState(false);
  const [finalThrs, setFinalThrs] = useState(0);
  const [finalTLodg, setFinalTLodg] = useState(0);
  const [finalTCopy, setFinalTCopy] = useState(0);
  const [finalTMisc, setFinalTMisc] = useState(0);
  const [finalTMiles, setFinalTMiles] = useState(0);
  const [finalTMileage, setFinalTMileage] = useState(0);
  const [finalTPerDiem, setFinalTPerDiem] = useState(0);
  const [closingInvoice, setCloseingInvoice] = useState(false);
  const [deletedInvoiceLineItemPopup, setDeletedInvoiceLineItemPopup] =
    useState(false);
  const [invoiceDetailsVallues, setInvoiceDetailsValues] = useState("");
  const [invoiceDeleteKey, setInvoiceDeleteKey] = useState("");
  const [invoiceDeleteIndex, setInvoiceDeleteIndex] = useState("");
  const [deleteLineProjId, setDeleteLineProjId] = useState("");
  const [projectFilterSelect, setProjectFilterSelect] = useState("All");
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);
  const [attachDettachLoading, setAttachDettachLoading] = useState(false);
  const [bname, setBname] = useState();
  const [projname, setPrpjName] = useState();
  const [projectIdval, setProjectIdval] = useState();
  const [customerIdValue, setCustomerIdval] = useState();
  const [attachDettachPeriodKey, setAttachDettachPeriodKey] = useState();
  const [attachDetailsUpsert, setAttachDettails] = useState({});
  console.log(attachDetailsUpsert, "attachDetailsUpsertattachDetailsUpsert");
  const [InvoiceTotalValue, setInvoiceTotalValue] = useState(0.0);
  const {
    BillableOfficePerDiem,
    BillableTravelPerDiem,
    BillingDayRate,
    MileageRate,
  } =
    (perList && JSON.parse(perList).data && JSON.parse(perList).data[0]) || [];
  const userListSel = deCryptFun(useSelector((s) => s.AllUserReducer));
  const stateList = deCryptFun(useSelector((s) => s.AllStateListReducer));
  const [attachmentId, setAttachmentId] = useState();
  const [lineList, setLineList] = useState([]);
  const [selectedPeriodList, setSelectedPeriodList] = useState([]);
  const [selectedNewPeriodList, setSelectedNewPeriodList] = useState([]);
  const [billingStatementHeading, setBillingStatementHeading] = useState("");
  const [invoiceStatusIDVal, setInvoiceStatusIDVal] = useState("");
  const [invoiceGrandTotalVal, setInvoiceGrandTotalVal] = useState(0.0);
  const [openAttachmentFilter, setOpenAttachmentFilter] = useState(false);
  const [headidStatement, setHeadIdStatement] = useState();
  const [brokerNamesperproject, setBrokerNamesPerproject] = useState([]);
  const [projectBrokerDetails, setProjectBrokerDetails] = useState([]);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [addressButtonLoading, setAddressButtonLoading] = useState();
  const [isAttachDetachLoaded, setIsAttachDetachLoaded] = useState(false);
  const [isAttachDetachLoadedBilling, setIsAttachDetachLoadedBilling] =
    useState(false);
  const [saveDayRateValue, setSaveDayRateValue] = useState(false);
  const [saveMileageRateValue, setSaveMileageRateValue] = useState(false);
  const [saveProjID, setSaveProjID] = useState("");
  const [saveCustomerId, setSaveCustomerId] = useState("");
  const [savePeriodKey, setSavePeriodKey] = useState("");
  const [saveMatchedDayRate, setSaveMatchedDayRate] = useState("");
  const [saveSelectedDayRate, setSaveSelectedDayRate] =
    useState("Billable Rate");
  const [saveProjectName, setSaveProjectName] = useState("");
  const [pendingDayRateSelections, setPendingDayRateSelections] = useState({});
  const [pendingDayRateValues, setPendingDayRateValues] = useState({});
  const hasUnsavedDayRate =
    Object.keys(pendingDayRateSelections).length > 0 ||
    Object.keys(pendingDayRateValues).length > 0;
  const [originalFinalList, setOriginalFinalList] = useState([]); // Store original values

  const dispatch = useDispatch();
  const [details, setDetails] = useState([]);
  const [finalList, setFinalList] = useState([]);
  const [shouldUpsert, setShouldUpsert] = useState(false);
  console.log(finalList, "jajajajjaalalallalalalla");
  console.log(lineList, "lineListlineListlineList");
  console.log(selectedPeriodList, "brokerNamesperprojectbrokerNamesperproject");
  const [initialLineList, setInitialLineList] = useState([]);
  const [deletedInvoicePopup, setDeletedInvoicePopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [consolidatedInvoiceDetails, setConsolidatedInvoiceDetails] = useState(
    []
  );
  const [reOpenLoading, setReopenLoading] = useState(false);
  console.log(initialLineList, "initialLineListinitialLineList");
  const [updateAddressValues, setUpdateAddressValues] = useState({
    street1: "",
    street2: "",
    city: "",
    state: "",
    zipcode: "",
  });
  const [changedFields, setChangedFields] = useState({});
  const [addressvaluesChanged, setAddressvaluesChanged] = useState(false);
  const [currentPopoverIndex, setCurrentPopoverIndex] = useState(null);
  const [warningHighlightColor, setWarningHighlightColor] = useState(false);
  const [addlineItemValue, setAddlineItemValue] = useState(false);
  const [showWarning, setShowWarningpopup] = useState(false);
  const [closeBillingAlert, setCloseBillingAlert] = React.useState(false);
  const [backNavigateArrow, setBackNavigateArrow] = useState(false);
  const [periousInvoiceDate, setInvoiceDate] = useState(null);
  const [dateFormatError, setDateFormatError] = useState("");
  console.log(consolidatedInvoiceDetails, "dateeeeeeeeeeeeee");
  // console.log(moment.utc(periousInvoiceDate).format('MM/DD/YYYY'), "dateeeeeeeeeeeeee");
  const [invoicDatePopup, setInvoiceDatePopup] = useState(false);

  const [popOvername, setPopOverName] = useState(null);
  const [projectDetailsValue, setProjectDetailsValue] = useState([]);
  const [bid, setBid] = useState(0);
  const [headId, setHeadId] = useState(0);
  const [openPrintInvoiceModel, setOpenPrintInvoiceModel] = useState(false);

  const filteredBrokerList = userListSel
    ? JSON.parse(userListSel).data.filter(
        (userlist) =>
          userlist.UserRole &&
          userlist.UserRole.split(",").includes(
            "6d8f5f3c-8ed1-40d5-b870-d54283c7da28"
          )
      )
    : [];
  const showToast = useToast();

  const handleAttachmentOpen = (val) => {
    // if (invoiceStatus) {
    //   showToast(
    //     "This invoice has been closed and can no longer be edited.",
    //     "reopenInvoice"
    //   );
    // }
    //  else {
    getInvoiceDetails("View-Edit", val);
    // setOpenAttachmentFilter(val);
    // }
  };
  const handleClose = () => {
    setDetachOpen(false);
    setAttachOpen(false);
  };
  const getValidationSchemaForIndex = (index) => {
    return Yup.object({
      lineItems: Yup.array().of(
        Yup.object().shape({
          billingType:
            index === undefined
              ? Yup.string().required("Billing type is required")
              : Yup.string(),
          brokerId:
            index === undefined
              ? Yup.string().required("Broker is required")
              : Yup.string(),
          date:
            index === undefined
              ? Yup.string().required("Date is required")
              : Yup.string(),
        })
      ),
    });
  };
  const validationSchemaFormNew = Yup.object().shape({
    lineItems: Yup.array().of(
      Yup.object().shape({
        billingType: Yup.string().required("Billing type is required"),
        brokerId: Yup.string().required("Broker is required"),
        date: Yup.string().required("Date is required"),
      })
    ),
  });

  const validateLineItemnew = (values, index) => {
    const errors = {};
    const touchedValues = {};
    if (!values.lineItems || !values.lineItems[index]) {
      console.error("Line item is undefined or index out of bounds");
      return false; // return false if line item does not exist
    }

    if (values.lineItems[index].billingType == "") {
      errors.billingType = "Billing type is required";
      touchedValues.billingType = true;
    } else {
      errors.billingType = "";
      touchedValues.billingType = false;
    }

    if (values.lineItems[index].brokerId == "") {
      errors.brokerId = "Broker is required";
      touchedValues.brokerId = true;
    } else {
      errors.brokerId = "";
      touchedValues.brokerId = false;
    }

    if (!dayjs(values.lineItems[index].date)) {
      errors.date = "Date is required";
      touchedValues.date = true;
    } else {
      errors.date = "";
      touchedValues.date = false;
    }

    if (Object.keys(errors).length > 0) {
      formik1.setErrors({
        lineItems: {
          ...formik1.errors.lineItems,
          [index]: errors,
        },
      });
      formik1.setTouched({
        lineItems: {
          ...formik1.touched.lineItems,
          [index]: touchedValues,
        },
      });

      const allValuesAreFalse = Object.values(errors).every((value) => {
        return value === "";
      });
      if (allValuesAreFalse) {
        return true;
      } else {
        return false; // return false if there are validation errors
      }
    }

    return true; // return true if validation passed
  };

  const generateInitialValues = (numberOfLineItems, startDate) => {
    const initialValuesLines = {};
    const startMoment = moment(startDate, "MM/DD/YYYY").local().startOf("day");
    for (let i = 1; i <= numberOfLineItems; i++) {
      const currentMoment = startMoment
        .clone()
        .add(i - 1, "days")
        .startOf("day");
      initialValuesLines[`lineItem${currentMoment.format("MM/DD/YYYY")}`] = [
        {
          invoiceDetailsId: "",
          invoiceHeaderId: "",
          billingHeaderId: "",
          billingDetailId: "",
          brokerId: "",
          billingType: "",
          dayRate: "",
          selectedDayRate: "Billable Rate",
          hours: "0.00",
          miles: "0",
          lodging: "0.00",
          description: "",
          perdiemRate: "$0.00",
          perDiem: "0.00",
          copies: "0.00",
          misc: "0.00",
          date: currentMoment.format("MM/DD/YYYY"),
          billingStatementDetailsId: 0,
        },
      ];
    }

    return initialValuesLines;
  };
  React.useEffect(() => {
    let stDate = moment(new Date()).utc().format("MM/DD/YYYY");
    let val = generateInitialValues(1, stDate);
    // setLineItemArr(val)
    setLineItemArrIni(val);
    // formik1.setValues(val)
  }, []);

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };
  const handleStep = (step) => () => {
    // setActiveStep(step);
  };
  const handlePopoverOpen = (event, index, name) => {
    setAnchorEl(event.currentTarget);
    setCurrentPopoverIndex(index);
    setPopOverName(name);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setCurrentPopoverIndex(null);
    setPopOverName(null);
  };

  const isPopoverOpen = (index, name) => {
    return currentPopoverIndex === index && popOvername === name;
  };

  const handlePopoverOpen1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };

  const handlePopoverClose1 = () => {
    setAnchorEl1(null);
  };
  const handlePopoverOpen2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handlePopoverClose2 = () => {
    setAnchorEl2(null);
  };
  const handlePopoverOpenPerDiem = (event) => {
    setAnchorElPerDiem(event.currentTarget);
  };

  const handlePopoverClosePerDiem = () => {
    setAnchorElPerDiem(null);
  };

  const handlePopoverOpen1Expenses = (event) => {
    setAnchorExpenses(event.currentTarget);
  };

  const handlePopoverClose1Expenses = () => {
    setAnchorExpenses(null);
  };

  const open = Boolean(anchorEl);
  const open1 = Boolean(anchorEl1);
  const open2 = Boolean(anchorEl2);
  const openExpenses = Boolean(anchorExpenses);
  const BillingPeriod1 = Boolean(anchorBilling1);
  const openPerDiem = Boolean(anchorElPerDiem);
  const validationSchema = Yup.object({
    street1: Yup.string().required("Address is required"),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    zipcode: Yup.string().required("Zipcode is required"),
  });
  const validationSchemaForm1 = Yup.object({
    lineItems: Yup.array().of(
      Yup.object().shape({
        billingType: Yup.string().required("Billing type is required"),
        brokerId: Yup.string().required("Broker is required"),
        date: Yup.string().required("Date is required"),
      })
    ),
  });

  const lineItemValidationSchema = Yup.object().shape({
    billingType: Yup.string().required("Billing type is required"),
    brokerId: Yup.string().required("Broker is required"),
  });

  const validationSchemaForm2 = Yup.object().shape(
    Object.keys(initialValues)
      .filter((key) => key.startsWith("lineItem"))
      .reduce((schema, key) => {
        schema[key] = Yup.array().of(lineItemValidationSchema);
        return schema;
      }, {})
  );
  const {
    handleSubmit,
    handleChange,
    setValues,
    setFieldTouched,
    values,
    errors,
    setErrors,
    touched,
    resetForm,
    setFieldValue,
    setTouched,
  } = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      upsertAddressFun(values);
    },
  });
  console.log(values, "valuesssss");
  const [previousMileageRate, setPreviousMileageRate] = useState();
  const [currentMileageRate, setCurrentMileageRate] = useState();
  const [previousDayRate, setPreviousDayRate] = useState();
  const [currentDayRate, setCurrentDayRate] = useState();
  const [
    previousMileageRateDayRateByProject,
    setPreviousMileageRateDayRateByProject,
  ] = useState("");
  const [oldMileageRateDayRateByProject, setOldMileageRateDayRateByProject] =
    useState("");
  console.log(
    oldMileageRateDayRateByProject,
    "voldMileageRateDayRateByProjectaluesssss"
  );
  const upsertAddressFun = async () => {
    setAddressButtonLoading(true);
    let postData = {
      invoiceId: invoiceid,
      billToStreet1: values.street1,
      billToStreet2: values.street2,
      billToCity: values.city,
      billToState: values.state,
      billToZip: values.zipcode,
    };
    const config = {
      method: "PUT",
      headers: authHeader(),
      url: UPDATE_INVOICE_BILLING_ADDRESS,
      data: {
        webString: enCryptFun(JSON.stringify(postData)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status == "Success") {
        const message = parsedResponse.message;

        const invoiceUpdateMessage = message.split("\\n")[0]; // The first line contains the static part
        const updatedData = message
          .split("\\n") // Split the message into lines by the newline character
          .slice(1) // Ignore the first line as it contains the static part
          .filter((line) => line.includes("updated from")) // Keep only lines that mention updates
          .map((line) => line.trim()); // Clean up extra spaces

        const formattedUpdates = updatedData.map((update, index) => (
          <span key={index}>{update}</span>
        ));

        console.log(formattedUpdates, "formattedUpdatesformattedUpdates");
        console.log(updatedData, "formatupdatedDatatedUpdatesformattedUpdates");
        console.log(
          invoiceUpdateMessage,
          "formatupdateinvoiceUpdateMessagedDatatedUpdatesformattedUpdates"
        );

        let toastMessage = null;

        if (formattedUpdates.length == 0) {
          toastMessage = (
            <>
              <span>{invoiceUpdateMessage}</span>
              <br />
            </>
          );
          getInvoiceDetails();
          // Show the toast with the formatted message
          showToast(toastMessage, "success");
        } else if (formattedUpdates.length > 0) {
          toastMessage = (
            <>
              <span>{invoiceUpdateMessage}</span>
              <br />
              {formattedUpdates.map((update, index) => (
                <span key={index}>
                  {update}
                  <br />
                </span>
              ))}
            </>
          );
          getInvoiceDetails();
          // Show the toast with the formatted message
          showToast(toastMessage, "success");
        }
        setAddressButtonLoading(false);
        // showToast(parsedResponse.message, "success");
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v.message == "This invoice is closed and cannot be edited.") {
          showToast(v.message, "error");
          getInvoiceDetails();
        } else {
          showToast(v.message, "error");
        }
      }
      setAddressButtonLoading(false);
    }
  };
  const upsertInvoiceDetailsFun = async (
    val,
    Bids,
    Hids,
    ProjID,
    PeriodKey
  ) => {
    setSaveButtonLoading(true);
    const lineItem = formik1.values.lineItems[val];
    const {
      lodging,
      billingType,
      hours,
      perDiem,
      dayRate,
      miles,
      misc,
      copies,
      mileageRate,
      total,
      date,
      perDiemRate,
      description,
      brokerId,
      selectedDayRate: selectedDayRateValue,
    } = lineItem || [];

    console.log(lineItem,'lineeeeeeeeeeeee')
    const calculatedPerDiem = calculatePerDiem(hours, perDiemRate);

    // const { BillingHeaderID } = values;
    const projectForLine = finalList[val] || consolidatedInvoiceDetails[val] || projectDetailsValue[0] || {};
    const projectHeaderRate = getProjectHeaderRate(ProjID, PeriodKey);
    const projectHeaderDayRate = projectHeaderRate.dayRate ?? 0;
    const invoiceRateSource = {
      ...projectForLine,
      InvoiceDayRate: projectHeaderDayRate,
      BillingDayRate: projectHeaderDayRate,
      BillableDayRate: projectHeaderDayRate,
      ...projectHeaderRate,
    };
    const brokerForLine = findLineBroker(brokerId, ProjID);
    const resolvedRate = resolveNewLineItemDayRate(
      selectedDayRateValue,
      brokerForLine,
      normalizeProjectRateData(projectForLine),
      projectHeaderDayRate
    );
    const lineRateSource = normalizeProjectRateData(invoiceRateSource);
    const billableRate = getInvoiceSelectionRate(
      "Billable Rate",
      { ...projectForLine, ...lineItem, ...invoiceRateSource },
      lineRateSource,
      dayRate
    );
    let postData = {
      invoiceDetailsId: 0,
      invoiceHeaderId: parseInt(invoiceid),
      billingHeaderId: Hids ? Hids : 0,
      billingDetailId: Bids ? Bids : 0,
      brokerId: brokerId,
      billingType: billingType,
      date: dayjs(date).format("MM/DD/YYYY"),
      hours: parseFloat(hours) || 0,
      perDiem: perDiem ? perDiem : 0,
      lodging: lodging ? parseFloat(lodging) : 0,
      miles: miles ? parseFloat(miles) : 0,
      misc: misc ? parseFloat(misc) : 0,
      copies: copies ? parseFloat(copies) : 0,
      description: description ? description : "",
      perDiemRate:
        perDiemRate && !isNaN(parseFloat(perDiemRate))
          ? parseFloat(perDiemRate)
          : 0,
      ...buildNewLineItemRatePayload(
        resolvedRate.selectedDayRate,
        billableRate,
        resolvedRate.dayRate
      ),
      projectId: ProjID && ProjID,
      periodKey: PeriodKey,
    };

    const configone = {
      method: "POST",
      url: UPSERT_INVOICE_DETAILS_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(postData)),
      },
    };

    try {
      const response = await API(configone);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status == "Success") {
        showToast(parsedResponse.message, "success");
        formik1.resetForm();
        getInvoiceDetails("attach-dettach");
        setSaveButtonLoading(false);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v.message == "This invoice is closed and cannot be edited.") {
          showToast(v.message, "error");
        } else {
          showToast(v.message, "error");
        }
        await getInvoiceDetails();
        setSaveButtonLoading(false);
      }
    }
  };

  const getCustomersById = async (InvoiceCustomerID) => {
    let data = {
      userId: InvoiceCustomerID,
    };
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_CUSTOMER_BY_ID_URL,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        formik1.setValues((prev) => ({
          ...prev,
          // dayRate: DefaultDayRate != null ? parsedResponse?.data[0]?.DefaultDayRate : '0',
        }));
        setValues((prev) => ({
          ...prev,
          // dayRate: DefaultDayRate != null ? parsedResponse?.data[0]?.DefaultDayRate : '0',
        }));
      }
    } catch (error) {}
  };

  const getProjectsById = async (ProjID) => {
    let data = {
      projectIds: ProjID.toString(),
    };
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_PROJECTS_ID,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        const projectDetails = (parsedResponse.ProjectDetails || []).map(
          (project) => ({
            ...project,
            ProjectID: project.ProjectID ?? project.projectId,
            principalRate: project.PrincipalRate ?? project.principalRate,
            PrincipalRate: project.PrincipalRate ?? project.principalRate,
            projectManagerRate:
              project.ProjectManagerRate ?? project.projectManagerRate,
            ProjectManagerRate:
              project.ProjectManagerRate ?? project.projectManagerRate,
            fieldAgentRate: project.FieldAgentRate ?? project.fieldAgentRate,
            FieldAgentRate:
              project.FieldAgentRate ?? project.fieldAgentRate,
          })
        );
        const {
          MileageRate,
          BillableTravelPerDiem,
          BillingDayRate,
          BillableOfficePerDiem,
        } = projectDetails[0] || {};
        setValues((prev) => ({
          ...prev,
          mileageRate: MileageRate,
          BillableOfficePerDiem: BillableOfficePerDiem,
          BillableTravelPerDiem: BillableTravelPerDiem,
          BillingDayRate: BillingDayRate,
        }));
        setRateFlag((previous) => !previous);
        formik1.setValues((prev) => ({
          ...prev,
          mileageRate: MileageRate,
          BillableOfficePerDiem: BillableOfficePerDiem,
          BillableTravelPerDiem: BillableTravelPerDiem,
          BillingDayRate: BillingDayRate,
        }));
        setProjectDetailsValue((previous) => {
          const merged = [...previous];
          projectDetails.forEach((project) => {
            const existingIndex = merged.findIndex(
              (item) => String(item.ProjectID) === String(project.ProjectID)
            );
            if (existingIndex === -1) merged.push(project);
            else {
              merged[existingIndex] = {
                ...merged[existingIndex],
                ...project,
                principalRate:
                  project.principalRate ?? merged[existingIndex].principalRate,
                PrincipalRate:
                  project.PrincipalRate ?? merged[existingIndex].PrincipalRate,
                projectManagerRate:
                  project.projectManagerRate ??
                  merged[existingIndex].projectManagerRate,
                ProjectManagerRate:
                  project.ProjectManagerRate ??
                  merged[existingIndex].ProjectManagerRate,
                fieldAgentRate:
                  project.fieldAgentRate ?? merged[existingIndex].fieldAgentRate,
                FieldAgentRate:
                  project.FieldAgentRate ?? merged[existingIndex].FieldAgentRate,
              };
            }
          });
          return merged;
        });
        const mergedList = finalList.map((finalItem) => {
          const projectDetail = projectDetails.find(
            (detail) =>
              String(detail.ProjectID) ===
              String(finalItem.ProjID || finalItem.InvProjectID)
          );
          return { ...finalItem, ...projectDetail };
        });
        // setFinalList(mergedList)
      }
    } catch (error) {}
  };

  // const calculatePerDiem = (hours, rate) => {
  //   const parsedRate = parseFloat(rate) || 0;
  //   const hoursVal = Math.min(parseFloat(hours), 8); // Capping hours at 8

  //   return ((hoursVal / 8) * parsedRate).toFixed(3); // Returns the calculated per diem rounded to 2 decimal places
  // };

  const calculatePerDiem = (hours, rate) => {
    const parsedRate = parseFloat(rate) || 0;
    const roundHours = hours ? parseFloat(hours) : 0; // Ensure rate is a valid number
    const hoursVal = parseFloat(roundHours) <= 8 ? parseFloat(roundHours) : 8; // Ensure hours are a valid number and capped at 8
    const resultCalc = (hoursVal / 8) * parsedRate;

    // Truncate to 2 decimal places without rounding
    const truncatedResult = Math.trunc(resultCalc * 100) / 100;
    const roundedUpResult = Math.round(resultCalc * 100) / 100;
    return roundedUpResult.toFixed(2);
    // const roundedResult = parseFloat(resultCalc.toFixed(3));
    // return roundedResult % 1 === 0
    //   ? roundedResult.toString()
    //   : roundedResult.toFixed(3);
  };

  const getConsolidatedLineProject = (index) =>
    normalizeProjectRateData(
      consolidatedInvoiceDetails[index] ||
        finalList[index] ||
        projectDetailsValue[index] ||
        {}
    );
  const findLineBroker = (brokerId, projectId) => {
    if (brokerId === null || brokerId === undefined || brokerId === "") {
      return undefined;
    }

    const matchingBrokers = [
      ...projectBrokerDetails,
      ...brokerNamesperproject,
    ].filter(
      (broker) =>
        String(broker.UserID) === String(brokerId) ||
        String(broker.BrokerID) === String(brokerId)
    );

    // Broker permissions are project-scoped. Prefer the record belonging to
    // this project when the API returns the same broker more than once.
    const projectBroker = matchingBrokers.find((broker) => {
      const brokerProjectId =
        broker.ProjectID ??
        broker.ProjectId ??
        broker.projectId ??
        broker.ProjID ??
        broker.projId;
      return (
        projectId !== null &&
        projectId !== undefined &&
        brokerProjectId !== null &&
        brokerProjectId !== undefined &&
        String(brokerProjectId) === String(projectId)
      );
    });

    return projectBroker || matchingBrokers[0];
  };
  const getLineBrokerId = (lineItem = {}) =>
    lineItem.BrokerID ??
    lineItem.BrokerId ??
    lineItem.brokerId ??
    lineItem.UserID ??
    lineItem.userId;
  const getConsolidatedLineRateOptions = (index, brokerId) => {
    const lineItem = formik1.values.lineItems[index] || {};
    const project = getConsolidatedLineProject(index);
    return getLineDayRateOptions(
      findLineBroker(brokerId, project?.ProjID || project?.InvProjectID),
      project,
      lineItem.selectedDayRate
    );
  };
  const handleConsolidatedLineRateChange = (
    index,
    selection,
    projectOverride
  ) => {
    const lineItem = formik1.values.lineItems[index] || {};
    const project = projectOverride || getConsolidatedLineProject(index);
    const projectId =
      project.ProjID ||
      project.InvProjectID ||
      project.ProjectID ||
      project.projectId;
    const broker = findLineBroker(lineItem.brokerId, projectId);
    const projectHeaderRate = getProjectHeaderRate(
      project.ProjID || project.InvProjectID || project.ProjectID || project.projectId,
      project.PeriodKey || project.InvPeriodKey || project.periodKey
    );
    const resolved = resolveExistingLineItemDayRate(
      selection,
      { ...project, ...projectHeaderRate, ...broker },
      { ...project, ...projectHeaderRate },
      projectHeaderRate.dayRate ?? 0
    );
    formik1.setFieldValue(`lineItems[${index}]`, {
      ...lineItem,
      selectedDayRate: resolved.selectedDayRate,
      ...(resolved.selectedDayRate === "Billable Rate"
        ? { dayRate: formatPopulatedDayRate(resolved.dayRate) }
        : {}),
    });
  };

  const handleExistingConsolidatedLineRateChange = (
    invoiceDetailsId,
    selection,
    projectId,
    periodKey,
    lineItem
  ) => {
    const project = finalList.find(
      (item) =>
        String(item.ProjID || item.InvProjectID) === String(projectId) &&
        String(item.PeriodKey || item.InvPeriodKey) === String(periodKey)
    ) || finalList.find(
      (item) => String(item.ProjID || item.InvProjectID) === String(projectId)
    ) || {};
    const projectHeaderRate = getProjectHeaderRate(projectId, periodKey);
    const resolved = resolveExistingLineItemDayRate(
      selection,
      {
        ...lineItem,
        InvoiceDayRate: projectHeaderRate.dayRate,
        ...projectHeaderRate,
      },
      normalizeProjectRateData(project),
      lineItem?.DayRate ?? lineItem?.BillableDayRate ?? 0
    );
    setFinalList((previous) =>
      previous.map((item) => ({
        ...item,
        selectedperiod: Array.isArray(item.selectedperiod)
          ? item.selectedperiod.map((row) =>
              String(row.InvoiceDetailsID) === String(invoiceDetailsId)
                ? {
                    ...row,
                    selectedDayRate: resolved.selectedDayRate,
                    InvSelectedDayRate: resolved.selectedDayRate,
                    ...getSelectedRateFields(resolved.selectedDayRate, resolved.dayRate),
                    ...(resolved.selectedDayRate === "Billable Rate"
                      ? { dayRate: resolved.dayRate, DayRate: resolved.dayRate }
                      : {}),
                  }
                : row
            )
          : item.selectedperiod,
      }))
    );
    // setLineList((previous) =>
    //   previous.map((row) =>
    //     String(row.InvoiceDetailsID) === String(invoiceDetailsId)
    //       ? {
    //           ...row,
    //           selectedDayRate: resolved.selectedDayRate,
    //           InvSelectedDayRate: resolved.selectedDayRate,
    //           ...getSelectedRateFields(resolved.selectedDayRate, resolved.dayRate),
    //           ...(resolved.selectedDayRate === "Billable Rate"
    //             ? { dayRate: resolved.dayRate, DayRate: resolved.dayRate }
    //             : {}),
    //         }
    //       : row
    //   )
    // );

    // Only the displayed rows change here. lineList holds the saved lines;
    // updating it re-runs the lineList effect, which refetches statements and
    // upserts the invoice. The change is saved with the line's Save button.

    const initialSelection = getPersistedSelectedDayRate(
      lineList.find(
        (row) => String(row.InvoiceDetailsID) === String(invoiceDetailsId)
      )
    );
    setChangedFields((previous) => {
      const next = { ...previous };
      const isChanged =
        normalizeSelectedDayRate(resolved.selectedDayRate) !==
        normalizeSelectedDayRate(initialSelection);

      if (isChanged) {
        next[invoiceDetailsId] = {
          ...next[invoiceDetailsId],
          SelectedDayRate: true,
        };
      } else if (next[invoiceDetailsId]) {
        const fields = { ...next[invoiceDetailsId] };
        delete fields.SelectedDayRate;
        if (Object.keys(fields).length > 0) {
          next[invoiceDetailsId] = fields;
        } else {
          delete next[invoiceDetailsId];
        }
      }

      return next;
    });
  };

  const formik1 = useFormik({
    initialValues: {
      lineItems: consolidatedInvoiceDetails.map(() => ({ ...initialLineItem })),
    },
    enableReinitialize: true,
    validationSchema: validationSchemaFormNew, // Use the validation schema here
    onSubmit: (values) => {
      upsertInvoiceDetailsFun(values); // Function to handle form submission
      // setSubmitting(falseupsertInvoiceDetailsFun);
    },
  });

  console.log(formik1.values?.lineItems, "formik111111111111111111");
  const formik2 = useFormik({
    initialValues: initialArrayOfLines,
    enableReinitialize: true,
    // validationSchema: validationSchemaForm1,
    onSubmit: (values) => {},
  });
  const validateLineItem = async (key, index) => {
    const lineItemPath = `${key}[${index}]`;
    const lineItemValues = formik1.values[key][index];

    try {
      await lineItemValidationSchema.validate(lineItemValues, {
        abortEarly: false,
      });
      const newErrors = { ...errors };
      if (newErrors[key]) {
        newErrors[key].splice(index, 1);
        if (newErrors[key].length === 0) {
          delete newErrors[key];
        }
      }
      formik1.setErrors(newErrors);
      return true;
    } catch (validationErrors) {
      if (validationErrors.inner) {
        const newErrors = { ...errors };
        if (!newErrors[key]) {
          newErrors[key] = [];
        }
        newErrors[key][index] = validationErrors.inner.reduce((acc, error) => {
          acc[error.path.split(".").pop()] = error.message;
          return acc;
        }, {});
        formik1.setErrors(newErrors);

        // Mark fields as touched
        const newTouched = { ...touched };
        if (!newTouched[key]) {
          newTouched[key] = [];
        }
        newTouched[key][index] = validationErrors.inner.reduce((acc, error) => {
          acc[error.path.split(".").pop()] = true;
          return acc;
        }, {});
        formik1.setTouched(newTouched);
      }
      return false;
    }
  };
  useEffect(() => {
    dispatch(getAlluserList());
  }, []);

  useEffect(() => {
    if (consolidatedInvoiceDetails && consolidatedInvoiceDetails.length > 0) {
      const newLineItems = consolidatedInvoiceDetails
        .filter(Boolean)
        .map((project) => {
          const dayRate = getProjectBillableDayRate(project);
          return {
            ...initialLineItem,
            dayRate: formatPopulatedDayRate(dayRate),
            InvoiceDayRate: dayRate,
          };
        });
      formik1.setValues({ lineItems: newLineItems });
      formik1.setErrors({});
    }
  }, [
    consolidatedInvoiceDetails,
    oldMileageRateDayRateByProject,
    projectDetailsValue,
  ]);

  useEffect(() => {
     if (shouldUpsert) {
    upsertForTotalInsert();
    setShouldUpsert(false);
  }
  }, [finalList, shouldUpsert]);

    // Invoice total from the lines on screen: mileage + lodging, copies and misc
  // + per diem + broker charges at each line's selected day rate.
  const getConsolidatedInvoiceTotal = (list = []) => {
    const savedLines = (item) =>
      (item.selectedperiod || []).filter((period) => period.InvoiceDetailsID);

    let totalMilesVal = 0;
    let totalMilesFin = 0;
    list.forEach((detail) => {
      const totalMiles = savedLines(detail).reduce(
        (sum, period) => sum + (period.Miles ? period.Miles : 0),
        0
      );
      const matchedMileageRateDayRateObj = previousMileageRateDayRateByProject.find(
        (row) => row.projectId == detail.ProjID
      );
      totalMilesVal += matchedMileageRateDayRateObj?.mileageRate * totalMiles;
      totalMilesFin +=
        (detail.MatchedMileageRate ? detail.MatchedMileageRate : 0) * totalMiles;
    });

    const totalExpensesVal = list.reduce(
      (acc, item) =>
        acc +
        savedLines(item).reduce(
          (sum, period) =>
            sum +
            ((period.Lodging ? parseFloat(period.Lodging) : 0) +
              (period.Copies ? parseFloat(period.Copies) : 0) +
              (period.Misc ? parseFloat(period.Misc) : 0)),
          0
        ),
      0
    );
    const totalPerdiemVal = list.reduce(
      (acc, item) =>
        acc +
        savedLines(item).reduce(
          (sum, period) => parseFloat(sum) + parseFloat(period.PerDiem),
          0
        ),
      0
    );
    const totalChargeVal = list.reduce(
      (acc, item) => acc + getProjectChargeTotal(item),
      0
    );

    return (
      (parseFloat(totalMilesFin ? totalMilesFin : totalMilesVal) || 0) +
      (parseFloat(totalExpensesVal) || 0) +
      (parseFloat(totalPerdiemVal) || 0) +
      (parseFloat(totalChargeVal) || 0)
    ).toFixed(2);
  };

  // Keep the displayed total in step with local edits (such as a line's day
  // rate) before they are saved, as the single invoice form does.
  useEffect(() => {
    if (selectedPeriodList?.length > 0 && values.CustomerID) {
      setInvoiceGrandTotalVal(getConsolidatedInvoiceTotal(finalList));
    }
  }, [
    finalList,
    previousMileageRateDayRateByProject,
    oldMileageRateDayRateByProject,
    projectDetailsValue,
    selectedPeriodList,
    values.CustomerID,
  ]);

  const upsertForTotalInsert = async (type) => {
    if (
      selectedPeriodList &&
      selectedPeriodList.length > 0 &&
      values.CustomerID
    ) {
      var grandMDTotalVlaue = 0;
      var totalMilesVal = 0;
      var totalMilesCount = 0;
      var totalLodgingCount = 0;
      var totalCopiesCount = 0;
      var totalMiscCount = 0;
      var totalHoursCount = 0;

      console.log(finalList, "finalListfinalListfinalList");
      console.log(dayjs(values.invoiceDate).format("MM/DD/YYYY"), 'finalListfinalListfiInvoiceDatenalList',
        dayjs(values.createDate, "MM/DD/YYYY"),);

      finalList.forEach((detail) => {
        const matchedMileageRateDayRateObj =
          previousMileageRateDayRateByProject.find(
            (row) => row.projectId == detail.ProjID
          );
        const totalMiles = detail.selectedperiod
          .filter((period) => period.InvoiceDetailsID)
          .reduce((sum, period) => {
            return sum + (period.Miles ? period.Miles : 0);
          }, 0);

        // console.log(
        //   "totalMilestotalMilesNEW",
        //   totalMiles,
        //   matchedMileageRateDayRateObj.mileageRate
        // );
        const value = matchedMileageRateDayRateObj?.mileageRate * totalMiles;
        totalMilesVal += value;
        totalMilesCount += totalMiles;
      });

      const totalExpensesVal = finalList.reduce((acc, item) => {
        // Calculate total expenses for each item by summing Lodging, Copies, and Misc from selectedPeriod
        const totalItemExpenses = item.selectedperiod
          .filter((period) => period.InvoiceDetailsID)
          .reduce((sum, period) => {
            totalLodgingCount += period.Lodging;
            totalCopiesCount += period.Copies;
            totalMiscCount += period.Misc;
            totalHoursCount += period.Hours;
            console.log(period.Hours, "periodhouessssssssssss", period);
            return (
              (sum ? sum : 0) +
              ((period.Lodging ? parseFloat(period.Lodging) : 0) +
                (period.Copies ? parseFloat(period.Copies) : 0) +
                (period.Misc ? parseFloat(period.Misc) : 0))
            );
          }, 0);

        // Add the totalItemExpenses to the overall total
        return acc + totalItemExpenses;
      }, 0);
      console.log(totalHoursCount, "totalHoursCounttotalHoursCount");

      const totalPerdiemVal = finalList.reduce((acc, item) => {
        const totalItempers = item.selectedperiod
          .filter((period) => period.InvoiceDetailsID)
          .reduce(
            (sum, period) => parseFloat(sum) + parseFloat(period.PerDiem),
            0
          );
        return acc + totalItempers;
      }, 0);

      var totalMilesFin = 0;

      finalList.forEach((detail) => {
        const MileageRate = detail.MatchedMileageRate
          ? detail.MatchedMileageRate
          : 0;

        const totalMiles = detail.selectedperiod
          .filter((period) => period.InvoiceDetailsID)
          .reduce((sum, period) => {
            return sum + (period.Miles ? period.Miles : 0);
          }, 0);

        console.log("totalMilestotalMiles", MileageRate, totalMiles);

        const value = MileageRate * totalMiles;
        totalMilesFin += value;
      });

      const totalChargeVal = finalList.reduce((acc, item) => {
        return acc + getProjectChargeTotal(item);
      }, 0);

      // grandMDTotalVlaue = (
      //   (parseFloat(totalMilesFin ? totalMilesFin : totalMilesVal) || 0) +
      //   (parseFloat(totalExpensesVal) || 0) +
      //   (parseFloat(totalPerdiemVal) || 0) +
      //   (parseFloat(totalChargeVal) || 0)
      // ).toFixed(2);

      grandMDTotalVlaue = getConsolidatedInvoiceTotal(finalList);

      console.log(
        grandMDTotalVlaue,
        "invoiceGrandTotalValinvoiceGrandTotalVal"
      );
      console.log(
        parseFloat(totalMilesVal) || 0,
        parseFloat(totalMilesFin) || 0,
        parseFloat(totalExpensesVal) || 0,
        parseFloat(totalPerdiemVal) || 0,
        "invoiceGrandTotalValinvoiceGrandTotalVal",
        parseFloat(totalChargeVal) || 0,
        totalChargeVal
      );
      setInvoiceGrandTotalVal(grandMDTotalVlaue);
      console.log(
        dayjs(values.invoiceDate).format("MM/DD/YYYY"),
        'dayjs(values.invoiceDate).format("MM/DD/YYYY")'
      );

      const data = {
        invoiceId: values?.invoiceNo,
        customerId: values.CustomerID,
        periodKey:
          selectedPeriodList &&
          selectedPeriodList[0] &&
          selectedPeriodList[0].PeriodKey
            ? selectedPeriodList[0].PeriodKey
            : null,
        projectId:
          selectedPeriodList &&
          selectedPeriodList[0] &&
          selectedPeriodList[0].ProjID
            ? selectedPeriodList[0].ProjID
            : null,
        userId: getLogUserId(),
        statusId: values.InvoiceStatusID,
        billingStart: null,
        billingEnd: null,
        invoiceDate: dayjs.utc(values.invoiceDate).format("MM/DD/YYYY"),
        createDate: dayjs(values.createDate, "MM/DD/YYYY"),
        billToStreet1: values.street1 || "",
        billToStreet2: values.street2 || "",
        billToCity: values.city || "",
        billToState: values.state || "",
        billToZip: values.zipcode,
        brokerCount: values.InvoiceBrokerCount,
        brokerHours: parseFloat(totalHoursCount).toFixed(2),
        dayRate: values.dayRate || '0.00',
        perDiem: parseFloat(totalPerdiemVal) || 0,
        lodging: parseFloat(totalLodgingCount).toFixed(2),
        miles: totalMilesCount,
        misc: parseFloat(totalMiscCount).toFixed(2),
        copies: parseFloat(totalCopiesCount).toFixed(2),
        mileageRate: values.mileageRate || '0.000',
        invoiceTotal: parseFloat(grandMDTotalVlaue)?.toFixed(2),
        headerIds: null,
        isConsolidated: true,
      };

      const config = {
        method: "POST",
        headers: authHeader(),
        url: UPSERT_INVOICE_STATEMENT_URL,
        data: {
          webString: enCryptFun(JSON.stringify(data)),
        },
      };

      try {
        const response = await API(config);

        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status === "Success") {
          const preVDate = moment.utc(periousInvoiceDate).format("MM/DD/YYYY");
          const updatedDate = moment
            .utc(values?.invoiceDate)
            .format("MM/DD/YYYY");
          console.log(preVDate, "preVDatevpreVDate", updatedDate);
          if (type === "InvoiceDate") {
            showToast("Invoice date updated successfully", "success");
            // getInvoiceDetails()
          }
        }
      } catch (error) {}
    }
  };

  const deleteLineItemFromAPI = async (
    id,
    lineItemKey,
    index,
    ProjID,
    attachDettachPeriodKey
  ) => {
    let data = {
      invoiceDetailId: id,
      projectId: ProjID,
      isConsolidate: 1,
    };
    const config = {
      method: "DELETE",
      url: DELETE_INVOICE_LINE_ITEM_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        setLineItemArr((prevValues) => ({
          ...prevValues,
          [lineItemKey]: prevValues[lineItemKey]?.filter((_, i) => i !== index),
        }));

        // getBillStatementDetails();
        // upsertLog("remove");

        showToast(parsedResponse?.message, "success");
        getInvoiceDetails("attach-dettach", ProjID, attachDettachPeriodKey);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v.message == "This invoice is closed and cannot be edited.") {
          showToast(v.message, "error");
          getInvoiceDetails();
        } else {
          showToast(v.message, "error");
        }
      }
    }
  };
  const handleSaveItem = async (key, index, itemid) => {
    const isValid = await validateLineItem(key, index);
    if (isValid) {
      // If valid, you can proceed with submission logic for the specific item or the whole form
      handleAddItem(key);
      // upsertBillingDetailsFun(formik1.values); // Uncomment this if you want to submit the form
    } else {
    }
  };
  const handleAddItem = (lineItemKey) => {
    const currentItems = LineItemArr[lineItemKey];
    if (currentItems) {
      const lastDate = currentItems[currentItems.length - 1].date;
      setLineItemArr((prevValues) => ({
        ...prevValues,
        [lineItemKey]: [
          ...prevValues[lineItemKey],
          {
            billingType: 0,
          dayRate: "",
          selectedDayRate: "Billable Rate",
            hours: "0.00",
            miles: "0",
            lodging: "0.00",
            description: "",
            perdiemRate: "$0.00",
            perDiem: "0.00",
            copies: "0.00",
            misc: "0.00",
            date: lastDate,
          },
        ],
      }));
    } else {
      setLineItemArr((prevValues) => ({
        ...prevValues,
        [lineItemKey]: [
          {
            billingType: 0,
            dayRate: "",
            selectedDayRate: "Billable Rate",
            hours: "0.00",
            miles: "0",
            lodging: "0.00",
            description: "",
            perdiemRate: "$0.00",
            perDiem: "0.00",
            copies: "0.00",
            misc: "0.00",
            date: moment(new Date()).format("MM/DD/YYYY"),
          },
        ],
      }));
    }
  };

  const updateInvoiceStatus = async (id, status, type) => {
    let data = {
      invoiceId: id,
      statusId: status,
      isDelete: type == "true" ? 1 : 0,
    };
    const config = {
      method: "PUT",
      url: UPDATE_INVOICE_STATUS_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        if (type == "true") {
          showToast(parsedResponse.message, "success");
          navigate(INVOICE_LIST);
        } else {
          showToast(
            `Invoice ${values.invoiceNo} for customer '${values?.CustomerName}' has been successfully closed.`,
            "success"
          );
          showToast(
            "This invoice has been closed and can no longer be edited.",
            "reopenInvoice"
          );
        }
        // getInvoiceAttachmentsList();
        setCloseingInvoice(false);
        getInvoiceDetails();
        if (type != "true") {
          updateHeaderDetails("false");
        }
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v.message == "This invoice is closed and cannot be edited.") {
          showToast(v.message, "error");
          getInvoiceDetails();
        } else {
          showToast(v.message, "error");
        }
      }
    }
  };
  const handleInvoiceStatus = () => {
    const allAttachedFalse = selectedPeriodList.every(
      (item) => item.IsAttached === false || item.IsAttached === 0
    );
    console.log(
      selectedPeriodList,
      "lineLsssssssssssss",
      lineList,
      finalList,
      allAttachedFalse
    );

    if (
      (InvoiceTotalValue == 0 || InvoiceTotalValue == "0.00") &&
      // finalList?.length == 0 &&
      allAttachedFalse
    ) {
      setDeletedInvoicePopup(true);
    } else if (
      addressvaluesChanged ||
      Object.keys(changedFields).length > 0 ||
      addlineItemValue ||
      dateFormatError !== "" ||
      hasUnsavedDayRate
    ) {
      setShowWarningpopup(true);
      setCloseBillingAlert(true);
    } else {
      // const newCompleted = completed;
      // newCompleted[activeStep] = true;
      // setCompleted(newCompleted);
      // setActiveStep(3);
      // setInvoiceStatus(true);
      setCloseingInvoice(true);
      //updateInvoiceStatus(invoiceid, 4);
    }
    setIsAttachDetachLoadedBilling(false);
    setIsAttachDetachLoaded(false);
  };

  const handleClosingInvoiceYesClick = () => {
    updateInvoiceStatus(invoiceid, 4);
  };

  const handleClosingInvoiceNoClick = () => {
    setCloseingInvoice(false);
  };

  const handleDownload = async (attachmentFileObject, brokerDetails) => {
    console.log(attachmentFileObject, "gggggggggggggggg", brokerDetails);
    setDownloadLoading(true);
    const zip = new JSZip();
    const folder = zip.folder();

    try {
      // Fetch images and add them to the zip
      const fetchPromises = attachmentFileObject.map(async (photo, index) => {
        setDownloadLoading(true);
        try {
          const response = await fetch(photo.Path);
          if (!response.ok) {
            throw new Error(
              `Failed to fetch ${photo.Path}. Status: ${response.status}, Status Text: ${response.statusText}`
            );
          }

          const blob = await response.blob();
          let fileName = photo.FileName;

          // Check for duplicate filenames
          let duplicateCount = 0;
          const originalFileName = fileName;

          // Ensure uniqueness by appending an index if a duplicate exists
          while (folder.files[`${fileName}`]) {
            duplicateCount += 1;
            const lastDotIndex = originalFileName.lastIndexOf(".");
            const nameWithoutExt = originalFileName.substring(0, lastDotIndex);
            const ext = originalFileName.substring(lastDotIndex); // Includes the dot
            fileName = `${nameWithoutExt} (${duplicateCount})${ext}`;
          }

          // Add file to the zip with the unique file name
          folder.file(fileName, blob);
        } catch (error) {
          console.error(`Error fetching ${photo.Path}:`, error);
        }
      });

      // Wait for all fetch promises to resolve
      await Promise.all(fetchPromises);

      // Generate the zip file and save it
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(
        zipBlob,
        `${brokerDetails.ProjectName}_${"attachments"}_${
          brokerDetails.PeriodKey
        }.zip`
      );
    } catch (error) {
      console.error("Error generating or saving zip file:", error);
    } finally {
      setDownloadLoading(false);
    }
  };

  const getDayAndMileageRateRecentData = async () => {
    let data = {
      invoiceId: invoiceid,
    };

    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_DAY_AND_MILEAGE_RATE_URL,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        var uniqueProjectsMillageAndDayRate = [];

        if (
          parsedResponse.invoiceData &&
          parsedResponse.invoiceData.length > 0
        ) {
          parsedResponse.invoiceData.map(function (project) {
            var found = uniqueProjectsMillageAndDayRate.find(function (p) {
              return (
                p.projectId === project.projectId &&
                p.periodKey === project.periodKey
              );
            });

            if (!found) {
              uniqueProjectsMillageAndDayRate.push({
                projectId: project.projectId ?? project.ProjectID,
                periodKey: project.periodKey ?? project.PeriodKey,
                dayRate: project.dayRate,
                mileageRate: project.mileageRate,
                selectedPrincipalRate:
                  project.selectedPrincipalRate ?? project.SelectedPrincipalRate,
                selectedProjectManagerRate:
                  project.selectedProjectManagerRate ??
                  project.SelectedProjectManagerRate,
                selectedFieldAgentRate:
                  project.selectedFieldAgentRate ?? project.SelectedFieldAgentRate,
                SelectedPrincipalRate: project.SelectedPrincipalRate,
                SelectedProjectManagerRate: project.SelectedProjectManagerRate,
                SelectedFieldAgentRate: project.SelectedFieldAgentRate,
                principalRate: project.principalRate ?? project.PrincipalRate,
                PrincipalRate: project.PrincipalRate ?? project.principalRate,
                projectManagerRate:
                  project.projectManagerRate ?? project.ProjectManagerRate,
                ProjectManagerRate:
                  project.ProjectManagerRate ?? project.projectManagerRate,
                fieldAgentRate: project.fieldAgentRate ?? project.FieldAgentRate,
                FieldAgentRate: project.FieldAgentRate ?? project.fieldAgentRate,
                selectedDayRate: normalizeSelectedDayRate(
                  project.selectedDayRate || project.SelectedDayRate
                ),
              });
            }
          });
          return uniqueProjectsMillageAndDayRate;
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getDayAndMileageRate = async () => {
    let data = {
      invoiceId: invoiceid,
    };
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_DAY_AND_MILEAGE_RATE_URL,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        var uniqueProjectsMillageAndDayRate = [];
        if (
          parsedResponse.invoiceData &&
          parsedResponse.invoiceData.length > 0
        ) {
          parsedResponse.invoiceData.map(function (project) {
            var found = uniqueProjectsMillageAndDayRate.find(function (p) {
              return (
                p.projectId === project.projectId &&
                p.periodKey === project.periodKey
              );
            });

            if (!found) {
              uniqueProjectsMillageAndDayRate.push({
                projectId: project.projectId ?? project.ProjectID,
                periodKey: project?.periodKey ?? project?.PeriodKey,
                dayRate: parseFloat(project.dayRate)?.toFixed(2),
                mileageRate: parseFloat(project.mileageRate)?.toFixed(3),
                selectedPrincipalRate:
                  project.selectedPrincipalRate ?? project.SelectedPrincipalRate,
                selectedProjectManagerRate:
                  project.selectedProjectManagerRate ??
                  project.SelectedProjectManagerRate,
                selectedFieldAgentRate:
                  project.selectedFieldAgentRate ?? project.SelectedFieldAgentRate,
                SelectedPrincipalRate: project.SelectedPrincipalRate,
                SelectedProjectManagerRate: project.SelectedProjectManagerRate,
                SelectedFieldAgentRate: project.SelectedFieldAgentRate,
                principalRate: project.principalRate ?? project.PrincipalRate,
                PrincipalRate: project.PrincipalRate ?? project.principalRate,
                projectManagerRate:
                  project.projectManagerRate ?? project.ProjectManagerRate,
                ProjectManagerRate:
                  project.ProjectManagerRate ?? project.projectManagerRate,
                fieldAgentRate: project.fieldAgentRate ?? project.FieldAgentRate,
                FieldAgentRate: project.FieldAgentRate ?? project.fieldAgentRate,
                selectedDayRate: normalizeSelectedDayRate(
                  project.selectedDayRate || project.SelectedDayRate
                ),
              });
            }
          });
          setPreviousMileageRateDayRateByProject(
            uniqueProjectsMillageAndDayRate
          );
          setOldMileageRateDayRateByProject(uniqueProjectsMillageAndDayRate);
        }

        const { dayRate, mileageRate } = parsedResponse.invoiceData[0];
        // setValues({...values,dayRate:dayRate,mileagRate:mileageRate})
        setDetails(parsedResponse.invoiceData);
        setPreviousMileageRate(mileageRate);
        setCurrentMileageRate(mileageRate);
        setPreviousDayRate(dayRate);
        setCurrentDayRate(dayRate);
        finalList =
          finalList &&
          finalList.length > 0 &&
          finalList.map((item) => {
            // Find the matching item in parsedResponse.invoiceData by projectId
            const invoice =
              uniqueProjectsMillageAndDayRate &&
              uniqueProjectsMillageAndDayRate.find(
                (invoice) =>
              String(invoice.projectId) === String(item.ProjID || item.InvProjectID) &&
              String(invoice.periodKey) === String(item.PeriodKey || item.InvPeriodKey)
              );
            // If a matching invoice is found, update the BillableDayRate
            if (invoice) {
              item.BillableDayRate = invoice.dayRate;
              item.MileageRate = invoice.mileageRate;
              item.selectedDayRate = normalizeSelectedDayRate(
                invoice.selectedDayRate
              );
            }

            return item;
          });
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getInvoiceAttachmentsList = async (InvoiceStatusID) => {
    if (!isAttachDetachLoadedBilling) {
      let data = {
        invoiceId: invoiceid,
      };
      const config = {
        method: "GET",
        headers: authHeader(),
        url: GET_ATTACH_URL,
        params: {
          webString: enCryptFun(JSON.stringify(data)),
        },
      };
      try {
        const response = await API(config);
        let decryptedResponse = deCryptFun(response.data);
        console.log("Decrypted Response: ", decryptedResponse); // Debugging the response

        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status === "Success") {
          if (
            parsedResponse.data &&
            Array.isArray(parsedResponse.data) &&
            parsedResponse.data.length > 0
          ) {
            var billingStatementDetailArray = parsedResponse.data;

            if (
              InvoiceStatusID === 3 ||
              (!InvoiceStatusID && invoiceStatusIDVal === 3)
            ) {
              setSelectedPeriodList(billingStatementDetailArray);
            } else {
              const filteredData = billingStatementDetailArray.filter(
                (item) => item.StatusID !== 1 && item.StatusID !== 2
              );
              console.log("Filtered Data: ", filteredData); // Check filtered results
              setSelectedPeriodList(filteredData);
            }
          } else {
            setSelectedPeriodList([]);
          }
        } else {
          console.error("Response status not successful");
        }
      } catch (error) {
        console.log(error);
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          // showToast(v.message, "error");
        }
      } finally {
        setIsAttachDetachLoadedBilling(true);
        setIsAttachDetachLoaded(false);
      }
    }
  };

  const getAttachNewStatementInvoice = async (adminBillingStatementDetail) => {
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_ATTACH_NEW_STATEMENT_INVOICE_URL,
      params: {
        webString: enCryptFun(JSON.stringify(adminBillingStatementDetail)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (
        parsedResponse.status === "Success" &&
        parsedResponse.data.length > 0
      ) {
        const filteredData = parsedResponse.data.filter(
          (item) => item.StatusID != 3
        );
        return filteredData;
      }
    } catch (error) {}
  };

  useEffect(() => {
    const fetchInvoiceData = async () => {
      try {
        const adminBillingStatementDetail = consolidatedInvoiceDetails
          .filter(Boolean)
          .map((item) => ({
            projectId: item.projectId,
            periodKey: item.periodKey,
          }));

        const promises = adminBillingStatementDetail.map(
          async (adminBillingStatementDetailData) => {
            const getAttachNewStatementInvoiceResp =
              await getAttachNewStatementInvoice(
                adminBillingStatementDetailData
              );

            if (
              getAttachNewStatementInvoiceResp &&
              getAttachNewStatementInvoiceResp.length > 0
            ) {
              const newEntries = getAttachNewStatementInvoiceResp
                .filter(
                  (newEntry) =>
                    !selectedPeriodList.some(
                      (existingEntry) =>
                        existingEntry.BillingHeaderID ===
                          newEntry.statementId &&
                        existingEntry.ProjID === newEntry.ProjID &&
                        existingEntry.PeriodKey === newEntry.PeriodKey
                    )
                )
                .map((newEntry) => ({
                  AttachedID: null,
                  InvoiceId: null,
                  BillingHeaderID: newEntry.statementId,
                  IsAttached: newEntry.isAttached,
                  ProjectName: newEntry.ProjectName,
                  customerId: null,
                  BrokerName: newEntry.BrokerName,
                  BrokerID: null,
                  ID: null,
                  PeriodKey: newEntry.PeriodKey,
                  UserID: newEntry.UserID,
                  ProjID: newEntry.ProjID,
                  StatusID: newEntry.StatusID,
                  BillingStart: newEntry.BillingStart,
                  BillingEnd: newEntry.BillingEnd,
                  Hours: newEntry.Hours,
                  Total: newEntry.Total,
                  LastModified: newEntry.LastModified,
                  IsOrphaned: false,
                }));

              return newEntries;
            }
            return [];
          }
        );

        const newEntriesList = await Promise.all(promises);
        const flattenedNewEntries = newEntriesList.flat();

        // Use functional update to ensure proper merging with previous state
        setSelectedPeriodList((prevList) => {
          const uniqueEntries = new Set(
            prevList.map(
              (entry) =>
                `${entry.BillingHeaderID}-${entry.ProjID}-${entry.PeriodKey}`
            )
          );

          const newFilteredEntries = flattenedNewEntries.filter(
            (entry) =>
              !uniqueEntries.has(
                `${entry.BillingHeaderID}-${entry.ProjID}-${entry.PeriodKey}`
              )
          );

          return [...prevList, ...newFilteredEntries];
        });
      } catch (error) {
        console.error("Error fetching invoice data:", error);
      }
    };

    if (invoiceStatusIDVal === 3 && !isAttachDetachLoaded) {
      setAttachDettachLoading(true);
      setIsAttachDetachLoaded(true); // Prevent multiple calls by flagging it
      fetchInvoiceData();

      setTimeout(() => {
      setAttachDettachLoading(false);
      }, 7000);
    }

    console.log(
      "selectedPeriodListFLEXTest",
      selectedPeriodList,
      invoiceStatusIDVal,
      isAttachDetachLoaded
    );
  }, [
    invoiceStatusIDVal,
    isAttachDetachLoaded,
    consolidatedInvoiceDetails,
    selectedPeriodList,
  ]);

  // Added invoiceStatusIDVal to dependencies

  const getInvoiceAttachments = async (
    projid,
    userid,
    periodk,
    type,
    brokerDetails
  ) => {
    let data = {
      projectId: projid,
      type: 2,
      userId: userid,
      periodKey: periodk,
      billingStatementId: brokerDetails.BillingHeaderID,
      parentTypeId: 1,
    };
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_ATTACHMENT_BY_BILLING_PROJECT_ID_URL,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        const { Path, attachmentId } = parsedResponse.data[0];
        setAttachmentId(attachmentId);
        handleDownload(parsedResponse.data, brokerDetails);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast("Attachment not found", "error");
      }
    } finally {
    }
  };
  const getInvoiceSelectedPeriod = async (projectId, periodKeySel) => {
    let data = {
      projectId: projectId,
      periodKey: periodKeySel,
    };
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_INVOICE_SELECTED_PERIOD_URL,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        // setSelectedPeriodList(parsedResponse.billingStatementDetails);
        return parsedResponse.billingStatementDetails;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getBillingStatementByID = async (headerId) => {
    let data = {
      headerId: headerId,
    };
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_BILLING_STATEMENT_DETAILS_BY_ID_URL,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        // setSelectedPeriodList(parsedResponse.billingStatementDetails);
        return parsedResponse.billingStatementDetails;
      }
    } catch (error) {
      console.log(error);
    }
  };
  const parsePeriodKey = (periodKey) => {
    // Extract the start and end dates from the period key
    const startDateStr = periodKey?.substring(0, 8);
    const endDateStr = periodKey?.substring(8, 16);

    // Parse the dates using Moment.js
    const startDate = moment
      .utc(startDateStr, "MMDDYYYY", true)
      .format("MM/DD/YYYY");
    const endDate = moment
      .utc(endDateStr, "MMDDYYYY", true)
      .format("MM/DD/YYYY");

    console.log(startDate, startDateStr, "dtaratatat", endDate, endDateStr);
    return { startDate, endDate };
  };
  const getInvoiceDetails = async (
    type,
    ProjId12,
    PeriodKey12,
    attchedValue
  ) => {
    const requestId = ++invoiceLoadRef.current;
    invoiceDetailsLoadedRef.current = false;
    setLoading(true);
    let data = {
      invoiceId: invoiceid,
    };
    console.log(type, "typetypetype");
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_INVOICE_DETAILS_BY_ID,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);

      if (requestId !== invoiceLoadRef.current) return;

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        const {
          BillingType,
          BrokerID,
          Copies,
          Date,
          Description,
          Hours,
          InvoiceBillToCity,
          InvoiceBillToState,
          InvoiceBillToStreet2,
          InvoiceBillToStreet1,
          InvoiceBillToZip,
          InvoiceBillingEnd,
          InvoiceBillingStart,
          InvoiceBrokerCount,
          InvoiceBrokerHours,
          InvoiceCopies,
          InvoiceCreateDate,
          InvoiceCustomerID,
          InvoiceDate,
          InvoiceDetailsID,
          InvoiceHeaderID,
          InvoiceLodging,
          InvoiceMileageRate,
          InvoiceMiles,
          InvoiceMisc,
          InvoicePerDiem,
          // InvoicePeriodKey,
          // InvoiceProjectID,
          InvoiceStatusID,
          InvoiceTotal,
          IsConsolidate,
          LastModified,
          Lodging,
          Miles,
          Misc,
          CustomerName,
          CustomerFirstName,
          CustomerLastName,
          CustomerMobilePhone,
          CustomerOfficePhone,
          PerDiem,
          invoiceId,
          invoiceDetails,
          ConsolidatedInvoiceDetails,
        } = parsedResponse.invoiceData[0];
        console.log(
          ConsolidatedInvoiceDetails === null &&
            currentPathSegment === "invoice-form",
          "ConsolidatedInvoiceDetailsiiiiii"
        );

        console.log(InvoiceCustomerID, "parsedResponseinvoiceDataNEWW");

        if (
          ConsolidatedInvoiceDetails === null &&
          currentPathSegment === "consolidated-invoice-form"
        ) {
          // window.location.reload()
          navigate(`/invoice-form/${invoiceid}`, { replace: true });
          // getInvoiceDetails()
        } else {
          if (type == "View-Edit") {
            setOpenAttachmentFilter(!openAttachmentFilter);
          }
          // else if (type == "View-Edit" && InvoiceStatusID == 4) {
          //   showToast("This invoice is closed and cannot be edited.", "error");
          // }

          const AddressValues = {
            street1: InvoiceBillToStreet1,
            street2: InvoiceBillToStreet2,
            city: InvoiceBillToCity,
            state: InvoiceBillToState ? InvoiceBillToState : 1,
            zipcode: InvoiceBillToZip,
          };
          setUpdateAddressValues(AddressValues);

          const dayAndMileageRateResponse =
            await getDayAndMileageRateRecentData();

          if (requestId !== invoiceLoadRef.current) return;

          console.log("dayAndMileageRateResponse", dayAndMileageRateResponse);

          if (InvoiceStatusID == 3) {
            setInvoiceStatus(false);
          } else if (InvoiceStatusID == 4) {
            setInvoiceStatus(true);
            setActiveStep(3);
          }
          //setInvoiceGrandTotalVal(InvoiceTotal)
          setInvoiceStatusIDVal(InvoiceStatusID);

          let invoiceDetailsVal =
            invoiceDetails != null ? JSON.parse(invoiceDetails) : [];
          let consolidatedInvoiceDetailsVal =
            ConsolidatedInvoiceDetails != null
              ? JSON.parse(ConsolidatedInvoiceDetails)
              : [];

          consolidatedInvoiceDetailsVal.forEach((invoice) => {
            const match =
              dayAndMileageRateResponse &&
              dayAndMileageRateResponse.find(
                (rate) =>
                  String(rate.projectId) ===
                    String(invoice.projectId || invoice.InvProjectID) &&
                  String(rate.periodKey) === String(invoice.periodKey || invoice.PeriodKey)
              );
            if (match) {
              // invoice.MatchedDayRate = match.dayRate;
              // invoice.MatchedMileageRate = match.mileageRate;
              invoice.MileageRate = match.mileageRate;
              invoice.BillingDayRate = match.dayRate;
              invoice.selectedDayRate = normalizeSelectedDayRate(
                match.selectedDayRate
              );
            }
          });
          invoiceDetailsVal.forEach((invoice) => {
            const match =
              dayAndMileageRateResponse &&
              dayAndMileageRateResponse.find(
                (rate) =>
                  String(rate.projectId) ===
                    String(invoice.ProjID || invoice.InvProjectID) &&
                  String(rate.periodKey) === String(invoice.PeriodKey || invoice.InvPeriodKey)
              );
            if (match) {
              // invoice.MatchedDayRate = match.dayRate;
              // invoice.MatchedMileageRate = match.mileageRate;
              invoice.MileageRate = match.mileageRate;
              invoice.BillableDayRate = match.dayRate;
              invoice.selectedDayRate = normalizeSelectedDayRate(
                invoice.selectedDayRate ??
                  invoice.SelectedDayRate ??
                  invoice.InvSelectedDayRate ??
                  match.selectedDayRate
              );
            }
          });

          var newLineItemData = invoiceDetailsVal ? invoiceDetailsVal : [];

          consolidatedInvoiceDetailsVal &&
            consolidatedInvoiceDetailsVal.forEach((detail) => {
              const exists =
                invoiceDetailsVal &&
                invoiceDetailsVal.some(
                  (item) => item.BillingHeaderID === detail.BillingStatementID
                );

              if (!exists) {
                const newLineItem = {
                  InvoiceDetailsID: 0,
                  InvoiceHeaderID: detail.invoiceId,
                  BillingHeaderID: detail.BillingStatementID
                    ? detail.BillingStatementID
                    : 0,
                  BillingDetailID: 0,
                  BrokerID: detail.userId,
                  Date: "",
                  BillingType: "",
                  Hours: 0,
                  Miles: 0,
                  Lodging: 0,
                  Copies: 0,
                  Misc: 0,
                  PerDiem: 0,
                  Description: "",
                  LastModified: "",
                  PerDiemRate: detail.PerDiem,
                  ProjectName: detail.ProjectName,
                  customerId: "",
                  ProjID: detail.projectId,
                  PeriodKey: detail.periodKey,
                  BrokerName: "",
                  MileageRate: detail.MileageRate,
                  BillableDayRate: detail.BillingDayRate,
                  selectedDayRate: normalizeSelectedDayRate(
                    detail.selectedDayRate
                  ),
                  BillableOfficePerDiem: detail.BillableOfficePerDiem,
                  BillableTravelPerDiem: detail.BillableTravelPerDiem,
                  newLineItemType: "New",
                };

                newLineItemData.push(newLineItem);
              }
            });
          const newLineItemData21 = invoiceDetailsVal.map((item) => ({
            ...item,
            // Keep the persisted line-level selection as the canonical value
            // used by the existing-line-item dropdown.
            selectedDayRate: normalizeSelectedDayRate(
              item.selectedDayRate ??
                item.SelectedDayRate ??
                item.InvSelectedDayRate
            ),
            Lodging: Number(item.Lodging ?? 0).toFixed(2),
            Copies: Number(item.Copies ?? 0).toFixed(2),
            // PerDiem: item.PerDiem.toFixed(2),
            Misc: Number(item.Misc ?? 0).toFixed(2),
            Hours: Number(item.Hours ?? 0).toFixed(2),
            BillableOfficePerDiem: Number(
              item.BillableOfficePerDiem ?? 0
            ).toFixed(2),
            BillableTravelPerDiem: Number(
              item.BillableTravelPerDiem ?? 0
            ).toFixed(2),
          }));
          console.log(newLineItemData21, "newLineItemDatanewLineItemData");
          setLineList(newLineItemData21);
          setInitialLineList(newLineItemData);
          // setLineList(invoiceDetailsVal);
          // setInitialLineList(invoiceDetailsVal);
          setConsolidatedInvoiceDetails(consolidatedInvoiceDetailsVal);

          // setLineList(invoiceDetails != null ? JSON.parse(invoiceDetails) : []);
          // setInitialLineList(
          //   invoiceDetails != null ? JSON.parse(invoiceDetails) : []
          // );
          // setConsolidatedInvoiceDetails(
          //   ConsolidatedInvoiceDetails != null
          //     ? JSON.parse(ConsolidatedInvoiceDetails)
          //     : []
          // );
          const {
            ProjID,
            InvoiceProjectID,
            PeriodKey,
            ProjectName,
            BrokerName,
            BillingHeaderID,
          } = invoiceDetails != null ? JSON.parse(invoiceDetails)[0] : [];

          const projectids = ConsolidatedInvoiceDetails
            ? JSON.parse(ConsolidatedInvoiceDetails)
            : [];
          const projectIdString = projectids
            .map((detail) => detail.projectId)
            .join(",");
          Promise.allSettled([
            getProjectsDetailsById(projectIdString),
            getInvoiceSelectedPeriod(ProjID, PeriodKey),
            getCustomersById(InvoiceCustomerID),
            getProjectsById(projectIdString),
          ]);
          if (invoiceDetails != null) {
            // The selected periods are fetched above with the other
            // invoice-scoped dependencies before the loader is released.
            // let attachListPromise =
            getInvoiceAttachmentsList(InvoiceStatusID);

            const { startDate, endDate } = parsePeriodKey(PeriodKey);
            formik2.setValues({
              ...formik2.values,
              billingType: BillingType,
            });
            const parseValue = JSON.parse(invoiceDetails);
            const perDiemSum = parseValue.reduce(
              (acc, item) => acc + item.PerDiem,
              0
            );
            const perLodgingSum = parseValue.reduce(
              (acc, item) => acc + item.Lodging,
              0
            );
            const perCopiesSum = parseValue.reduce(
              (acc, item) => acc + item.Copies,
              0
            );
            const perMiscSum = parseValue.reduce(
              (acc, item) => acc + item.Misc,
              0
            );
            const perMilesSum = parseValue.reduce(
              (acc, item) => acc + item.Miles,
              0
            );
            const perTotalHoursSum = parseValue.reduce(
              (acc, item) => acc + item.Hours,
              0
            );

            if (
              type == "attach-dettach" &&
              ProjId12 !== undefined &&
              ProjId12 !== null &&
              PeriodKey12 !== undefined &&
              PeriodKey12 !== null &&
              type != "mileageRate_save" &&
              type != "dayRate_save"
            ) {
              updateHeaderDetails(
                "false",
                grandTotal,
                ProjId12,
                PeriodKey12,
                attchedValue
              );
            }
            const invoiceDate = dayjs.utc(InvoiceDate); // Keep as dayjs object, no formatting yet
            const currentDate = dayjs.utc(); // Get current date, no formatting yet

            // Check if the invoice date is in the past
            const finalInvoiceDate = invoiceDate.format("MM/DD/YYYY");
            // invoiceDate.isBefore(currentDate)
            //   ? currentDate.format('MM/DD/YYYY') // Format only after comparison
            //   :
            // Format only after comparison

            console.log(
              InvoiceDate,
              "finalalaaaaaaaaaa",
              InvoiceDate,
              dayjs.utc(InvoiceCreateDate)
            );
            setInvoiceDate(InvoiceDate);
            setValues((prevValues) => ({
              ...prevValues,
              street1: InvoiceBillToStreet1,
              street2: InvoiceBillToStreet2,
              CustomerID: InvoiceCustomerID,
              city: InvoiceBillToCity,
              state: InvoiceBillToState ? InvoiceBillToState : 1,
              zipcode: InvoiceBillToZip,
              invoiceDate: InvoiceDate,
              createDate: InvoiceCreateDate
                ? dayjs.utc(InvoiceCreateDate)
                : dayjs.utc(),
              statusId: values?.InvoiceStatusID,
              invoiceNo: invoiceId,
              invoiceTotal: InvoiceTotal,
              projectName: ProjectName,
              startDate: startDate,
              endDate: endDate,
              brokerName: BrokerName,
              totalPerDiem: perDiemSum,
              totalMileage: InvoiceMileageRate,
              totalLodging: perLodgingSum,
              totalCopies: perCopiesSum,
              totalMisc: perMiscSum,
              totalHours: perTotalHoursSum,
              totalMiles: perMilesSum,
              CustomerName: CustomerName,
              BillingHeaderID: BillingHeaderID ? BillingHeaderID : 0,
              InvoiceStatusID: InvoiceStatusID,
              InvoiceBrokerCount: InvoiceBrokerCount,
              InvoiceBrokerHours: InvoiceBrokerHours,
              // BillingDetailID:BillingDetailID?BillingDetailID:0
              // BillableOfficePerDiem: BillableOfficePerDiem,
              // BillableTravelPerDiem: BillableTravelPerDiem,
              // BillableDayRate: BillableDayRate,
              // perDiemRate: perDiemRate,
              // dayRate: dayRate,
            }));
            // Customer/project data is fetched above before rendering.
          } else {
            const invoiceDate = dayjs.utc(InvoiceDate); // Keep as dayjs object, no formatting yet
            const currentDate = dayjs.utc(); // Get current date, no formatting yet

            // Check if the invoice date is in the past
            const finalInvoiceDate = invoiceDate.format("MM/DD/YYYY"); // Format only after comparison

            console.log(
              finalInvoiceDate,
              "finalalaaaaaaaaaa",
              InvoiceDate,
              dayjs.utc(InvoiceCreateDate)
            );
            setInvoiceDate(finalInvoiceDate);
            Promise.allSettled([
              getInvoiceAttachmentsList(InvoiceStatusID),
              getCustomersById(InvoiceCustomerID),
              getProjectsById(projectIdString),
            ]);
            setValues({
              ...values,
              street1: InvoiceBillToStreet1,
              street2: InvoiceBillToStreet2,
              CustomerID: InvoiceCustomerID,
              city: InvoiceBillToCity,
              state: InvoiceBillToState ? InvoiceBillToState : 1,
              zipcode: InvoiceBillToZip,
              invoiceDate: finalInvoiceDate,
              createDate: InvoiceCreateDate
                ? dayjs.utc(InvoiceCreateDate)
                : dayjs.utc(),
              invoiceNo: invoiceId,
              invoiceTotal: InvoiceTotal,
              projectName: ProjectName,
              brokerName: BrokerName,
              totalMileage: InvoiceMileageRate,
              CustomerName: CustomerName,
              InvoiceStatusID: InvoiceStatusID,
              statusId: values?.InvoiceStatusID,
              InvoiceBrokerCount: InvoiceBrokerCount,
            });
            // Customer/project data is fetched above before rendering.
          }
          invoiceDetailsLoadedRef.current = true;
          // getInvoiceSelectedPeriod(InvoiceProjectID, InvoicePeriodKey);
          // const { startDate, endDate } = parsePeriodKey(PeriodKey);
          // let selectListPromise = getInvoiceSelectedPeriod(
          //   InvoiceProjectID,
          //   PeriodKey
          // );
          // let attachListPromise = getInvoiceAttachmentsList();

          // let [selectList, attachList] = await Promise.all([
          //   selectListPromise,
          //   attachListPromise,
          // ]);
          // let selectPeriodList = [];
          // if (attachList && selectedPeriodList) {
          //   selectPeriodList = selectedPeriodList.map((item) => {
          //     const selectedPeriod = attachList.find(
          //       (period) => period.BillingHeaderID === item.BillingStatementID
          //     );
          //     if (selectedPeriod) {
          //       return {
          //         ...item,
          //         IsAttached: selectedPeriod.IsAttached,
          //         id: selectedPeriod.ID,
          //       };
          //     }
          //     return {
          //       ...item,
          //       IsAttached: "false",
          //       id: 0,
          //     };
          //   });
          // }
          // setSelectedPeriodList(selectPeriodList);
          // formik2.setValues({
          //   ...formik2.values,
          //   billingType: BillingType,
          // });
          // setValues({
          //   ...values,
          //   street1: InvoiceBillToStreet1,
          //   street2: InvoiceBillToSteet2,
          //   city: InvoiceBillToCity,
          //   state: InvoiceBillToState,
          //   zipcode: InvoiceBillToZip,
          //   invoiceDate: dayjs(InvoiceDate),
          //   createDate: dayjs(InvoiceCreateDate),
          //   invoiceNo: invoiceId,
          //   invoiceTotal: InvoiceTotal,
          //   projectName: ProjectName,
          //   startDate: startDate,
          //   endDate: endDate,
          //   brokerName: BrokerName,
          //   totalPerDiem: InvoicePerDiem,
          //   totalMileage: InvoiceMileageRate,
          //   totalLodging: InvoiceLodging,
          //   totalCopies: InvoiceCopies,
          //   totalMisc: InvoiceMisc,
          //   totalHours: InvoiceBrokerHours,
          //   totalMiles: InvoiceMiles,
          // });
          //let dat = moment(InvoiceDate);
          // Loading is completed by processInvoiceData after the line items,
          // statement rows and derived project groups have been assembled.
          getDayAndMileageRate();
        }
      }
      console.log("invoiceDetailsinvoiceDetailsTEST");
    } catch (error) {
      console.log(error);
      if (requestId === invoiceLoadRef.current) {
        invoiceDetailsLoadedRef.current = false;
        setLoading(false);
      }
    } finally {
      // Do not clear loading here. The lineList effect still has to fetch and
      // build the rows displayed by the consolidated invoice.
    }
  };

  console.log(
    periousInvoiceDate,
    "periousInvoiceDate === dayjs(values.invoiceDate)",
    dayjs(values.invoiceDate)
  );
  const getProjectsDetailsById = async (ProjID) => {
    let data = {
      projectId: ProjID,
    };
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_PROJECT_DETAILS_BY_ID_URL,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        const projectDetails = (parsedResponse.ProjectDetails || []).map(
          (project) => ({
            ...project,
            ProjectID: project.ProjectID ?? project.projectId,
            principalRate: project.PrincipalRate ?? project.principalRate,
            PrincipalRate: project.PrincipalRate ?? project.principalRate,
            projectManagerRate:
              project.ProjectManagerRate ?? project.projectManagerRate,
            ProjectManagerRate:
              project.ProjectManagerRate ?? project.projectManagerRate,
            fieldAgentRate: project.FieldAgentRate ?? project.fieldAgentRate,
            FieldAgentRate:
              project.FieldAgentRate ?? project.fieldAgentRate,
          })
        );
        const projectBrokers = (parsedResponse.BrokerDetails || []).filter(
          (broker) => isEnabledRateFlag(broker.Active)
        );
        setProjectBrokerDetails((previous) => [
          ...previous,
          ...projectBrokers,
        ]);
        setProjectDetailsValue((previous) => {
          const merged = [...previous];
          projectDetails.forEach((project) => {
            const existingIndex = merged.findIndex(
              (item) => String(item.ProjectID) === String(project.ProjectID)
            );
            if (existingIndex === -1) {
              merged.push(project);
            } else {
              merged[existingIndex] = {
                ...merged[existingIndex],
                ...project,
                principalRate:
                  project.principalRate ?? merged[existingIndex].principalRate,
                PrincipalRate:
                  project.PrincipalRate ?? merged[existingIndex].PrincipalRate,
                projectManagerRate:
                  project.projectManagerRate ??
                  merged[existingIndex].projectManagerRate,
                ProjectManagerRate:
                  project.ProjectManagerRate ??
                  merged[existingIndex].ProjectManagerRate,
                fieldAgentRate:
                  project.fieldAgentRate ?? merged[existingIndex].fieldAgentRate,
                FieldAgentRate:
                  project.FieldAgentRate ?? merged[existingIndex].FieldAgentRate,
              };
            }
          });
          return merged;
        });

        const {
          MileageRate,
          BillableTravelPerDiem,
          BillableOfficePerDiem,
          BillingDayRate,
        } = projectDetails[0] || {};
        // setBrokerNamesPerproject(parsedResponse.BrokerDetails);
        // setValues((prev) => ({
        //   ...prev,
        //   mileageRate: MileageRate,
        //   BillableOfficePerDiem: BillableOfficePerDiem,
        //   BillableTravelPerDiem: BillableTravelPerDiem,
        //   dayRate: BillingDayRate,
        // }));
        // setPreviousMileageRate(MileageRate);
        // setPreviousDayRate(BillingDayRate);
        // formik1.setValues((prev) => ({
        //   ...prev,
        //   mileageRate: MileageRate,
        //   BillableOfficePerDiem: BillableOfficePerDiem,
        //   BillableTravelPerDiem: BillableTravelPerDiem,
        //   dayRate: BillingDayRate,
        // }));

        //Project Broker
      }
    } catch (error) {}
  };

  const getAllBrokers = async () => {
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_ALL_BROKERS,
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        const filteredValues = parsedResponse.data.filter(
          (item) => item.AccountActive == 1
        );
        setBrokerNamesPerproject(filteredValues);
      }
    } catch (error) {}
  };

  useEffect(() => {
    // The same form component can be reused when navigating between invoices.
    // Clear invoice-scoped data before starting the next load so old rows/rates
    // cannot be displayed while the new request is in flight.
    setLineList([]);
    setInitialLineList([]);
    setFinalList([]);
    setOriginalFinalList([]);
    setConsolidatedInvoiceDetails([]);
    setProjectDetailsValue([]);
    setProjectBrokerDetails([]);
    setSelectedPeriodList([]);
    setPreviousMileageRateDayRateByProject("");
    setOldMileageRateDayRateByProject("");
    setPendingDayRateSelections({});
    setPendingDayRateValues({});

    getInvoiceDetails();
    getAllBrokers();
  }, [invoiceid]);
  // useEffect(() => {
  //   if (finalList.length > 0) {
  //     getDayAndMileageRate();
  //   }
  // }, [finalList]);
  useEffect(() => {
    let cancelled = false;

    const processInvoiceData = async () => {
      if (!invoiceDetailsLoadedRef.current) return;
      const parsedInvoiceDetails = Array.isArray(lineList)
        ? lineList.filter(Boolean)
        : [];

      console.log(lineList, selectedPeriodList, "lineeeeeeeeeeeeeeeeNEW");

      const projectMap = {};
      const mergeDetails = parsedInvoiceDetails.map((lineItem) => {
        console.log(lineItem, "lineeeeeeeeeeeeeeee");
        console.log(
          previousMileageRateDayRateByProject,
          "previousMileageRateDayRateByProject987"
        );
        // if (lineItem.BillingHeaderID !== 0) {
        const match = consolidatedInvoiceDetails.find(
          (consolidatedItem) =>
            consolidatedItem.BillingStatementID === lineItem.BillingHeaderID
        );

        const matchedMileAndDayRate = Array.isArray(
          previousMileageRateDayRateByProject
        )
          ? previousMileageRateDayRateByProject.find(
              (rowval) => {
                const lineProjectId =
                  lineItem.ProjID ||
                  lineItem.InvProjectID ||
                  lineItem.ProjectID ||
                  lineItem.projectId;
                const linePeriodKey =
                  lineItem.PeriodKey ||
                  lineItem.InvPeriodKey ||
                  lineItem.periodKey;

                return (
                  String(rowval?.projectId) === String(lineProjectId) &&
                  String(rowval?.periodKey) === String(linePeriodKey)
                );
              }
            )
          : [];
        console.log(
          matchedMileAndDayRate,
          "matchedMileAndDayRatematchedMileAndDayRate"
        );
        return {
          ...lineItem,
          BillingStatementID: match ? match.BillingStatementID : 0,
          MatchedHours: lineItem ? lineItem.Hours : null,
          MatchedMiles: lineItem ? lineItem.Miles : null,
          MatchedLodging: lineItem ? lineItem.Lodging : null,
          MatchedCopies: lineItem ? lineItem.Copies : null,
          MatchedPerDiem: lineItem
            ? Number(lineItem.PerDiem ?? 0).toFixed(2)
            : null,
          MatchedPerDiemRate: lineItem ? lineItem.PerDiemRate : null,
          MatchedMisc: lineItem ? lineItem.Misc : null,
          MatchedMileageRate: matchedMileAndDayRate?.mileageRate
            ? matchedMileAndDayRate?.mileageRate
            : lineItem?.MileageRate,
          MatchedDayRate: matchedMileAndDayRate?.dayRate
            ? matchedMileAndDayRate?.dayRate
            : lineItem?.DayRate,
        };
        // }

        // return { ...lineItem, BillingStatementID: null };
      });

      console.log(mergeDetails, "mergeDetailsmergeDetails");
      for (const item of mergeDetails) {
        const projectKey = item.ProjID || item.InvProjectID;
        const projectPeriodKey = item.PeriodKey || item.InvPeriodKey;

        const { startDate, endDate } = parsePeriodKey(projectPeriodKey);

        // Check if this projectKey already exists in the projectMap

        // Check if this projectKey already exists in the projectMap
        if (!projectMap[projectKey]) {
          projectMap[projectKey] = [];
        }

        // Check if there's an existing entry for the same projectKey with matching startDate and endDate

        // Check if there's an existing entry for the same projectKey with matching startDate and endDate
        const existingProject = projectMap[projectKey].find(
          (proj) => proj.startDate === startDate && proj.endDate === endDate
        );

        if (existingProject) {
          existingProject.details.push({ ...item, startDate, endDate });
          existingProject.selectedperiod.push({ ...item, startDate, endDate });
          existingProject.BillingHeaderIDs.add(item.BillingHeaderID);
        } else {
          projectMap[projectKey].push({
            ...item,
            periods: new Set(),
            selectedperiod: [],
            details: [],
            startDate,
            endDate,
            BillingHeaderIDs: new Set(),
            BrokerName: item.BrokerName,
            PerDiemRate: item.PerDiemRate,
            PerDiem: item.PerDiem,
            BillableOfficePerDiem: item.BillableOfficePerDiem,
            BillableTravelPerDiem: item.BillableTravelPerDiem,
            DayRate: item.BillableDayRate,
          });

          // Push details into the newly created project

          // Push details into the newly created project
          const newProject = projectMap[projectKey].find(
            (proj) => proj.startDate === startDate && proj.endDate === endDate
          );
          newProject.details.push({ ...item, startDate, endDate });
          newProject.selectedperiod.push({ ...item, startDate, endDate });
          newProject.BillingHeaderIDs.add(item.BillingHeaderID);
        }
      }

      // Cache API calls to avoid infinite calls
      const fetchedPerDiem = new Set();
      const fetchedStatements = new Set();

      const apiCalls = [];

      for (const projectKey in projectMap) {
        for (const project of projectMap[projectKey]) {
          if (!fetchedPerDiem.has(projectKey)) {
            apiCalls.push(dispatch(getPerDiemList(projectKey)));
            fetchedPerDiem.add(projectKey);
          }

          for (const value of project.BillingHeaderIDs) {
            if (!fetchedStatements.has(value)) {
              apiCalls.push(
                getBillingStatementByID(value)
                  .then((selectedPeriods) => {
                    if (selectedPeriods && Array.isArray(selectedPeriods)) {
                      const statementsWithBrokerName = selectedPeriods
                        .filter(
                          (statement) =>
                            !statement.InvoiceDetailsID ||
                            !project.selectedperiod.some(
                              (existing) =>
                                String(existing.InvoiceDetailsID) ===
                                String(statement.InvoiceDetailsID)
                            )
                        )
                        .map((statement) => ({
                          ...statement,
                          BrokerName: project.BrokerName,
                          PerDiem: project.PerDiem,
                          PerDiemRate: project.PerDiemRate,
                          BillableOfficePerDiem: project.BillableOfficePerDiem,
                          BillableTravelPerDiem: project.BillableTravelPerDiem,
                          DayRate: project.BillableDayRate,
                        }));
                      project.selectedperiod.push(...statementsWithBrokerName);
                    } else {
                      console.error(
                        `getInvoiceSelectedPeriod returned undefined or non-array for projectKey: ${projectKey}`
                      );
                    }
                  })
                  .catch((error) => {
                    console.error(
                      "Error fetching selected periods for projectKey",
                      error
                    );
                  })
              );
              fetchedStatements.add(value);
            }
          }
        }
      }

      try {
        // Execute all API calls concurrently. A failed auxiliary request must
        // not keep the invoice page's primary loader running forever.
        await Promise.allSettled(apiCalls);
        if (cancelled) return;

        const transformedData = Object.values(projectMap).flat();
        console.log(transformedData, "apiCa;lllllllllllll");
        setFinalList(transformedData);
        setShouldUpsert(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    // if (lineList?.length > 0) {
    //   processInvoiceData();
    // }
    processInvoiceData();

    return () => {
      cancelled = true;
    };
  }, [lineList]);

  useEffect(() => {
    dispatch(getAllStatesList());
  }, []);

  useEffect(() => {
    if (finalList.length > 0 && originalFinalList.length === 0) {
      setOriginalFinalList(finalList.map((item) => ({ ...item })));
    }
  }, [finalList]);

  const detachFunCall = async () => {
    setAttachDettachLoading(true);
    let attordet = "detached from";
    if (isAttach == false) {
      attordet = "attached to";
    }
    let data = {
      id: attachmentId ? attachmentId : 0,
      invoiceId: invoiceid,
      billingHeaderId: headidStatement ? headidStatement : 0,
      isAttached: isAttach == false ? true : false,
    };
    const config = {
      method: "POST",
      headers: authHeader(),
      url: ATTACH_DETACH_INVOICE_URL,
      data: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        const { rowCount } = parsedResponse;
        if (isAttach == false) {
          upsertLog("attached to", rowCount);
        } else {
          upsertLog("detached from", rowCount);
        }
        setDetachOpen(false);
        setAttachOpen(false);
        getInvoiceAttachmentsList();
        setProjectFilterSelect("All");
        getInvoiceDetails("attach-dettach");
        // showToast(
        //   `Billing for ${bname} (Customer:${values.CustomerName}, Project: ${projname}, Statement ID: ${headidStatement}) was ${attordet} this invoice. A Total of ${rowCount} invoice lines were removed`,
        //   "success"
        // );
        showToast(
          `Billing for ${bname} (Customer: ${
            values.CustomerName
          }, Project: ${projname}, Statement ID: ${headidStatement}) was ${attordet} this invoice. A total of ${rowCount} invoice lines were ${
            attordet == "attached to" ? "added" : "removed"
          }.`,
          "success"
        );
        setShowWarningpopup(false);
        setAddressvaluesChanged(false);
        setChangedFields({});
        setWarningHighlightColor(false);
        setAddlineItemValue(false);
        setIsAttachDetachLoaded(false);
        setIsAttachDetachLoadedBilling(true);
        setAttachDettachLoading(false);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v.message == "This invoice is closed and cannot be edited.") {
          showToast(v.message, "error");
          getInvoiceDetails();
          setDetachOpen(false);
          setAttachOpen(false);
        } else {
          showToast(v.message, "error");
          getInvoiceDetails();
          setDetachOpen(false);
          setAttachOpen(false);
        }
        setAttachDettachLoading(false);
      }
    }
  };
  const handleCloseAttach = () => {
    setAttachOpen(false);
  };

  const handleDetach = (
    headerid,
    id,
    attached,
    bname,
    projname,
    projId,
    customerId,
    PeriodKey,
    attchDetails
  ) => {
    console.log(id, "iddddddddddddddd");
    setDetachOpen(true);
    setIsAttach(attached);
    setAttachmentId(id);
    setHeadIdStatement(headerid);
    setBname(bname);
    setPrpjName(projname);
    setProjectIdval(projId);
    setCustomerIdval(customerId);
    setAttachDettachPeriodKey(PeriodKey);
    setAttachDettails(attchDetails);
    setIsAttachDetachLoadedBilling(false);
    // setIsAttachDetachLoaded(false);
  };
  const handleAttach = (
    headerid,
    id,
    attached,
    bname,
    projname,
    projId,
    customerId,
    PeriodKey,
    attchDetails
  ) => {
    setAttachOpen(true);
    setAttachmentId(id);
    setHeadIdStatement(headerid);
    setIsAttach(attached);
    setBname(bname);
    setPrpjName(projname);
    setProjectIdval(projId);
    setCustomerIdval(customerId);
    setAttachDettachPeriodKey(PeriodKey);
    setAttachDettails(attchDetails);
    setIsAttachDetachLoadedBilling(false);
    // setIsAttachDetachLoaded(false);
  };

  const upsertLog = async (type, rowCount) => {
    let logData = {
      logTypeID: type == "attached to" ? 51 : 52,
      logUser: getLogUserId(),
      target: headidStatement,
      // target: projectIdval,
      target2: customerIdValue,
      description:
        type == "attached to"
          ? `Billing for '${bname}' (Customer: '${values.CustomerName}', Project: '${projname}', Statement ID: '${headidStatement}') was ${type} this invoice. A Total of ${rowCount} invoice lines were added}`
          : `Billing for '${bname}' (Customer: '${values.CustomerName}', Project: '${projname}', Statement ID: '${headidStatement}') was ${type} this invoice. A Total of ${rowCount} invoice lines were removed}`,
    };
    const config = {
      method: "POST",
      headers: authHeader(),
      url: SYSTEM_LOG_INSERT_URL,
      data: {
        webString: enCryptFun(JSON.stringify(logData)),
      },
    };
    try {
      const resp = await API(config);
    } catch (error) {
      console.error(error);
    }
  };

  const lineDateChange = (e, index) => {
    // Ensure the date input (e) is valid before processing
    if (!e || isNaN(new Date(e))) {
      console.error("Invalid date input");
      return;
    }

    // Format the date to local time in MM/DD/YYYY format
    const valueDate = moment.utc(new Date(e)).local().format("MM/DD/YYYY");
    console.log(valueDate, "lineDateChange", e, index);

    // Update the specific line item's date in the lineItems array
    formik1.setValues((prev) => ({
      ...prev,
      lineItems: prev.lineItems.map((item, i) =>
        i === index ? { ...item, date: valueDate } : item
      ),
    }));

    // Optionally update a separate field if necessary
    formik1.setFieldValue("date", valueDate);
  };

  // console.log(formik1.values.lineItems, "formik1.values.lineItems");

  const handleChangeDate = (e, field) => {
    const selectedDate = dayjs(e);
    const today = dayjs().startOf("day");

    if (!selectedDate.isValid()) {
      setDateFormatError("Invalid date format.", "error");
      // Reset or keep the old date (Optional: depends on your UX)
      setValues({ ...values, invoiceDate: selectedDate });
      return;
    }
    // else if (selectedDate.isBefore(today)) {
    //   setDateFormatError("Invoice date cannot be in the past.", "error");
    //   // Reset or keep the old date (Optional: depends on your UX)
    //   setValues({ ...values, invoiceDate: selectedDate });
    // }
    else {
      // Set the valid date
      setDateFormatError("", "error");
      setValues({ ...values, invoiceDate: selectedDate });
    }
  };
  const listOnChange = (e, billid, headerID) => {
    setShouldUpsert(false);
    const { name, value } = e.target;

    console.log(name, "namenamenamename");
    const regex = /^\d*\.?\d{0,2}$/;
    const floatRegex = /^(\d{0,2}(\.\d{0,2})?)$/;
    const numericValue = parseFloat(value);

    // Find the index of the object in finalList with the matching billid
    if (name == "Description" || name == "BillingType") {
      const updatedFinalList = finalList.map((item) => {
        if (parseInt(item.BillingHeaderID) === parseInt(headerID)) {
          // Update the selectedperiod array for the matching HeaderID
          const updatedSelectedPeriod = item.selectedperiod.map((period) =>
            parseInt(period.InvoiceDetailsID) === parseInt(billid)
              ? { ...period, [name]: value }
              : period
          );
          return { ...item, selectedperiod: updatedSelectedPeriod };
        }
        return item;
      });

      setFinalList(updatedFinalList);
      setRateFlag(!rateFlag);
    } else if (name == "Hours") {
      let newName = "Matched" + name;
      if (
        (value === "" || floatRegex.test(value)) &&
        (numericValue <= 24 || value === "")
      ) {
        const updatedFinalList = finalList.map((item) => {
          if (parseInt(item.BillingHeaderID) === parseInt(headerID)) {
            // Update the selectedperiod array for the matching HeaderID
            const updatedSelectedPeriod = item.selectedperiod.map((period) =>
              parseInt(period.InvoiceDetailsID) === parseInt(billid)
                ? { ...period, [newName]: value }
                : period
            );
            return { ...item, selectedperiod: updatedSelectedPeriod };
          }
          return item;
        });

        const updatedFinalList1 = finalList.map((item) => {
          if (Number(item.BillingHeaderID) === Number(headerID)) {
            const updatedSelectedPeriod = (item.selectedperiod || []).map(
              (period) =>
                Number(period.InvoiceDetailsID) === Number(billid)
                  ? {
                      ...period,
                      [newName]: value,
                      MatchedPerDiem: calculatePerDiem(
                        value,
                        period?.MatchedPerDiemRate
                      ),
                    }
                  : period
            );
            return { ...item, selectedperiod: updatedSelectedPeriod };
          }
          return item;
        });

        if (name === "PerDiemRate" || name === "Hours") {
          setFinalList(updatedFinalList1);
        } else {
          setFinalList(updatedFinalList);
        }
        setRateFlag(!rateFlag);
      }
    } else {
      let newName = "Matched" + name;
      if (regex.test(value) || value === "") {
        const updatedFinalList = finalList.map((item) => {
          if (parseInt(item.BillingHeaderID) === parseInt(headerID)) {
            // Update the selectedperiod array for the matching HeaderID
            const updatedSelectedPeriod = item.selectedperiod.map((period) =>
              parseInt(period.InvoiceDetailsID) === parseInt(billid)
                ? { ...period, [newName]: value }
                : period
            );
            return { ...item, selectedperiod: updatedSelectedPeriod };
          }
          return item;
        });

        const updatedFinalList1 = finalList.map((item) => {
          if (Number(item.BillingHeaderID) === Number(headerID)) {
            const updatedSelectedPeriod = (item.selectedperiod || []).map(
              (period) =>
                Number(period.InvoiceDetailsID) === Number(billid)
                  ? {
                      ...period,
                      [newName]: value,
                      MatchedPerDiem: calculatePerDiem(
                        period?.MatchedHours,
                        value
                      ),
                    }
                  : period
            );
            return { ...item, selectedperiod: updatedSelectedPeriod };
          }
          return item;
        });

        if (name === "PerDiemRate" || name === "Hours") {
          setFinalList(updatedFinalList1);
        } else {
          setFinalList(updatedFinalList);
        }
        setRateFlag(!rateFlag);
      }
    }

    const initialValue = initialLineList.find(
      (item) => item.InvoiceDetailsID == billid
    )?.[name];
    setChangedFields((prevState) => {
      const newState = { ...prevState };
      const isChanged = value != initialValue; // Check if the current value differs from the initial value
      if (isChanged) {
        newState[billid] = {
          ...prevState[billid],
          [name]: true, // Mark as changed
        };
      } else {
        if (newState[billid]) {
          delete newState[billid][name];
          if (Object.keys(newState[billid]).length === 0) {
            delete newState[billid];
          }
        }
      }

      return newState;
    });
  };

  const handleUpdateLineItem = async (hid, inDetId, ProjID1, periodKey1) => {
    setSaveButtonLoading(true);

    let filterresult = finalList
      .map((item) => {
        if (item.BillingHeaderID === hid) {
          const finalvalue = item.selectedperiod.filter(
            (rec) => rec.InvoiceDetailsID == inDetId
          );
          return finalvalue;
        } else {
          return null; // or you can return an empty array or any other default value
        }
      })
      .filter((item) => item !== null) // To remove null values if any
      .flat(); // Flatten the array to remove nested arrays

    const FilterInvoiceDetails = finalList.filter((item) => {
      return item.BillingHeaderID === hid;
    });

    // const {
    //   InvoiceHeaderID,
    //   InvoiceDetailsID,
    //   BillingHeaderID,
    //   BrokerID,
    //   BillingDetailID,
    // } = FilterInvoiceDetails[0];
    const {
      BillingDetailID,
      BillingHeaderID,
      InvoiceDetailsID,
      InvoiceHeaderID,
      BillingType,
      BrokerID,
      Copies,
      Date,
      Description,
      Hours,
      Miles,
      Lodging,
      Misc,
      PerDiem,
      PerDiemRate,
      DayRate,
      ProjID,
      MatchedHours,
      MatchedMiles,
      MatchedLodging,
      MatchedCopies,
      MatchedPerDiem,
      MatchedPerDiemRate,
      MatchedMisc,
      InvProjectID,
      InvPeriodKey,
      selectedDayRate: selectedDayRateValue,
    } = filterresult[0];

    //const calculatedPerDiem = calculatePerDiem(Hours, PerDiemRate);
    const calculatedPerDiem = calculatePerDiem(
      MatchedHours,
      MatchedPerDiemRate
    );

    // let postData = {
    //   invoiceDetailsId: InvoiceDetailsID,
    //   invoiceHeaderId: InvoiceHeaderID,
    //   billingHeaderId: BillingHeaderID,
    //   billingDetailId: BillingDetailID,
    //   brokerId: BrokerID,
    //   billingType: BillingType,
    //   date: moment(Date).format("MM/DD/YYYY"),
    //   hours: Hours ? Hours : 0,
    //   perDiem: calculatedPerDiem ? parseFloat(calculatedPerDiem) : 0,
    //   lodging: Lodging ? parseFloat(Lodging) : 0,
    //   miles: Miles ? parseFloat(Miles) : 0,
    //   misc: Misc ? parseFloat(Misc) : 0,
    //   copies: Copies ? parseFloat(Copies) : 0,
    //   description: Description ? Description : "",
    //   perDiemRate: PerDiemRate ? parseFloat(PerDiemRate) : 0,
    //   dayRate: DayRate ? parseFloat(DayRate) : 0,
    //   projectId: ProjID && ProjID,
    //   periodKey: periodKey,
    // };

    const projectForLine = finalList.find(
      (item) => String(item.ProjID || item.InvProjectID) === String(ProjID || InvProjectID)
    ) || projectDetailsValue.find(
      (item) => String(item.ProjectID || item.projectId) === String(ProjID || InvProjectID)
    ) || {};
    const projectHeaderRate = getProjectHeaderRate(
      ProjID || InvProjectID,
      periodKey1 || InvPeriodKey
    );
    const consolidatedRateSource = {
      InvoiceDayRate: projectHeaderRate.dayRate,
      ...projectHeaderRate,
    };
    const resolvedRate = resolveExistingLineItemDayRate(
      getPersistedSelectedDayRate({
        selectedDayRate: selectedDayRateValue,
        InvSelectedDayRate: filterresult[0]?.InvSelectedDayRate,
      }),
      consolidatedRateSource,
      normalizeProjectRateData(projectForLine),
      DayRate
    );
    const lineRateSource = normalizeProjectRateData({
      ...projectForLine,
      ...filterresult[0],
    });
    const lineRate = resolveExistingLineItemDayRate(
      getPersistedSelectedDayRate({
        selectedDayRate: selectedDayRateValue,
        InvSelectedDayRate: filterresult[0]?.InvSelectedDayRate,
      }),
      consolidatedRateSource,
      lineRateSource,
      DayRate
    ).dayRate;
    let postData = {
      invoiceDetailsId: InvoiceDetailsID,
      invoiceHeaderId: InvoiceHeaderID,
      billingHeaderId: BillingHeaderID,
      billingDetailId: BillingDetailID,
      brokerId: BrokerID,
      billingType: BillingType,
      date: moment(Date).utc().format("MM/DD/YYYY"),
      hours: MatchedHours ? MatchedHours : 0,
      perDiem: MatchedPerDiem ? parseFloat(MatchedPerDiem)?.toFixed(2) : "0.00",
      // perDiem: calculatedPerDiem ? parseFloat(calculatedPerDiem) : 0,
      lodging: MatchedLodging ? parseFloat(MatchedLodging) : 0,
      miles: MatchedMiles ? parseFloat(MatchedMiles) : 0,
      misc: MatchedMisc ? parseFloat(MatchedMisc) : 0,
      copies: MatchedCopies ? parseFloat(MatchedCopies) : 0,
      description: Description ? Description : "",
      perDiemRate: !isNaN(parseFloat(MatchedPerDiemRate))
        ? Number(parseFloat(MatchedPerDiemRate).toFixed(2))
        : 0,
      ...buildExistingLineItemRatePayload(
        resolvedRate.selectedDayRate,
        resolveExistingLineItemDayRate(
          "Billable Rate",
        consolidatedRateSource,
          lineRateSource,
          DayRate
        ).dayRate,
        lineRate,
        { ...filterresult[0], ...consolidatedRateSource }
      ),
      projectId: ProjID ? ProjID : InvProjectID,
      periodKey: periodKey1 ? periodKey1 : InvPeriodKey,
    };

    const configone = {
      method: "POST",
      url: UPSERT_INVOICE_DETAILS_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(postData)),
      },
    };

    try {
      const response = await API(configone);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status == "Success") {
        const message = parsedResponse.message;

        // Dynamically extract the project, customer, and date information from the message
        const invoiceUpdateMessage = message.split("\\n")[0]; // The first line contains the static part

        // Extract the rest of the data updates from the message
        const updatedData = message
          .split("\\n") // Split the message into lines by the newline character
          .slice(1) // Ignore the first line as it contains the static part
          .filter((line) => line.includes("updated from")) // Keep only lines that mention updates
          .map((line) => line.trim()); // Clean up extra spaces

        // Format the updates into JSX spans
        const formattedUpdates = updatedData.map((update, index) => (
          <span key={index}>{update}</span>
        ));

        // Create the final toast message dynamically
        // Declare the toastMessage outside the JSX
        let toastMessage = null;

        if (formattedUpdates.length > 0) {
          toastMessage = (
            <>
              <span>{invoiceUpdateMessage}</span>
              <br />
              <span>Data updated was:</span>
              <br />
              {formattedUpdates.map((update, index) => (
                <span key={index}>
                  {update}
                  <br />
                </span>
              ))}
            </>
          );

          // Show the toast with the formatted message
          showToast(toastMessage, "success");
        } else {
          toastMessage = (
            <>
              <span>{invoiceUpdateMessage}</span>
            </>
          );
          showToast(toastMessage, "success");
        }
        updateHeaderDetails("false", "", ProjID1, periodKey1);
      }
      getInvoiceDetails();
      setSaveButtonLoading(false);
      setChangedFields({});
      setWarningHighlightColor(false);
      setAddlineItemValue(false);
      setAddressvaluesChanged(false);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v.message == "This invoice is closed and cannot be edited.") {
          showToast(v.message, "error");
          getInvoiceDetails();
        } else {
          showToast(v.message, "error");
          getInvoiceDetails();
        }
        setSaveButtonLoading(false);
      }
    }
  };
  const updateDayAndMileageRate = async (
    ProjID,
    customerId,
    periodKey,
    type,
    ProjectName,
    detfetch,
    selectedDayRate,
    dayRateOverride
  ) => {
    console.log(
      "previousMileageRateDayRateByProject 1 ",
      previousMileageRateDayRateByProject
    );
    console.log(
      "previousMileageRateDayRateByProject 2 ",
      oldMileageRateDayRateByProject
    );

    var previousMileageRateDayRateByProjectRow =
      previousMileageRateDayRateByProject.find(
        (val) => val.projectId == ProjID && val.periodKey == periodKey
      );
    var oldMileageRateDayRateByProjectRow = oldMileageRateDayRateByProject.find(
      (val) => val.projectId == ProjID && val.periodKey == periodKey
    );
    const effectiveDayRate =
      type === "dayRate_save" && dayRateOverride !== undefined
        ? parseFloat(dayRateOverride)
        : previousMileageRateDayRateByProjectRow
        ? parseFloat(previousMileageRateDayRateByProjectRow.dayRate)
        : currentDayRate;

    const headerProject = finalList.find(
      (item) =>
        String(item.ProjID || item.InvProjectID) === String(ProjID) &&
        String(item.PeriodKey || item.InvPeriodKey) === String(periodKey)
    ) || {};
    const headerProjectRecord =
      oldMileageRateDayRateByProjectRow ||
      previousMileageRateDayRateByProjectRow ||
      {};
    const headerRateSource = {
      ...headerProject,
      ...headerProjectRecord,
      InvoiceDayRate: headerProjectRecord.dayRate,
    };
    const normalizedSelectedDayRate = normalizeSelectedDayRate(selectedDayRate);
    const projectHeaderRate = getProjectHeaderRate(ProjID, periodKey);
    // `dayRate` on a project header is always the billable/header rate.  The
    // manually entered value belongs only to the selected optional rate.
    const billableHeaderDayRate =
      normalizedSelectedDayRate === "Billable Rate"
        ? effectiveDayRate
        : parseFloat(projectHeaderRate.dayRate ?? 0);
    const headerSelectedRateFields = getProjectHeaderRateFields(
      headerRateSource,
      normalizedSelectedDayRate,
      effectiveDayRate
    );

    const consolidatedProjects = details.map((detail) => {
      const isTargetHeader =
        String(detail.projectId) === String(ProjID) &&
        String(detail.periodKey) === String(periodKey);
      return {
        ...detail,
        ...(isTargetHeader
          ? {
              ...headerSelectedRateFields,
              dayRate: billableHeaderDayRate,
            }
          : {}),
        selectedDayRate: isTargetHeader
          ? normalizedSelectedDayRate
          : normalizeSelectedDayRate(detail.selectedDayRate),
      };
    });
    const headerRatePayload = getLineRatePayload(
      normalizedSelectedDayRate,
      billableHeaderDayRate,
      effectiveDayRate,
      headerRateSource
    );

    const data = {
      consolidatedProjects: JSON.stringify(consolidatedProjects),
      oldMileageRate: oldMileageRateDayRateByProjectRow
        ? parseFloat(oldMileageRateDayRateByProjectRow.mileageRate)
        : previousMileageRate,
      mileageRate:
        type == "mileageRate_save" && previousMileageRateDayRateByProjectRow
          ? parseFloat(previousMileageRateDayRateByProjectRow.mileageRate)
          : currentMileageRate,
      oldDayRate: oldMileageRateDayRateByProjectRow
        ? parseFloat(oldMileageRateDayRateByProjectRow.dayRate)
        : previousDayRate,
      ...headerRatePayload,
      ...headerSelectedRateFields,
      customerId: customerId,
      projectId: ProjID,
      invoiceId: invoiceid && invoiceid,
    };

    let updatedDayRateMillageRate = {
      projectId: ProjID,
      periodKey,
      selectedDayRate: normalizeSelectedDayRate(selectedDayRate),
      mileageRate: previousMileageRateDayRateByProjectRow
        ? parseFloat(previousMileageRateDayRateByProjectRow.mileageRate)
        : currentMileageRate,
      dayRate: billableHeaderDayRate,
      ...headerSelectedRateFields,
    };

    const config = {
      method: "POST",
      headers: authHeader(),
      url: UPDATE_DAY_AND_MILEAGE_RATE_INVOICE_URL,
      data: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status == "Success") {
        if (type == "dayRate_save") {
          const StartDate = moment
            ?.utc(detfetch?.billingStart)
            .format("MM/DD/YYYY");
          const ToDate = moment?.utc(detfetch?.billingEnd).format("MM/DD/YYYY");
          const oldDayRate = oldMileageRateDayRateByProjectRow
            ? parseFloat(oldMileageRateDayRateByProjectRow.dayRate)
            : previousDayRate;

          const newDayRate = effectiveDayRate;
          showToast(
            `The day rate was updated from $${oldDayRate} to $${newDayRate} for the billing period from ${StartDate} to ${ToDate} in the "${ProjectName}" project.`,
            "success"
          );
        } else if (type == "mileageRate_save") {
          const StartDate = moment
            ?.utc(detfetch?.billingStart)
            .format("MM/DD/YYYY");
          const ToDate = moment?.utc(detfetch?.billingEnd).format("MM/DD/YYYY");
          const oldMilerageRate = oldMileageRateDayRateByProjectRow
            ? parseFloat(oldMileageRateDayRateByProjectRow.mileageRate)
            : previousMileageRate;

          const newMileagerate = previousMileageRateDayRateByProjectRow
            ? parseFloat(previousMileageRateDayRateByProjectRow.mileageRate)
            : currentMileageRate;

          showToast(
            `The mileage rate was updated from $${oldMilerageRate} to $${newMileagerate} for the billing period from ${StartDate} to ${ToDate} in the "${ProjectName}" project.`,
            "success"
          );
        } else {
          showToast(parsedResponse.message, "success");
        }
        const mergeUpdatedHeaderRate = (previous) =>
          previous.map((item) =>
            String(item.projectId) === String(ProjID) &&
            String(item.periodKey) === String(periodKey)
              ? { ...item, ...updatedDayRateMillageRate }
              : item
          );
        setPreviousMileageRateDayRateByProject(mergeUpdatedHeaderRate);
        setOldMileageRateDayRateByProject(mergeUpdatedHeaderRate);
        updateHeaderDetails(
          "false",
          "",
          ProjID,
          periodKey,
          "",
          updatedDayRateMillageRate
        );

        getProjectsById(ProjID);
        getInvoiceDetails(type);
        return true;
      }
      return false;
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v.message == "This invoice is closed and cannot be edited.") {
          showToast(v.message, "error");
          getInvoiceDetails();
        } else {
          showToast(v.message, "error");
        }
      }
      return false;
    }
  };

  const updateHeaderDetails = async (
    Type,
    InvoiceTotal,
    ProjId,
    PeriodKey,
    attchedValue,
    updatedDayRateMillageRate
  ) => {
    console.log(
      dayjs(values.invoiceDate).format("MM/DD/YYYY"),       "incoicueiueuuyeuyureuupdateHeaderDetailsrtyergrheghrghrgb",
     dayjs(values.createDate).format("MM/DD/YYYY"),

    );

    var grandMDTotalVlaue = 0;

    let mileageRateVal = values.mileageRate;
    let dayRateVal = values.dayRate;

    if (updatedDayRateMillageRate) {
      setShouldUpsert(true);
      setFinalList((prevFinalList) => {
        return prevFinalList.map((invoice) => {
          if (invoice.ProjID === updatedDayRateMillageRate.projectId) {
            return {
              ...invoice,
              MileageRate: updatedDayRateMillageRate.mileageRate,
              DayRate: updatedDayRateMillageRate.dayRate,
              selectedperiod: invoice.selectedperiod.map((period) => ({
                ...period,
                MatchedMileageRate: updatedDayRateMillageRate.mileageRate,
                MatchedDayRate: updatedDayRateMillageRate.dayRate,
              })),
              details: invoice.details.map((detail) => ({
                ...detail,
                MatchedMileageRate: updatedDayRateMillageRate.mileageRate,
                MatchedDayRate: updatedDayRateMillageRate.dayRate,
              })),
            };
          }
          return invoice; // Return the unchanged invoice
        });
      });

      //totalMilesVal
      var totalMilesVal = 0;
      finalList.forEach((detail) => {
        const matchedMileageRateDayRateObj =
          previousMileageRateDayRateByProject.find(
            (row) => row.projectId == detail.ProjID
          );
        const totalMiles = detail.selectedperiod
          .filter((period) => period.InvoiceDetailsID)
          .reduce((sum, period) => {
            return sum + (period.Miles ? period.Miles : 0);
          }, 0);

        // console.log(
        //   "totalMilestotalMilesNEW",
        //   totalMiles,
        //   matchedMileageRateDayRateObj.mileageRate
        // );
        const value = matchedMileageRateDayRateObj?.mileageRate * totalMiles;
        totalMilesVal += value;
      });

      const totalExpensesVal = finalList.reduce((acc, item) => {
        // Calculate total expenses for each item by summing Lodging, Copies, and Misc from selectedPeriod
        const totalItemExpenses = item.selectedperiod
          .filter((period) => period.InvoiceDetailsID)
          .reduce((sum, period) => {
            return (
              (sum ? sum : 0) +
              ((period.Lodging ? parseFloat(period.Lodging) : 0) +
                (period.Copies ? parseFloat(period.Copies) : 0) +
                (period.Misc ? parseFloat(period.Misc) : 0))
            );
          }, 0);

        // Add the totalItemExpenses to the overall total
        return acc + totalItemExpenses;
      }, 0);

      const totalPerdiemVal = finalList.reduce((acc, item) => {
        const totalItempers = item.selectedperiod
          .filter((period) => period.InvoiceDetailsID)
          .reduce(
            (sum, period) => parseFloat(sum) + parseFloat(period.PerDiem),
            0
          );
        return acc + totalItempers;
      }, 0);

      const totalChargeVal = finalList.reduce((acc, item) => {
        return acc + getProjectChargeTotal(item);
      }, 0);

      mileageRateVal = updatedDayRateMillageRate.mileageRate;
      dayRateVal = updatedDayRateMillageRate.dayRate;

      console.log(
        totalMilesVal,
        totalExpensesVal,
        totalPerdiemVal,
        totalChargeVal,
        finalList,
        updatedDayRateMillageRate,
        previousMileageRateDayRateByProject,
        "totalChargeValtotalChargeVal"
      );

      grandMDTotalVlaue = (
        (parseFloat(totalMilesVal) || 0) +
        (parseFloat(totalExpensesVal) || 0) +
        (parseFloat(totalPerdiemVal) || 0) +
        (parseFloat(totalChargeVal) || 0)
      ).toFixed(2);
    }

    const totalValues = {
      perDiemSum:
        finalList.details?.reduce((acc, item) => {
          return (
            acc + calculatePerDiem(Number(item.Hours), Number(item.PerDiemRate))
          );
        }, 0) || 0, // fallback to 0 if details is undefined or empty
      perLodgingSum:
        finalList.details?.reduce(
          (acc, item) => acc + Number(item.Lodging),
          0
        ) || 0,
      perCopiesSum:
        finalList.details?.reduce(
          (acc, item) => acc + Number(item.Copies),
          0
        ) || 0,
      perMiscSum:
        finalList.details?.reduce((acc, item) => acc + Number(item.Misc), 0) ||
        0,
      perMilesSum:
        finalList.details?.reduce((acc, item) => acc + Number(item.Miles), 0) ||
        0,
      perTotalHoursSum:
        finalList.details?.reduce((acc, item) => acc + Number(item.Hours), 0) ||
        0,
    };

    console.log("grandMDTotalVlaue", grandMDTotalVlaue);

    // Calculate grand total based on different components
    const grandTotal =
      (totalValues.perDiemSum ? parseFloat(totalValues.perDiemSum) : 0) +
      (totalValues.perLodgingSum ? parseFloat(totalValues.perLodgingSum) : 0) +
      (totalValues.perCopiesSum ? parseFloat(totalValues.perCopiesSum) : 0) +
      (totalValues.perMiscSum ? parseFloat(totalValues.perMiscSum) : 0) +
      (totalValues.perMilesSum ? parseFloat(totalValues.perMilesSum) : 0) *
        (mileageRateVal ? parseFloat(mileageRateVal) : 0) +
      (totalValues.perTotalHoursSum
        ? (parseFloat(totalValues.perTotalHoursSum) / 8) *
          (dayRateVal ? parseFloat(dayRateVal) : 0)
        : 0);

    console.log(
      InvoiceTotalValue,
      "incoicueiueuuyeuyureurtyergrheghrghrgb InvoiceTotalValue"
    );
    console.log(
      InvoiceTotal,
      "incoicueiueuuyeuyureurtyergrheghrghrgb InvoiceTotal"
    );

    const data = {
      invoiceId: values?.invoiceNo,
      customerId: values.CustomerID,
      periodKey: PeriodKey,
      projectId: ProjId,
      userId: getLogUserId(),
      statusId: values.InvoiceStatusID,
      billingStart: null,
      // attchedValue == "Attched_Dettached_Values"
      // ? dayjs(attachDetailsUpsert?.BillingStart).format("MM/DD/YYYY")
      // : values.startDate,
      billingEnd: null,
      // attchedValue == "Attched_Dettached_Values"
      //   ? dayjs(attachDetailsUpsert?.BillingEnd).format("MM/DD/YYYY")
      //   : values.endDate,
      invoiceDate: dayjs.utc(values.invoiceDate).format("MM/DD/YYYY"),
      createDate: dayjs(values.createDate).format("MM/DD/YYYY"),
      billToStreet1: values.street1 || "",
      billToStreet2: values.street2 || "",
      billToCity: values.city || "",
      billToState: values.state || "",
      billToZip: values.zipcode,
      brokerCount: values.InvoiceBrokerCount,
      brokerHours: totalValues?.perTotalHoursSum
        ? totalValues?.perTotalHoursSum
        : 0,
      dayRate: dayRateVal || '0.00',
      perDiem: totalValues.perDiemSum,
      lodging: totalValues.perLodgingSum,
      miles: totalValues.perMilesSum,
      misc: totalValues.perMiscSum,
      copies: totalValues.perCopiesSum,
      mileageRate: mileageRateVal || '0.00',
      // invoiceTotal: InvoiceTotalValue
      //   ? InvoiceTotalValue
      //   : InvoiceTotal != undefined || InvoiceTotal != null
      //   ? InvoiceTotal
      //   : grandTotal,
      invoiceTotal: updatedDayRateMillageRate
        ? grandMDTotalVlaue
        : InvoiceTotalValue
        ? InvoiceTotalValue
        : InvoiceTotal != undefined || InvoiceTotal != null
        ? InvoiceTotal
        : grandTotal,
      headerIds: null,
      isConsolidated: true,
    };
    const config = {
      method: "POST",
      headers: authHeader(),
      url: UPSERT_INVOICE_STATEMENT_URL,
      data: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status == "Success") {
        // getInvoiceDetails();
        if (Type != "false") {
          showToast(parsedResponse.message, "success");
        }
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        console.log("Error Messgae From updateHeaderDetails", v);
        if (v.message == "This invoice is closed and cannot be edited.") {
          // showToast(v.message, "error");
          getInvoiceDetails();
        } else {
          // showToast(v.message, "error");
          getInvoiceDetails();
        }
      }
    }
  };

  const mileageRateSave = (
    id,
    customerId,
    periodKey,
    mileageRateVal,
    ProjectName
  ) => {
    const project = finalList.find(
      (item) =>
        parseInt(item.ProjID ? item.ProjID : item.InvProjectID) ===
          parseInt(id) && (item?.PeriodKey || item?.InvPeriodKey) === periodKey
    );

    if (!project) {
      showToast("Project not found", "error");
      return;
    }

    // Find index in your lists
    // const index = finalList.findIndex(
    //   (item) => parseInt(item.ProjID) === parseInt(id)
    // );

    // const index1 = details.findIndex(
    //   (item) => parseInt(item.projectId) === parseInt(id)
    // );

    // if (project) {
    //   finalList[index].MileageRate = mileageRateVal;
    //   details[index1].mileageRate = mileageRateVal;
    //   setCurrentMileageRate(mileageRateVal);
    // }

    finalList
      .filter(
        (item) =>
          parseInt(item.ProjID ? item.ProjID : item.InvProjectID) ===
            parseInt(id) &&
          (item?.PeriodKey || item?.InvPeriodKey) === periodKey
      )
      .forEach((item) => {
        item["MileageRate"] = mileageRateVal;
      });

    const updatedFinalList = finalList.map((item) =>
      parseInt(item.ProjID ? item.ProjID : item.InvProjectID) ===
        parseInt(id) && (item?.PeriodKey || item?.InvPeriodKey) === periodKey
        ? { ...item, MileageRate: mileageRateVal }
        : item
    );
    setFinalList(updatedFinalList);
    setShouldUpsert(true);
    details
      .filter(
        (item) =>
          parseInt(item.projectId) === parseInt(id) &&
          item?.periodKey === periodKey
      )
      .forEach((item) => {
        item["mileageRate"] = mileageRateVal;
      });

    const updatedDetails = details.map((item) =>
      parseInt(item.projectId) === parseInt(id) && item?.periodKey === periodKey
        ? { ...item, mileageRateVal: mileageRateVal }
        : item
    );
    setDetails(updatedDetails);

    const detfetch = details.find(
      (item) =>
        parseInt(item.projectId) === parseInt(id) &&
        item?.periodKey === periodKey
    );

    if (detfetch.mileageRate) {
      updateDayAndMileageRate(
        id,
        customerId,
        periodKey,
        "mileageRate_save",
        ProjectName,
        detfetch
      );
    } else {
      showToast("Mileage Rate is required", "error");
    }
  };

  const dayRateSave = async (
    id,
    customerId,
    periodKey,
    dayRateVal,
    ProjectName,
    selectedDayRate
  ) => {
    // setPreviousDayRate(currentDayRate);
    // setPreviousMileageRate(currentMileageRate);

    const project = finalList.find(
      (item) =>
        parseInt(item.ProjID ? item.ProjID : item.InvProjectID) ===
          parseInt(id) && (item?.PeriodKey || item?.InvPeriodKey) === periodKey
    );

    if (!project) {
      showToast("Project not found", "error");
      return;
    }

    const normalizedSelection = normalizeSelectedDayRate(selectedDayRate);
    const selectedRateFields = getSelectedRateFields(
      normalizedSelection,
      dayRateVal
    );

    finalList
      .filter(
        (item) =>
          parseInt(item.ProjID ? item.ProjID : item.InvProjectID) ===
            parseInt(id) &&
          (item?.PeriodKey || item?.InvPeriodKey) === periodKey
      )
      .forEach((item) => {
        item["BillableDayRate"] = dayRateVal;
      });

    const updatedFinalList = finalList.map((item) =>
      parseInt(item.ProjID ? item.ProjID : item.InvProjectID) ===
        parseInt(id) && (item?.PeriodKey || item?.InvPeriodKey) === periodKey
        ? {
            ...item,
            ...(normalizedSelection === "Billable Rate"
              ? { BillableDayRate: dayRateVal }
              : {}),
            ...selectedRateFields,
            selectedDayRate: normalizedSelection,
            selectedperiod: (item.selectedperiod || []).map((line) =>
              normalizeSelectedDayRate(getPersistedSelectedDayRate(line)) ===
              normalizedSelection
                ? {
                    ...line,
                    dayRate: dayRateVal,
                    DayRate: dayRateVal,
                    ...selectedRateFields,
                  }
                : line
            ),
          }
        : item
    );
    setFinalList(updatedFinalList);
    setLineList((previous) =>
      previous.map((line) =>
        String(line.ProjID || line.InvProjectID) === String(id) &&
        String(line.PeriodKey || line.InvPeriodKey) === String(periodKey) &&
        normalizeSelectedDayRate(getPersistedSelectedDayRate(line)) ===
          normalizedSelection
          ? {
              ...line,
              dayRate: dayRateVal,
              DayRate: dayRateVal,
              ...selectedRateFields,
            }
          : line
      )
    );
    setShouldUpsert(true);
    details
      .filter(
        (item) =>
          parseInt(item.projectId) === parseInt(id) &&
          item?.periodKey === periodKey
      )
      .forEach((item) => {
        item["dayRate"] = dayRateVal;
      });

    const updatedDetails = details.map((item) =>
      parseInt(item.projectId) === parseInt(id) && item?.periodKey === periodKey
        ? {
            ...item,
            dayRate: dayRateVal,
            selectedDayRate: normalizedSelection,
            ...selectedRateFields,
          }
        : item
    );
    setDetails(updatedDetails);

    // Find index in your lists
    // const index = finalList.findIndex(
    //   (item) => parseInt(item.ProjID) === parseInt(id)
    // );

    // const index1 = details.findIndex(
    //   (item) => parseInt(item.projectId) === parseInt(id)
    // );

    // if (project) {
    //   finalList[index].BillableDayRate = dayRateVal;
    //   details[index1].dayRate = dayRateVal;
    //   setCurrentDayRate(dayRateVal);
    // }

    const detfetch = details.find(
      (item) =>
        parseInt(item.projectId) === parseInt(id) &&
        item?.periodKey === periodKey
    );
    console.log(detfetch, "detavvvvvvvvvvvvvvvvv");
    if (detfetch.dayRate) {
      return updateDayAndMileageRate(
        id,
        customerId,
        periodKey,
        "dayRate_save",
        ProjectName,
        detfetch,
        selectedDayRate,
        dayRateVal
      );
    } else {
      showToast("Day Rate is required", "error");
    }
  };

  const handleChangeDayRate = (e, type, id, periodKey, indexvalue) => {
    console.log(
      "previousMileageRateDayRateByProject",
      previousMileageRateDayRateByProject
    );

    const value = e.target.value;
    const regex = /^\d+(\.\d{0,2})?$/;

    // Find index in your lists
    const index = finalList.findIndex(
      (item) =>
        parseInt(item.ProjID ? item.ProjID : item.InvProjectID) ===
          parseInt(id) && (item?.PeriodKey || item?.InvPeriodKey) === periodKey
    );

    if (index === -1) {
      console.error("Project not found");
      return;
    }

    // Update the state based on the type of rate
    if (type === "dayRate") {
      const key = getProjectCardKey(id, periodKey);
      setPendingDayRateValues((previous) => ({
        ...previous,
        [key]: value,
      }));

      setPreviousMileageRateDayRateByProject((prevState) =>
        prevState.map((item) =>
          item.projectId === parseInt(id) && item.periodKey === periodKey
            ? { ...item, dayRate: value }
            : item
        )
      );
    } else if (type === "mileageRate") {
      if (regex.test(value) || value === "") {
        const mileageRate = value === "" ? "" : parseFloat(value);
        finalList[index].MatchedMileageRate = mileageRate;
      }

      setPreviousMileageRateDayRateByProject((prevState) =>
        prevState.map((item) =>
          item.projectId === parseInt(id) && item.periodKey === periodKey
            ? { ...item, mileageRate: value }
            : item
        )
      );
    }
  };

  const getProjectCardKey = (projectId, periodKey) =>
    `${projectId}-${periodKey}`;

  // The project cards are sorted and can be filtered before rendering. Keep
  // the add-line-item form tied to the original Formik slot for this project,
  // instead of to the card's current display position.
  const getFormikLineItemIndex = (project) => {
    const projectId =
      project?.ProjID ||
      project?.InvProjectID ||
      project?.ProjectID ||
      project?.projectId;
    const periodKey =
      project?.PeriodKey ||
      project?.InvPeriodKey ||
      project?.periodKey;

    return consolidatedInvoiceDetails.findIndex(
      (detail) =>
        String(
          detail?.ProjID ||
            detail?.InvProjectID ||
            detail?.ProjectID ||
            detail?.projectId
        ) === String(projectId) &&
        String(
          detail?.PeriodKey || detail?.InvPeriodKey || detail?.periodKey
        ) === String(periodKey)
    );
  };

  const getProjectHeaderRate = (projectId, periodKey) => {
    const invoiceRate = [
      ...(Array.isArray(oldMileageRateDayRateByProject)
        ? oldMileageRateDayRateByProject
        : []),
      ...(Array.isArray(previousMileageRateDayRateByProject)
        ? previousMileageRateDayRateByProject
        : []),
    ].find(
      (item) =>
        String(item.projectId) === String(projectId) &&
        String(item.periodKey) === String(periodKey)
    ) || {};
    const projectRate =
      projectDetailsValue.find(
        (item) =>
          String(item.ProjectID || item.projectId) === String(projectId)
      ) || {};
    const firstRate = (...values) =>
      values.find((value) => value !== null && value !== undefined && value !== "") ??
      0;

    const dayRate = firstRate(
      invoiceRate.dayRate,
      invoiceRate.BillingDayRate,
      projectRate.BillingDayRate,
      projectRate.BillableDayRate,
      projectRate.billingDayRate,
      projectRate.billableDayRate,
      projectRate.dayRate
    );
    const principalRate = firstRate(
      invoiceRate.selectedPrincipalRate,
      invoiceRate.SelectedPrincipalRate,
      projectRate.selectedPrincipalRate,
      projectRate.SelectedPrincipalRate,
      projectRate.PrincipalRate,
      projectRate.principalRate
    );
    const projectManagerRate = firstRate(
      invoiceRate.selectedProjectManagerRate,
      invoiceRate.SelectedProjectManagerRate,
      projectRate.selectedProjectManagerRate,
      projectRate.SelectedProjectManagerRate,
      projectRate.ProjectManagerRate,
      projectRate.projectManagerRate
    );
    const fieldAgentRate = firstRate(
      invoiceRate.selectedFieldAgentRate,
      invoiceRate.SelectedFieldAgentRate,
      projectRate.selectedFieldAgentRate,
      projectRate.SelectedFieldAgentRate,
      projectRate.FieldAgentRate,
      projectRate.fieldAgentRate
    );

    return {
      ...projectRate,
      ...invoiceRate,
      dayRate,
      BillingDayRate: dayRate,
      BillableDayRate: dayRate,
      selectedPrincipalRate: principalRate,
      SelectedPrincipalRate: principalRate,
      selectedProjectManagerRate: projectManagerRate,
      SelectedProjectManagerRate: projectManagerRate,
      selectedFieldAgentRate: fieldAgentRate,
      SelectedFieldAgentRate: fieldAgentRate,
    };
  };

  const getProjectBillableDayRate = (project) => {
    const projectId =
      project?.ProjID ||
      project?.InvProjectID ||
      project?.ProjectID ||
      project?.projectId;
    const periodKey =
      project?.PeriodKey ||
      project?.InvPeriodKey ||
      project?.periodKey;
    const projectRate =
      project?.BillableDayRate ??
      project?.BillingDayRate ??
      project?.billableDayRate ??
      project?.billingDayRate;

    return projectRate != null && projectRate !== ""
      ? projectRate
      : getProjectHeaderRate(projectId, periodKey).dayRate ?? 0;
  };

  const getProjectChargeTotal = (project = {}) => {
    const projectId =
      project.ProjID ||
      project.InvProjectID ||
      project.ProjectID ||
      project.projectId;
    const periodKey =
      project.PeriodKey ||
      project.InvPeriodKey ||
      project.periodKey;
    const projectHeaderRate = getProjectHeaderRate(projectId, periodKey);
    const rateSource = {
      ...project,
      ...projectHeaderRate,
      InvoiceDayRate: projectHeaderRate.dayRate,
    };

    return getInvoiceLineChargeBreakdown(
      (Array.isArray(project.selectedperiod) ? project.selectedperiod : []).filter(
        (lineItem) => lineItem?.InvoiceDetailsID
      ),
      rateSource
    ).reduce((total, rate) => total + rate.charge, 0);
  };

  const getSelectedDayRate = (project, projectId, periodKey) => {
    const key = getProjectCardKey(projectId, periodKey);
    const savedProjectRate = Array.isArray(oldMileageRateDayRateByProject)
      ? oldMileageRateDayRateByProject.find(
          (item) =>
            String(item.projectId) === String(projectId) &&
            String(item.periodKey) === String(periodKey)
        )?.selectedDayRate
      : undefined;
    return normalizeSelectedDayRate(
      pendingDayRateSelections[key] ||
      savedProjectRate ||
      project?.selectedDayRate ||
      project?.SelectedDayRate
    );
  };

  const handleDayRateSelection = (project, projectId, periodKey, selection) => {
    const selectedDayRate = normalizeSelectedDayRate(selection);
    const projectRateSource =
      projectDetailsValue.find(
        (detail) =>
          String(detail.ProjectID || detail.projectId) === String(projectId)
      ) ||
      project ||
      {};
    const projectHeaderRate = getProjectHeaderRate(projectId, periodKey);
    const dayRate = getDayRateForSelection(
      selectedDayRate,
      {
        ...normalizeProjectRateData(projectRateSource),
        ...projectHeaderRate,
      },
      0,
      true
    );

    const key = getProjectCardKey(projectId, periodKey);
    setPendingDayRateSelections((previous) => ({
      ...previous,
      [key]: selectedDayRate,
    }));
    setPendingDayRateValues((previous) => ({
      ...previous,
      [key]: formatPopulatedDayRate(dayRate),
    }));
  };

  useEffect(() => {
    if (!Array.isArray(oldMileageRateDayRateByProject) || !finalList.length) return;

    setFinalList((previous) => {
      let changed = false;
      const next = previous.map((item) => {
        const projectId = item.ProjID || item.InvProjectID;
        const periodKey = item.PeriodKey || item.InvPeriodKey;
        const projectRates = getProjectHeaderRate(projectId, periodKey);

        const selectedDayRate = normalizeSelectedDayRate(
          item.selectedDayRate || item.SelectedDayRate || projectRates.selectedDayRate
        );
        const resolvedDayRate = getDayRateForSelection(
          selectedDayRate,
          { InvoiceDayRate: projectRates.dayRate, ...projectRates },
          0,
          true
        );

        if (
          String(item.MatchedDayRate) !== String(resolvedDayRate) ||
          item.selectedDayRate !== selectedDayRate
        ) {
          changed = true;
          return {
            ...item,
            MatchedDayRate: formatPopulatedDayRate(resolvedDayRate),
            selectedDayRate,
          };
        }
        return item;
      });
      return changed ? next : previous;
    });
  }, [oldMileageRateDayRateByProject, finalList]);

  // const handleChangeDayRateNEEDIMprovr = (e, type, id) => {
  //   console.log(
  //     "previousMileageRateDayRateByProject",
  //     previousMileageRateDayRateByProject
  //   );

  //   const value = e.target.value;
  //   const regex = /^\d+(\.\d{0,2})?$/;

  //   // Find index in your lists
  //   const index = finalList.findIndex(
  //     (item) => parseInt(item.ProjID) === parseInt(id)
  //   );
  //   const index1 = details.findIndex(
  //     (item) => parseInt(item.projectId) === parseInt(id)
  //   );

  //   if (index === -1) {
  //     console.error("Project not found");
  //     return;
  //   }

  //   // Update the state based on the type of rate
  //   if (type === "dayRate") {
  //     if (regex.test(value) || value === "") {
  //       finalList[index].BillableDayRate = value;
  //       details[index1].dayRate = value;
  //       setCurrentDayRate(value);
  //     }
  //   } else if (type === "mileageRate") {
  //     if (regex.test(value) || value === "") {
  //       finalList[index].MileageRate = value;
  //       details[index1].mileageRate = value;
  //       setCurrentMileageRate(value);
  //     }
  //   }
  // };

  // const totalMilesCustomer = finalList.reduce((acc, item) => {
  //   return acc + item.Miles * item.MileageRate;
  // }, 0);

  const totalChargesCustomer = finalList.reduce((acc, item) => {
    return acc + getProjectChargeTotal(item);
  }, 0);
  const totalPerDiemFin = finalList.reduce((acc, item) => {
    const totalItempers = item.selectedperiod
      .filter((period) => period.InvoiceDetailsID)
      .reduce((sum, period) => parseFloat(sum) + parseFloat(period.PerDiem), 0);
    return acc + totalItempers;
  }, 0);

  const totalMilesFinOLD = finalList.reduce((acc, item) => {
    const totalItemMiles = item.selectedperiod.reduce((sum, period) => {
      // Calculate Miles * MileageRate for each period and add it to the sum
      return sum
        ? parseFloat(sum)
        : 0 +
            (period.Miles
              ? parseFloat(period.Miles)
              : 0 * parseFloat(item.MileageRate)
              ? parseFloat(item.MileageRate)
              : 0);
    }, 0);
    return acc + totalItemMiles;
  }, 0);

  var totalMilesFin = 0;

  finalList.forEach((detail) => {
    const MileageRate = detail.MatchedMileageRate
      ? detail.MatchedMileageRate
      : 0;

    const totalMiles = detail.selectedperiod
      .filter((period) => period.InvoiceDetailsID)
      .reduce((sum, period) => {
        return sum + (period.Miles ? period.Miles : 0);
      }, 0);

    console.log("totalMilestotalMiles", MileageRate, totalMiles);

    const value = MileageRate * totalMiles;
    totalMilesFin += value;
  });

  const totalExpensesCustomer = finalList.reduce((acc, item) => {
    // Calculate total expenses for each item by summing Lodging, Copies, and Misc from selectedPeriod
    const totalItemExpenses = item.selectedperiod
      .filter((period) => period.InvoiceDetailsID)
      .reduce((sum, period) => {
        return (
          (sum ? sum : 0) +
          ((period.Lodging ? parseFloat(period.Lodging) : 0) +
            (period.Copies ? parseFloat(period.Copies) : 0) +
            (period.Misc ? parseFloat(period.Misc) : 0))
        );
      }, 0);

    // Add the totalItemExpenses to the overall total
    return acc + totalItemExpenses;
  }, 0);

  const handleSaveNewItem = async (
    headerid,
    detailid,
    index,
    key,
    ProjID,
    startDate,
    PeriodKey,
    rec
  ) => {
    console.log("handleSaveNewItem 1", headerid);
    console.log("handleSaveNewItem 2", detailid);
    console.log("handleSaveNewItem 3", index);
    console.log("handleSaveNewItem 4", key);
    console.log("handleSaveNewItem 5", ProjID);
    console.log("handleSaveNewItem 6", startDate);
    console.log("handleSaveNewItem 7", PeriodKey);
    console.log("handleSaveNewItem 8", rec);

    const PeriodKeyVal =
      rec.PeriodKey || rec.InvPeriodKey || rec.periodKey;
    const ProjectIdVal =
      rec.ProjID || rec.InvProjectID || rec.ProjectID || rec.projectId;

    PeriodKey = PeriodKey ? PeriodKey : PeriodKeyVal;
    ProjID = ProjID ? ProjID : ProjectIdVal;

    console.log("handleSaveNewItem 9", ProjID, PeriodKey);

    setHeadId(headerid);
    setBid(detailid);

    // Access Formik values directly and validate the line item at the specified index
    const isValid = validateLineItemnew(formik1.values, index);

    if (isValid) {
      upsertInvoiceDetailsFun(index, detailid, headerid, ProjID, PeriodKey); // Uncomment this if you want to submit the form
    } else {
    }
  };

  // const handleSaveNewItem = (headerid, detailid, index) => {

  //   setHeadId(headerid);
  //   setBid(detailid);

  //   // Create a copy of the touched line items or initialize it if it doesn't exist
  //   const newTouched = {
  //     lineItems: formik1.touched.lineItems
  //       ? [...formik1.touched.lineItems]
  //       : [],
  //   };

  //   // Ensure the touched line item at the specified index is updated
  //   newTouched.lineItems[index] = true;

  //   formik1.setTouched(newTouched);

  //   // Validate only the specific line item fields
  //   const fieldsToValidate = [
  //     `lineItems[${index}].billingType`,
  //     `lineItems[${index}].brokerId`,
  //     `lineItems[${index}].date`,
  //   ];

  //   const validateFieldPromises = fieldsToValidate.map((field) =>
  //     formik1.validateField(field)
  //   );

  //   Promise.all(validateFieldPromises).then(() => {
  //     const errors = fieldsToValidate.reduce((acc, field) => {
  //       const error =
  //         formik1.errors[field.split("[").join(".").split("]").join("")];
  //       if (error) acc.push(error);
  //       return acc;
  //     }, []);

  //     if (errors.length === 0) {
  //       // Prepare the data for submission for the specific line item
  //       const lineItemData = formik1.values.lineItems[index];
  //       // Submit the data for the specific line item
  //       submitLineItemData(headerid, detailid, lineItemData);
  //     } else {
  //       // formik1.setErrors()
  //     }
  //   });

  // };

  //   setHeadId(headerid);
  //   setBid(detailid);

  //   // Create a copy of the touched line items or initialize it if it doesn't exist
  //   const newTouched = {
  //     lineItems: formik1.touched.lineItems ? [...formik1.touched.lineItems] : [],
  //   };

  //   // Ensure the touched line item at the specified index is updated
  //   newTouched.lineItems[index] = true;

  //   formik1.setTouched(newTouched);

  //   // Manually validate the specific line item
  //   const errors = validateLineItemnew(formik1.values, index);
  //   formik1.setErrors(errors);

  //   if (!errors.lineItems[index]) {
  //     formik1.handleSubmit();
  //   } else {
  //   }

  // };

  const submitLineItemData = (headerid, detailid, lineItemData) => {
    // Custom logic to handle the submission of a specific line item
    // setBid(detailid);
    // setHeadId(headerid);
    // upsertInvoiceDetailsFun(lineItemData);
    // Example: You can use an API call to submit the data
    // axios.post('/api/saveLineItem', { headerid, detailid, lineItemData })
    //   .then(response => {
    //   })
    //   .catch(error => {
    //   });
  };

  let finalthrs = 0;
  let finaltlodg = 0;
  let finaltcopy = 0;
  let finaltmisc = 0;
  let finaltmileage = 0;
  let finaltmiles = 0;
  let finaltperdiem = 0;
  useEffect(() => {
    if (finalList && finalList.length > 0) {
      let thrs = 0;
      let tLodg = 0;
      let tCopy = 0;
      let tMisc = 0;
      let tMiles = 0;
      let tMileage = 0;
      let tPerDiem = 0;

      finalList.forEach((r) => {
        const { selectedPeriod = [] } = r;
        selectedPeriod.forEach((period) => {
          thrs += period.Hours;
          tLodg += period.Lodging;
          tCopy += period.Copies;
          tMisc += period.Misc;
          tMiles += period.Miles;
          tMileage += period.Mileage;
          tPerDiem += period.PerDiem;
        });
      });

      // Set the accumulated values to state
      setFinalThrs(thrs);
      setFinalTLodg(tLodg);
      setFinalTCopy(tCopy);
      setFinalTMisc(tMisc);
      setFinalTMiles(tMiles);
      setFinalTMileage(tMileage);
      setFinalTPerDiem(tPerDiem);
    }
  }, [finalList]);

  // Blur event handler to revert changes if not saved
  const handleBlur = (type) => {
    // Revert to the previous value if not saved
    if (type === "dayRate") {
      setCurrentDayRate(previousDayRate);
    } else if (type === "mileageRate") {
      setCurrentMileageRate(previousMileageRate);
    }
  };

  const handleFocusOut = (e) => {
    if (!gridRef.current.contains(e.relatedTarget)) {
      // This means that focus has moved out of the grid
      handleBlur(e, "mileageRate");
    }
  };

  const handleDayRateFocusOut = (e) => {
    if (!gridRefDay.current.contains(e.relatedTarget)) {
      // This means that focus has moved out of the grid
      handleBlur(e, "dayRate");
      handleBlur(e, "mileageRate");
    }
  };

  useEffect(() => {
    setInvoiceTotalValue(
      (
        (parseFloat(totalPerDiemFin) || 0) +
        (parseFloat(totalExpensesCustomer) || 0) +
        (parseFloat(totalMilesFin) || 0) +
        (parseFloat(totalChargesCustomer) || 0)
      ).toFixed(2)
    );
  }, [
    totalPerDiemFin,
    totalExpensesCustomer,
    totalMilesFin,
    totalChargesCustomer,
  ]);

  useEffect(() => {
    const lineItems = formik1?.values?.lineItems || [];

    // Check if any line item contains non-default values
    const hasNonDefaultValues = lineItems.some((item) => {
      const {
        brokerId,
        billingType,
        hours,
        miles,
        lodging,
        copies,
        description,
        perDiemRate,
        misc,
      } = item;

      return (
        (brokerId && brokerId?.toString()?.trim() !== "") ||
        (billingType && billingType?.toString()?.trim() !== "") ||
        (hours && hours !== "0.00") ||
        (miles && miles !== "0") ||
        (lodging && lodging !== "0.00") ||
        (copies && copies !== "0.00") ||
        (description && description?.trim() !== "") ||
        (perDiemRate && perDiemRate !== "0.00") ||
        (misc && misc !== "0.00")
      );
    });

    setAddlineItemValue(hasNonDefaultValues);
  }, [formik1?.values]);

  useEffect(() => {
    if (
      updateAddressValues.street1 !== values.street1 ||
      updateAddressValues.street2 !== values.street2 ||
      updateAddressValues.city !== values.city ||
      updateAddressValues.state != values.state ||
      updateAddressValues.zipcode !== values.zipcode
      // saveDayRate != values.dayRate ||
      // savedMilRate != values.mileageRate
    ) {
      setAddressvaluesChanged(true);
    } else {
      setAddressvaluesChanged(false);
    }
  }, [updateAddressValues, values]);

  const handleNoClick = () => {
    setShowWarningpopup(false);
    setWarningHighlightColor(true);
  };

  const handleDeleteInvoiceNoClick = () => {
    // setShowWarningpopup(false);
    setDeletedInvoicePopup(false);
  };

  const handleDeleteInvoiceYesClick = () => {
    // setShowWarningpopup(false);
    setDeletedInvoicePopup(false);
    // const newCompleted = completed;
    // newCompleted[activeStep] = true;
    // setCompleted(newCompleted);
    // setActiveStep(3);
    // setInvoiceStatus(true);
    updateInvoiceStatus(invoiceid, 4, "true");
    setShowWarningpopup(false);
    setAddressvaluesChanged(false);
    setChangedFields({});
  };

  const handleNavigateAway = () => {
    setShowWarningpopup(true);
    setBackNavigateArrow(true);
  };

  const handleYesClick = () => {
    const allAttachedFalse = selectedPeriodList.every(
      (item) => item.IsAttached === false
    );
    if (
      InvoiceTotalValue == 0 &&
      // && finalList?.length == 0
      allAttachedFalse
    ) {
      setDeletedInvoicePopup(true);
      setShowWarningpopup(false);
    } else if (backNavigateArrow) {
      navigate(INVOICE_LIST);
    } else if (closeBillingAlert) {
      // const newCompleted = completed;
      // newCompleted[activeStep] = true;
      // setCompleted(newCompleted);
      // setActiveStep(3);
      // setInvoiceStatus(true);
      updateInvoiceStatus(invoiceid, 4);
      setShowWarningpopup(false);
      setAddressvaluesChanged(false);
      setChangedFields({});
      setWarningHighlightColor(false);
      setAddlineItemValue(false);
    } else {
      // const newCompleted = completed;
      // newCompleted[activeStep] = true;
      // setCompleted(newCompleted);
      // setActiveStep(3);
      // setInvoiceStatus(true);
      updateInvoiceStatus(invoiceid, 4);
      setShowWarningpopup(false);
      setAddressvaluesChanged(false);
      setChangedFields({});
      setWarningHighlightColor(false);
      setAddlineItemValue(false);
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (
        addressvaluesChanged ||
        Object.keys(changedFields).length > 0 ||
        addlineItemValue ||
        dateFormatError !== "" ||
        hasUnsavedDayRate
      ) {
        // setShowWarning(true);
        // Synchronously update state and warn the user
        setWarningHighlightColor(true);
        event.preventDefault(); // Necessary for some browsers to trigger warning
        event.returnValue = ""; // Most browsers will show a generic message
      }
    };

    const handlePopState = (event) => {
      if (
        addressvaluesChanged ||
        Object.keys(changedFields).length > 0 ||
        addlineItemValue ||
        dateFormatError !== "" ||
        hasUnsavedDayRate
      ) {
        setShowWarningpopup(true);
        setWarningHighlightColor(true);
        setBackNavigateArrow(true);
        window.history.pushState(null, null, window.location.href);
      } else {
        // Navigate to the billingstatement page
        window.location.assign("/invoices");
      }
    };

    // Set up event listeners
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    // Initial push state to handle browser back button
    if (
      addressvaluesChanged ||
      Object.keys(changedFields).length > 0 ||
      addlineItemValue ||
      dateFormatError !== "" ||
      hasUnsavedDayRate
    ) {
      // setShowWarning(true);
      // setWarningHighlightColor(true);
      // setBackNavigateArrow(true);
      window.history.pushState(null, null, window.location.href);
    }

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [addressvaluesChanged, changedFields, addlineItemValue, hasUnsavedDayRate]);

  useEffect(() => {
    if (finalList.length > 0) {
      // Filter finalList based on projectFilterSelect
      const filteredList = finalList.filter((rec) => {
        if (projectFilterSelect === "All") {
          return true;
        }
        return rec.ProjectName === projectFilterSelect;
      });

      console.log(filteredList, "filteredListfilteredList876");
      // Create a new array for lineItems with the updated dates from the filtered list
      const updatedLineItems = filteredList
        ?.sort((a, b) => {
          // First, compare based on ProjID or InvProjectID
          const projA = a?.ProjID ? a?.ProjID : a?.InvProjectID;
          const projB = b?.ProjID ? b?.ProjID : b?.InvProjectID;

          if (projA !== projB) {
            // If ProjID (or InvProjectID) is different, sort by ProjID
            return projA - projB;
          } else {
            // If ProjID (or InvProjectID) is the same, sort by startDate, then endDate
            const dateAStart = new Date(a.startDate);
            const dateBStart = new Date(b.startDate);

            const dateAEnd = new Date(a.endDate);
            const dateBEnd = new Date(b.endDate);

            // Sort by startDate first
            if (dateAStart.getTime() !== dateBStart.getTime()) {
              return dateAStart - dateBStart;
            }

            // If startDate is the same, sort by endDate
            return dateAEnd - dateBEnd;
          }
        })
        ?.reduce((lineItems, rec) => {
          const lineItemIndex = getFormikLineItemIndex(rec);
          if (lineItemIndex < 0) return lineItems;

          if (!lineItems[lineItemIndex]?.date) {
            console.log(rec, "recrecrecrecrecrecrec");
            lineItems[lineItemIndex] = {
              ...lineItems[lineItemIndex],
              date: dayjs(rec.startDate),
            };
          }
          return lineItems;
        }, [...formik1.values.lineItems]);

      // Only update formik values if there's a change
      if (
        JSON.stringify(updatedLineItems) !==
        JSON.stringify(formik1.values.lineItems)
      ) {
        formik1.setValues((prev) => ({
          ...prev,
          lineItems: updatedLineItems,
        }));
      }
    }
  }, [finalList, lineList, projectFilterSelect, formik1.values.lineItems]); // Added projectFilterSelect to the dependency array

  const handleManulyAddYesClick = () => {
    // upsertInvoiceDetailsFun(formik1.values);
    deleteLineItemFromAPI(
      invoiceDetailsVallues,
      invoiceDeleteKey,
      invoiceDeleteIndex,
      deleteLineProjId,
      attachDettachPeriodKey
    );
    setDeletedInvoiceLineItemPopup(false);
  };

  const handleManuallyAddNoClick = () => {
    setDeletedInvoiceLineItemPopup(false);
    setInvoiceDeleteIndex("");
    setInvoiceDeleteKey("");
    setInvoiceDetailsValues("");
    setDeleteLineProjId("");
  };

  const handleProjectSelect = (event) => {
    const { value } = event.target;
    console.log(event, " evevevvvvvvv");
    getInvoiceDetails();
    setProjectFilterSelect(value);
  };
  const handleInvoiceDateClick = (event) => {
    setInvoiceDatePopup(true);
  };
  const handleInvoiceDatePopupUpdate = (event) => {
    console.log("invoiceefaytayaaij");
    upsertForTotalInsert("InvoiceDate");
    setInvoiceDatePopup(false);
  };
  const handleInvoiceDatePopupClose = (event) => {
    setInvoiceDatePopup(false);
  };

  const renderedKeys = new Set(); // To keep track of rendered keys

  const handleSaveDayRateNo = () => {
    setLoading(false);
    console.log("No button clicked");
    const key = getProjectCardKey(saveProjID, savePeriodKey);
    setPendingDayRateSelections((previous) => {
      const next = { ...previous };
      delete next[key];
      return next;
    });
    setPendingDayRateValues((previous) => {
      const next = { ...previous };
      delete next[key];
      return next;
    });
    setSaveDayRateValue(false);
    getInvoiceDetails();
  };

  const handleSaveDayRateYes = async () => {
    setLoading(false);
    console.log(
      saveProjID,
      saveCustomerId,
      savePeriodKey,
      "No button clicked",
      saveMatchedDayRate,
      saveProjectName,
      saveSelectedDayRate
    );
    const saved = await dayRateSave(
      saveProjID,
      saveCustomerId,
      savePeriodKey,
      saveMatchedDayRate,
      saveProjectName,
      saveSelectedDayRate
    );
    if (saved) {
      const key = getProjectCardKey(saveProjID, savePeriodKey);
      setPendingDayRateSelections((previous) => {
        const next = { ...previous };
        delete next[key];
        return next;
      });
      setPendingDayRateValues((previous) => {
        const next = { ...previous };
        delete next[key];
        return next;
      });
    }
    setSaveDayRateValue(false);
  };

  const handleSaveMileageRateNo = () => {
    setLoading(false);
    setSaveMileageRateValue(false);
    getInvoiceDetails();
    // Deep copy the original list to trigger re-render
    setFinalList(originalFinalList.map((item) => ({ ...item })));
    setShouldUpsert(true);
  };

  const handleSaveMileageRateYes = () => {
    setLoading(false);
    console.log(
      saveProjID,
      saveCustomerId,
      savePeriodKey,
      "No button clicked",
      saveMatchedDayRate,
      saveProjectName
    );
    mileageRateSave(
      saveProjID,
      saveCustomerId,
      savePeriodKey,
      saveMatchedDayRate,
      saveProjectName
    );
    setSaveMileageRateValue(false);
  };

  console.log(
    lineList.every((item) => item.BillingType === ""),
    "sjhajshajsahksj",
    invoiceGrandTotalVal
  );

    const upsertPerDiemLog = async (item, rec) => {
      const oldperDiemValue = lineList?.filter(
        (val) => val.InvoiceDetailsID == item?.InvoiceDetailsID
      );
  
      console.log(item, "olddddddddddddddddd", rec);
      let logData = {
        logTypeID: 74,
        logUser: getLogUserId(),
        target: invoiceid,
        target2:  rec?.InvProjectID || rec?.ProjID || item?.InvProjectID || item?.ProjectID,
          // ? item?.InvProjectID
          // : item?.ProjID || item?.ProjectID,
        description: `Invoice line was updated for ${getLogUserName()} on ${moment
          .utc(item?.Date || item?.date)
          .format("MM/DD/YYYY")} in project '${
          item.ProjectName || item?.projectName || rec?.ProjectName
        }' for customer '${
          values?.CustomerName
        }'. Data updated was: PerDiem manually updated from ${
          oldperDiemValue?.length > 0 ? oldperDiemValue[0]?.PerDiem : "0.00"
        } to ${parseFloat(item?.MatchedPerDiem || item.perDiem || item?.PerDiem).toFixed(2)}.`,
      };
  
      console.log(logData, "logggggggggg");
      const config = {
        method: "POST",
        headers: authHeader(),
        url: SYSTEM_LOG_INSERT_URL,
        data: {
          webString: enCryptFun(JSON.stringify(logData)),
        },
      };
      try {
        const resp = await API(config);
      } catch (error) {
        console.error(error);
      }
    };
  return (
    <div>
      {loading && <CustomPageLoading />}
      <Box sx={{ display: "-webkit-box" }}>
        <Sidebar higlightSide={"5"} />

        <Box
          className="invoice-form-page"
          component="main"
          sx={{ flexGrow: 1, p: "18px 20px" }}
        >
          <Navbar
            title="Invoices"
            backFlag={true}
            backRoute={
              addressvaluesChanged ||
              Object.keys(changedFields).length > 0 ||
              addlineItemValue ||
              dateFormatError !== "" ||
              hasUnsavedDayRate
                ? handleNavigateAway
                : INVOICE_LIST
            }
          />

          <Box
            sx={{
              mt: "20px",
              padding: "18px 32px !important",
              paddingTop: "0px !important",
              paddingBottom: "4px !important",
            }}
            className="bg-box invoicebg-box"
          >
            <div>
              <Accordion className="invoice-tab" defaultExpanded>
                <AccordionSummary
                  sx={{ mt: "0px" }}
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  Billing Statements in Selected Period
                </AccordionSummary>
                {
                  // selectedPeriodList && selectedPeriodList.length > 0 &&
                  //   selectedPeriodList.map((r, index) => {
                  //     const { BillingHeaderID, AttachedID } = r;
                  //     return (
                  //       <AccordionDetails
                  //         sx={{ padding: "0px 16px 4px" }}
                  //         key={r.ProjID}
                  //       >
                  //         <Box className="datebox-title">
                  //           <Typography>
                  //             {r.ProjectName}:{" "}
                  //             {moment(new Date(r.BillingStart)).format(
                  //               "MM/DD/YYYY"
                  //             )}{" "}
                  //             -{" "}
                  //             {moment(new Date(r.BillingEnd)).format(
                  //               "MM/DD/YYYY"
                  //             )}
                  //           </Typography>
                  //         </Box>
                  //         <TableContainer className="statement-date-table">
                  //           <Table
                  //             sx={{ minWidth: 650 }}
                  //             aria-label="simple table"
                  //           >
                  //             <TableHead>
                  //               <TableRow>
                  //                 <TableCell sx={{ minWidth: "103px" }}>
                  //                   Statement ID
                  //                 </TableCell>
                  //                 <TableCell>Broker Name</TableCell>
                  //                 <TableCell sx={{ minWidth: "65px" }}>
                  //                   Hours
                  //                 </TableCell>
                  //                 <TableCell sx={{ minWidth: "106px" }}>
                  //                   Last Modified
                  //                 </TableCell>
                  //                 <TableCell>Status</TableCell>
                  //                 <TableCell>Total</TableCell>
                  //                 <TableCell>Action</TableCell>
                  //               </TableRow>
                  //             </TableHead>
                  //             <TableBody>
                  //               {selectedPeriodList &&
                  //                 selectedPeriodList.map((r, index) => {
                  //                   const { BillingHeaderID, AttachedID } = r;
                  //                   return ( */}
                  //               <TableRow>
                  //                 <TableCell>{r.BillingHeaderID}</TableCell>
                  //                 <TableCell
                  //                   sx={{
                  //                     wordBreak: "break-all",
                  //                     minWidth: "222px",
                  //                     maxWidth: "222px",
                  //                   }}
                  //                 >
                  //                   {r.BrokerName}
                  //                 </TableCell>
                  //                 <TableCell>{r.Hours}</TableCell>
                  //                 <TableCell>
                  //                   {moment(new Date(r.LastModified)).format(
                  //                     "MM/DD/YYYY"
                  //                   )}
                  //                 </TableCell>
                  //                 <TableCell>
                  //                   {r.StatusID == 4 ? "Invoice Closed" : ""}
                  //                   {r.StatusID == 3 ? "Invoice started" : ""}
                  //                   {r.StatusID == 2 ? "Statement Closed" : ""}
                  //                   {r.StatusID == 1 ? "Statement Open" : ""}
                  //                 </TableCell>
                  //                 <TableCell>${r.Total}</TableCell>
                  //                 <TableCell>
                  //                   <Stack
                  //                     className="action-icons"
                  //                     direction="row"
                  //                     spacing={1}
                  //                   >
                  //                     <Tooltip
                  //                       arrow
                  //                       className="project-tooltip"
                  //                       title="Click here to get all attachments for this statement."
                  //                       placement="top"
                  //                     >
                  //                       {downloadLoading ? (
                  //                         <Box class="download-btn-disable">
                  //                           <DownloadIcon
                  //                             style={{
                  //                               background: "#d5d5d6 !important",
                  //                               important: "true",
                  //                             }}
                  //                           />
                  //                         </Box>
                  //                       ) : (
                  //                         <img
                  //                           src={Download}
                  //                           onClick={() => {
                  //                             if (invoiceStatus == true) {
                  //                               showToast(
                  //                                 "This invoice has been closed and can no longer be edited.",
                  //                                 "reopenInvoice"
                  //                               );
                  //                             } else {
                  //                               getInvoiceAttachments(
                  //                                 r.ProjID,
                  //                                 r.UserID,
                  //                                 r.PeriodKey,
                  //                                 "download"
                  //                               );
                  //                             }
                  //                           }}
                  //                         />
                  //                       )}
                  //                     </Tooltip>
                  //                     <Tooltip
                  //                       arrow
                  //                       className="project-tooltip"
                  //                       title="Click here to print this statement."
                  //                       placement="top"
                  //                     >
                  //                       <img
                  //                         src={Print}
                  //                         onClick={() => {
                  //                           if (BillingHeaderID) {
                  //                             window.open(
                  //                               `/print-billing-statements/${BillingHeaderID}`,
                  //                               "_blank"
                  //                             );
                  //                           }
                  //                           // printInvoice(r, BillingStatementID);
                  //                         }}
                  //                       />
                  //                     </Tooltip>
                  //                     {invoiceStatus == true ? (
                  //                       <></>
                  //                     ) : r.IsAttached == false ? (
                  //                       <Tooltip
                  //                         arrow
                  //                         className="project-tooltip"
                  //                         title="Click here to attach this statement to the invoice. This will import all details for this statement."
                  //                         placement="top"
                  //                       >
                  //                         <img
                  //                           src={AttachmentGreen}
                  //                           disabled={invoiceStatus}
                  //                           onClick={() => {
                  //                             handleAttach(
                  //                               BillingHeaderID,
                  //                               AttachedID,
                  //                               r.IsAttached,
                  //                               r.BrokerName,
                  //                               r.ProjectName,
                  //                               r.ProjID,
                  //                               r.customerId
                  //                             );
                  //                           }}
                  //                         />
                  //                       </Tooltip>
                  //                     ) : (
                  //                       <Tooltip
                  //                         arrow
                  //                         className="project-tooltip"
                  //                         title="Click here to detach this statement from the invoice. This will REMOVE all details from this invoice."
                  //                         placement="top"
                  //                       >
                  //                         <img
                  //                           src={AttachmentRed}
                  //                           onClick={() => {
                  //                             handleDetach(
                  //                               BillingHeaderID,
                  //                               AttachedID,
                  //                               r.IsAttached,
                  //                               r.BrokerName,
                  //                               r.ProjectName,
                  //                               r.ProjID,
                  //                               r.customerId
                  //                             );
                  //                           }}
                  //                           // onClick={() => {
                  //                           //   getInvoiceAttachments(
                  //                           //     r.ProjID,
                  //                           //     r.UserID,
                  //                           //     r.PeriodKey,
                  //                           //     "detach"
                  //                           //   );
                  //                           // }}
                  //                         />
                  //                       </Tooltip>
                  //                     )}
                  //                   </Stack>
                  //                 </TableCell>
                  //               </TableRow>
                  //               {/* );
                  //                 })} */}
                  //             </TableBody>
                  //           </Table>
                  //         </TableContainer>
                  //       </AccordionDetails>
                  //     );
                  //   })
                }

                {attachDettachLoading && (
                  <AccordionDetails
                    sx={{
                      padding: "0px 16px 4px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%", // Optional: set height to fill the container
                    }}
                    key={1}
                  >
                    <CircularProgress disableShrink />
                  </AccordionDetails>
                )}

                {!attachDettachLoading ? (
                  selectedPeriodList?.length > 0 ? (
                    !attachDettachLoading &&
                    Object.values(
                      selectedPeriodList.reduce((groupedData, entry) => {
                        const key = `${entry.ProjID}-${entry.PeriodKey}`;
                        if (!groupedData[key]) {
                          groupedData[key] = {
                            ProjID: entry.ProjID,
                            PeriodKey: entry.PeriodKey,
                            entries: [],
                            ProjectName: entry.ProjectName,
                            BillingStart: entry.BillingStart,
                            BillingEnd: entry.BillingEnd,
                          };
                        }
                        groupedData[key].entries.push(entry);
                        return groupedData;
                      }, {})
                    )
                      ?.sort((a, b) => {
                        // First, compare based on ProjID or InvProjectID
                        const projA = a?.ProjID || a?.InvProjectID;
                        const projB = b?.ProjID || b?.InvProjectID;

                        if (projA !== projB) {
                          // If ProjID (or InvProjectID) is different, sort by ProjID
                          return projA - projB;
                        } else {
                          // If ProjID (or InvProjectID) is the same, sort by startDate, then endDate
                          const dateAStart = new Date(a.BillingStart);
                          const dateBStart = new Date(b.BillingStart);

                          const dateAEnd = new Date(a.BillingEnd);
                          const dateBEnd = new Date(b.BillingEnd);

                          // Sort by startDate first
                          if (dateAStart.getTime() !== dateBStart.getTime()) {
                            return dateAStart - dateBStart;
                          }

                          // If startDate is the same, sort by endDate
                          return dateAEnd - dateBEnd;
                        }
                      })
                      .map((group) => {
                        const groupKey = `${group.ProjID}-${group.PeriodKey}`;

                        if (renderedKeys.has(groupKey)) {
                          return null;
                        }

                        renderedKeys.add(groupKey);

                        return (
                          <AccordionDetails
                            sx={{ padding: "0px 16px 4px" }}
                            key={groupKey}
                          >
                            <Box className="datebox-title">
                              <Typography>
                                {group.ProjectName}:{" "}
                                {moment(new Date(group.BillingStart))
                                  .utc()
                                  .format("MM/DD/YYYY")}{" "}
                                -{" "}
                                {moment(new Date(group.BillingEnd))
                                  .utc()
                                  .format("MM/DD/YYYY")}
                              </Typography>
                            </Box>
                            <TableContainer className="statement-date-table">
                              <Table
                                sx={{ minWidth: 650 }}
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell sx={{ minWidth: "103px" }}>
                                      Statement ID
                                    </TableCell>
                                    <TableCell>Broker Name</TableCell>
                                    <TableCell sx={{ minWidth: "65px" }}>
                                      Hours
                                    </TableCell>
                                    <TableCell sx={{ minWidth: "106px" }}>
                                      Last Modified
                                    </TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Total</TableCell>
                                    <TableCell>Action</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {group.entries
                                    .filter(
                                      (entry, index, self) =>
                                        index ===
                                        self.findIndex(
                                          (e) =>
                                            e.BillingHeaderID ===
                                            entry.BillingHeaderID
                                        )
                                    )
                                    .map((entry) => (
                                      <TableRow key={entry.BillingHeaderID}>
                                        <TableCell>
                                          {entry.BillingHeaderID}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            wordBreak: "break-all",
                                            minWidth: "222px",
                                            maxWidth: "222px",
                                          }}
                                        >
                                          {entry.BrokerName}
                                        </TableCell>
                                        <TableCell>
                                          {entry.Hours?.toFixed(2)}
                                        </TableCell>
                                        <TableCell>
                                          {moment(new Date(entry.LastModified))
                                            .utc()
                                            .format("MM/DD/YYYY")}
                                        </TableCell>
                                        <TableCell>
                                          {entry.StatusID === 4
                                            ? "Invoice Closed"
                                            : entry.StatusID === 3
                                            ? "Invoice Started"
                                            : entry.StatusID === 2
                                            ? "Statement Closed"
                                            : entry.StatusID === 1
                                            ? "Statement Open"
                                            : ""}
                                        </TableCell>
                                        <TableCell>
                                          ${entry?.Total?.toFixed(2)}
                                        </TableCell>
                                         <TableCell>
                                           <Stack
                                             className="action-icons"
                                            direction="row"
                                            spacing={1}
                                          >
                                            <TableCell>
                                              <Stack
                                                className="action-icons"
                                                direction="row"
                                                spacing={1}
                                              >
                                                <TableCell>
                                                  <Stack
                                                    className="action-icons"
                                                    direction="row"
                                                    spacing={1}
                                                  >
                                                    <Tooltip
                                                      arrow
                                                      className="project-tooltip"
                                                      title="Click here to get all attachments for this statement."
                                                      placement="top"
                                                    >
                                                      {downloadLoading ? (
                                                        <Box class="download-btn-disable">
                                                          <DownloadIcon
                                                            style={{
                                                              background:
                                                                "#d5d5d6 !important",
                                                              important: "true",
                                                            }}
                                                          />
                                                        </Box>
                                                      ) : (
                                                        <img
                                                          src={Download}
                                                          onClick={() => {
                                                            // if (
                                                            //   invoiceStatus ==
                                                            //   true
                                                            // ) {
                                                            //   showToast(
                                                            //     "This invoice has been closed and can no longer be edited.",
                                                            //     "reopenInvoice"
                                                            //   );
                                                            // } else {
                                                            getInvoiceAttachments(
                                                              entry.ProjID,
                                                              entry.UserID,
                                                              entry.PeriodKey,
                                                              "download",
                                                              entry
                                                            );
                                                            // }
                                                          }}
                                                        />
                                                      )}
                                                    </Tooltip>
                                                    <Tooltip
                                                      arrow
                                                      className="project-tooltip"
                                                      title="Click here to print this statement."
                                                      placement="top"
                                                    >
                                                      <img
                                                        src={Print}
                                                        onClick={() => {
                                                          if (
                                                            entry.BillingHeaderID
                                                          ) {
                                                            window.open(
                                                              `/print-billing-statement/${entry.BillingHeaderID}`,
                                                              "_blank"
                                                            );
                                                          }
                                                          // printInvoice(r, BillingStatementID);
                                                        }}
                                                      />
                                                    </Tooltip>
                                                    {invoiceStatus == true ? (
                                                      <></>
                                                    ) : entry.IsAttached ==
                                                      false ? (
                                                      <Tooltip
                                                        arrow
                                                        className="project-tooltip"
                                                        title="Click here to attach this statement to the invoice. This will import all details for this statement."
                                                        placement="top"
                                                      >
                                                        <img
                                                          src={AttachmentGreen}
                                                          disabled={
                                                            invoiceStatus
                                                          }
                                                          onClick={() => {
                                                            handleAttach(
                                                              entry.BillingHeaderID,
                                                              entry.AttachedID,
                                                              entry.IsAttached,
                                                              entry.BrokerName,
                                                              entry.ProjectName,
                                                              entry.ProjID,
                                                              entry.customerId,
                                                              entry.PeriodKey,
                                                              entry
                                                            );
                                                          }}
                                                        />
                                                      </Tooltip>
                                                    ) : (
                                                      <Tooltip
                                                        arrow
                                                        className="project-tooltip"
                                                        title="Click here to detach this statement from the invoice. This will REMOVE all details from this invoice."
                                                        placement="top"
                                                      >
                                                        <img
                                                          src={AttachmentRed}
                                                          onClick={() => {
                                                            handleDetach(
                                                              entry.BillingHeaderID,
                                                              entry.AttachedID,
                                                              entry.IsAttached,
                                                              entry.BrokerName,
                                                              entry.ProjectName,
                                                              entry.ProjID,
                                                              entry.customerId,
                                                              entry.PeriodKey,
                                                              entry
                                                            );
                                                          }}

                                                          // onClick={() => {
                                                          //   getInvoiceAttachments(
                                                          //     entry.ProjID,
                                                          //     entry.UserID,
                                                          //     entry.PeriodKey,
                                                          //     "detach"
                                                          //   );
                                                          // }}
                                                        />
                                                      </Tooltip>
                                                    )}
                                                  </Stack>
                                                </TableCell>
                                              </Stack>
                                            </TableCell>
                                          </Stack>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </AccordionDetails>
                        );
                      })
                  ) : (
                    <Typography
                      sx={{ marginTop: "10px", marginBottom: "10px" }}
                    >
                      No invoice found for the selected period.
                    </Typography>
                  )
                ) : (
                  ""
                )}
              </Accordion>
            </div>
          </Box>
          <Grid
            container
            rowSpacing={1}
            columnspacing={{ xs: 1, sm: 1.5, md: 1.5 }}
          >
            <Grid xs={12} md={9}>
              <Box
                sx={{
                  p: "16px 17px",
                  pb: "9px",
                  mt: "22px",
                }}
                className="bg-box"
              >
                <Box
                  sx={{
                    position: { xs: "unset", sm: "sticky" },
                    top: "0px",
                    zIndex: 9,
                    borderBottom: "12px solid #fff",
                    paddingTop: "16px",
                    borderTop: "12px solid #fff",
                    marginTop: "-12px",
                    borderRadius: "0px",
                  }}
                  className="billing-box"
                >
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography className="billing-title">
                      Invoice No:
                    </Typography>
                    <Typography
                      sx={{ background: "#58A84A" }}
                      className="bill-date"
                    >
                      #{values.invoiceNo}
                    </Typography>
                  </Stack>
                  <Stack
                    sx={{ mt: "15px" }}
                    direction={{ xs: "column", sm: "row" }}
                    alignItems={{ xs: "flex-end", sm: "center" }}
                    spacing={{ xs: 2, sm: 3 }}
                  >
                    <FormControl
                      className="consolidated-date"
                      sx={{ width: "100%" }}
                      variant="standard"
                    >
                      <p className="label">Invoice Date: </p>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker"]}>
                          <DemoItem>
                            <DatePicker
                              disabled={invoiceStatus}
                              // defaultValue={dayjs()}
                              name="invoiceDate"
                              // disablePast
                              views={["year", "month", "day"]}
                              // onChange={handleChangeDate}
                              onChange={(e) => {
                                handleChangeDate(e, "invoiceDate");
                              }}
                              value={
                                values.invoiceDate
                                  ? dayjs.utc(values.invoiceDate)
                                  : dayjs.utc()
                              }
                            />
                          </DemoItem>
                        </DemoContainer>
                      </LocalizationProvider>
                      <FormHelperText error={true}>
                        {dateFormatError}
                      </FormHelperText>
                    </FormControl>
                    <Button
                      sx={{ mt: "4% !important", marginLeft: "9px !important" }}
                      className={
                        invoiceStatus ||
                        dateFormatError !== "" ||
                        dayjs
                          .utc(periousInvoiceDate)
                          .isSame(dayjs.utc(values.invoiceDate), "day") // Use isSame for date comparison
                          ? "disable-filter-btn"
                          : "primary-btn"
                      }
                      disabled={
                        invoiceStatus ||
                        dateFormatError !== "" ||
                        dayjs
                          .utc(periousInvoiceDate)
                          .isSame(dayjs.utc(values.invoiceDate), "day") // Use isSame for disabling logic
                      }
                      onClick={handleInvoiceDateClick}
                    >
                      Save
                    </Button>
                    <FormControl
                      className="consolidated-date"
                      sx={{ width: "100%" }}
                      variant="standard"
                    >
                      <p className="label">Create Date: </p>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker"]}>
                          <DemoItem>
                            <DatePicker
                              disabled
                              disablePast
                              views={["year", "month", "day"]}
                              onChange={(e) => {
                                handleChangeDate(e, "createDate");
                              }}
                              value={values.createDate}
                            />
                          </DemoItem>
                        </DemoContainer>
                      </LocalizationProvider>
                    </FormControl>
                    <Box className="invoice-total">
                      <Typography className="invoice-total-title">
                        Invoice Total:
                      </Typography>
                      <Typography className="invoice-total-amount">
                        {/* ${InvoiceTotalValue ? InvoiceTotalValue : "0.00"} */}
                        ${invoiceGrandTotalVal ? invoiceGrandTotalVal : "0.00"}
                      </Typography>
                    </Box>
                  </Stack>
                </Box>
                <Box sx={{ width: "100%", mt: "7px" }}>
                  <Stepper
                    className="bill-stepper"
                    nonLinear
                    activeStep={activeStep}
                  >
                    {steps.map((label, index) => {
                      return (
                        <Step key={label} completed={completed[index]}>
                          <StepButton
                            className={activeStep == index ? "step-active" : ""}
                            color="inherit"
                            onClick={handleStep(index)}
                          >
                            {index < activeStep ? (
                              // {completed[index] && index === 0 ? (
                              <img src={CircleGreenIconSvg} alt="Completed" />
                            ) : (
                              <CircleIcon />
                            )}
                            {label}
                          </StepButton>
                        </Step>
                      );
                    })}
                  </Stepper>

                  <Typography sx={{ mt: "7px", mb: 1, py: 1, pt: 0 }}>
                    <Box className="billing-box">
                      <Grid
                        sx={{ ml: "0 !important", mt: "0px !important" }}
                        container
                        rowSpacing={3}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                      >
                        <Grid className="bill-fieldsbox" xs={12} md={5}>
                          <Typography className="bill-to-title">
                            Bill to: {values && values.CustomerName}
                          </Typography>
                          <Stack
                            sx={{ mt: "16px" }}
                            direction={{ xs: "column", sm: "row" }}
                            spacing={2}
                            alignItems={{ xs: "baseline", sm: "center" }}
                          >
                            <p className="label">Street 1:</p>
                            <FormControl
                              sx={{
                                minWidth: "100px",
                              }}
                              variant="standard"
                            >
                              <TextField
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                      border:
                                        updateAddressValues.street1 !==
                                          values.street1 &&
                                        warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Default border color
                                    },
                                    "&:hover fieldset": {
                                      borderBottom:
                                        updateAddressValues.street1 !==
                                          values.street1 &&
                                        warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Border color when hovered
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderBottom:
                                        updateAddressValues.street1 !==
                                          values.street1 &&
                                        warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Border color when focused
                                    },
                                  },
                                }}
                                id="outlined-multiline-static"
                                disabled={invoiceStatus}
                                name="street1"
                                onChange={handleChange}
                                value={values.street1}
                                error={errors.street1 && touched.street1}
                                helperText={
                                  errors.street1 && touched.street1
                                    ? errors.street1
                                    : ""
                                }
                                inputProps={{
                                  maxLength: 250, // Restrict input length to 250 characters
                                }}
                              />
                            </FormControl>
                          </Stack>
                          <Stack
                            sx={{ mt: "10px" }}
                            direction={{ xs: "column", sm: "row" }}
                            spacing={2}
                            alignItems={{ xs: "baseline", sm: "center" }}
                          >
                            <p className="label">Street 2:</p>
                            <FormControl
                              sx={{
                                minWidth: "100px",
                              }}
                              variant="standard"
                            >
                              <TextField
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                      border:
                                        updateAddressValues.street2 !==
                                          values.street2 &&
                                        warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Default border color
                                    },
                                    "&:hover fieldset": {
                                      borderBottom:
                                        updateAddressValues.street2 !==
                                          values.street2 &&
                                        warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Border color when hovered
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderBottom:
                                        updateAddressValues.street2 !==
                                          values.street2 &&
                                        warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Border color when focused
                                    },
                                  },
                                }}
                                disabled={invoiceStatus}
                                id="outlined-multiline-static"
                                defaultValue=""
                                name="street2"
                                onChange={handleChange}
                                value={values.street2}
                                error={errors.street2 && touched.street2}
                                helperText={
                                  errors.street2 && touched.street2
                                    ? errors.street2
                                    : ""
                                }
                                inputProps={{
                                  maxLength: 250, // Restrict input length to 250 characters
                                }}
                              />
                            </FormControl>
                          </Stack>
                          <Stack
                            sx={{ mt: "10px" }}
                            direction={{ xs: "column", sm: "row" }}
                            spacing={2}
                            alignItems={{ xs: "baseline", sm: "center" }}
                          >
                            <p className="label">City:</p>
                            <FormControl
                              sx={{
                                minWidth: "100px",
                              }}
                              variant="standard"
                            >
                              <TextField
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                      border:
                                        updateAddressValues.city !==
                                          values.city && warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Default border color
                                    },
                                    "&:hover fieldset": {
                                      borderBottom:
                                        updateAddressValues.city !==
                                          values.city && warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Border color when hovered
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderBottom:
                                        updateAddressValues.city !==
                                          values.city && warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Border color when focused
                                    },
                                  },
                                }}
                                id="city"
                                disabled={invoiceStatus}
                                defaultValue=""
                                name="city"
                                onChange={handleChange}
                                value={values.city}
                                error={errors.city && touched.city}
                                helperText={
                                  errors.city && touched.city ? errors.city : ""
                                }
                                inputProps={{
                                  maxLength: 50, // Restrict input length to 250 characters
                                }}
                              />
                            </FormControl>
                          </Stack>
                          <Stack
                            sx={{ mt: "10px" }}
                            direction={{ xs: "column", sm: "row" }}
                            spacing={2}
                            alignItems={{ xs: "baseline", sm: "center" }}
                          >
                            <p className="label">State:</p>
                            <FormControl
                              sx={{
                                minWidth: "100px",
                              }}
                              variant="standard"
                            >
                              <Select
                                sx={{
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    border:
                                      updateAddressValues.state !== values &&
                                      values.state
                                        ? values.state
                                        : 1 && warningHighlightColor
                                        ? "1px solid yellow"
                                        : "", // Conditionally apply yellow border
                                    borderWidth:
                                      updateAddressValues.state !== values &&
                                      values.state
                                        ? values.state
                                        : 1 && warningHighlightColor
                                        ? "1px"
                                        : "", // Adjust border width if needed
                                    outline:
                                      updateAddressValues.state !== values &&
                                      values.state
                                        ? values.state
                                        : 1 && warningHighlightColor
                                        ? "1px solid yellow"
                                        : "",
                                  },
                                  "& .MuiSelect-select": {
                                    borderColor:
                                      updateAddressValues.state !== values &&
                                      values.state
                                        ? values.state
                                        : 1 && warningHighlightColor
                                        ? "1px solid yellow"
                                        : "", // Border color on hover
                                  },
                                }}
                                className="invoice-state-field cnsd-state-field"
                                // sx={{ pl: "0px !important" }}
                                name="state"
                                onChange={handleChange}
                                disabled={invoiceStatus}
                                value={
                                  values && values.state ? values.state : 1
                                }
                                autoWidth
                                label="State"
                                error={errors.state && touched.state}
                                helperText={
                                  errors.state && touched.state
                                    ? errors.state
                                    : ""
                                }
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {stateList &&
                                  (() => {
                                    try {
                                      const parsedStateList =
                                        JSON.parse(stateList);
                                      return parsedStateList.data.map(
                                        (item) => (
                                          <MenuItem
                                            key={item.countyId}
                                            value={item.countyId}
                                          >
                                            {item.name}
                                          </MenuItem>
                                        )
                                      );
                                    } catch (e) {
                                      console.error(
                                        "Error parsing stateList:",
                                        e
                                      );
                                      return null;
                                    }
                                  })()}
                              </Select>
                              {errors.state && touched.state && (
                                <FormHelperText error={true}>
                                  {errors.state}
                                </FormHelperText>
                              )}
                            </FormControl>
                          </Stack>
                          <Stack
                            sx={{ mt: "10px" }}
                            direction={{ xs: "column", sm: "row" }}
                            spacing={2}
                            alignItems={{ xs: "baseline", sm: "center" }}
                          >
                            <p className="label">Zipcode: </p>
                            <FormControl
                              sx={{
                                minWidth: "100px",
                              }}
                              variant="standard"
                            >
                              <TextField
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                      border:
                                        updateAddressValues.zipcode !==
                                          values.zipcode &&
                                        warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Default border color
                                    },
                                    "&:hover fieldset": {
                                      borderBottom:
                                        updateAddressValues.zipcode !==
                                          values.zipcode &&
                                        warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Border color when hovered
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderBottom:
                                        updateAddressValues.zipcode !==
                                          values.zipcode &&
                                        warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Border color when focused
                                    },
                                  },
                                }}
                                id="outlined-multiline-static"
                                defaultValue=""
                                disabled={invoiceStatus}
                                name="zipcode"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (
                                    /^[0-9]*$/.test(value) &&
                                    value.length <= 10
                                  ) {
                                    handleChange(e);
                                  }
                                }}
                                value={values.zipcode}
                                error={errors.zipcode && touched.zipcode}
                                helperText={
                                  errors.zipcode && touched.zipcode
                                    ? errors.zipcode
                                    : ""
                                }
                              />
                            </FormControl>
                          </Stack>
                          <Button
                            sx={{
                              mt: "12px",
                              ml: { xs: "0px", sm: "74px" },
                              mb: { xs: "20px", sm: "0px" },
                            }}
                            className={
                              invoiceStatus ||
                              addressvaluesChanged == false ||
                              addressButtonLoading
                                ? "disable-filter-btn"
                                : "primary-btn"
                            }
                            onClick={handleSubmit}
                            disabled={
                              invoiceStatus ||
                              addressvaluesChanged == false ||
                              addressButtonLoading
                            }
                          >
                            Save bill to address
                          </Button>
                        </Grid>
                        <Grid xs={12} md={7}>
                          <Grid
                            sx={{ ml: "0 !important", mt: "0px !important" }}
                            container
                            rowSpacing={2}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                          >
                            <Grid xs={12} md={6}>
                              <Typography className="state-titles">
                                Per Diem:
                                <span>
                                  <span
                                    style={{
                                      position: "absolute",
                                      fontSize: "15px",
                                      cursor: "pointer",
                                    }}
                                    aria-owns={
                                      open ? "mouse-over-popover" : undefined
                                    }
                                    aria-haspopup="true"
                                    onMouseEnter={handlePopoverOpenPerDiem}
                                    onMouseLeave={handlePopoverClosePerDiem}
                                    class="material-symbols-outlined"
                                  >
                                    help
                                  </span>
                                </span>
                              </Typography>
                              <Popover
                                className="charges-box"
                                id="mouse-over-popover"
                                sx={{
                                  pointerEvents: "none",
                                }}
                                open={openPerDiem}
                                anchorEl={anchorElPerDiem}
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "center",
                                }}
                                transformOrigin={{
                                  vertical: "bottom",
                                  horizontal: "center",
                                }}
                                onClose={handlePopoverClose}
                                disableRestoreFocus
                              >
                                <Typography className="charges-title">
                                  Total Per Diem
                                </Typography>
                                {finalList &&
                                  finalList.map((value, index) => {
                                    let tperdiem = 0;
                                    value.selectedperiod
                                      .filter(
                                        (period) => period.InvoiceDetailsID
                                      )
                                      .forEach((period) => {
                                        tperdiem += period.PerDiem;
                                      });
                                    console.log(
                                      tperdiem,
                                      value,
                                      "tperdiemtperdiem",
                                      value.PerDiem,
                                      (value
                                        ? (tperdiem ? tperdiem : 0) *
                                          (value.PerDiem ? value.PerDiem : 0)
                                        : 0
                                      ).toFixed(2)
                                    );
                                    return (
                                      <Box>
                                        <Box class="time-flexbox">
                                          <Typography className="charge-price">
                                            {finalList?.length === index + 1
                                              ? "+"
                                              : ""}{" "}
                                            $
                                            {/* {value &&
                                              tMiles * value.MileageRate} */}
                                            {(value
                                              ? tperdiem
                                                ? tperdiem
                                                : 0
                                              : 0
                                            ).toFixed(2)}
                                          </Typography>
                                          <Typography className="charge-text">
                                            {value.ProjectName}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    );
                                  })}
                                <Divider
                                  sx={{
                                    borderColor: "#F2F4F8",
                                    margin: "5px 0px",
                                  }}
                                />
                                <Box class="time-flexbox time-btn">
                                  <Typography className="charge-price total-charge">
                                    ${totalPerDiemFin.toFixed(2)}
                                  </Typography>
                                  <Typography className="charge-text">
                                    Total Per Diem
                                  </Typography>
                                </Box>
                              </Popover>
                              <Typography className="state-values">
                                ${Number(totalPerDiemFin).toFixed(2)}
                              </Typography>
                              <Typography
                                sx={{ position: "relative" }}
                                className="state-titles"
                              >
                                Mileage:
                                <span>
                                  <span
                                    style={{
                                      position: "absolute",
                                      fontSize: "15px",
                                      cursor: "pointer",
                                    }}
                                    aria-owns={
                                      open ? "mouse-over-popover" : undefined
                                    }
                                    aria-haspopup="true"
                                    onMouseEnter={handlePopoverOpen2}
                                    onMouseLeave={handlePopoverClose2}
                                    class="material-symbols-outlined"
                                  >
                                    help
                                  </span>
                                </span>
                              </Typography>
                              <Popover
                                className="charges-box"
                                id="mouse-over-popover"
                                sx={{
                                  pointerEvents: "none",
                                }}
                                open={open2}
                                anchorEl={anchorEl2}
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "center",
                                }}
                                transformOrigin={{
                                  vertical: "bottom",
                                  horizontal: "center",
                                }}
                                onClose={handlePopoverClose}
                                disableRestoreFocus
                              >
                                <Typography className="charges-title">
                                  Total Mileage
                                </Typography>
                                {finalList &&
                                  finalList.map((value, index) => {
                                    let tMiles = 0;
                                    value.selectedperiod
                                      .filter(
                                        (period) => period.InvoiceDetailsID
                                      )
                                      .forEach((period) => {
                                        tMiles += period.Miles;
                                      });
                                    return (
                                      <Box>
                                        <Box class="time-flexbox">
                                          <Typography className="charge-price">
                                            {finalList?.length === index + 1
                                              ? "+"
                                              : ""}{" "}
                                            $
                                            {/* {value &&
                                              tMiles * value.MileageRate} */}
                                            {(value
                                              ? (tMiles ? tMiles : 0) *
                                                (value.MatchedMileageRate
                                                  ? value.MatchedMileageRate
                                                  : 0)
                                              : 0
                                            ).toFixed(3)}
                                          </Typography>
                                          <Typography className="charge-text">
                                            {value.ProjectName}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    );
                                  })}
                                <Divider
                                  sx={{
                                    borderColor: "#F2F4F8",
                                    margin: "5px 0px",
                                  }}
                                />
                                <Box class="time-flexbox time-btn">
                                  <Typography className="charge-price total-charge">
                                    ${totalMilesFin.toFixed(3)}
                                  </Typography>
                                  <Typography className="charge-text">
                                    Total Mileage
                                  </Typography>
                                </Box>
                              </Popover>
                              <Typography className="state-values">
                                ${totalMilesFin.toFixed(3)}
                              </Typography>
                              {/*
                              <Typography className="state-titles">
                                Mileage Rate: 
                              </Typography>
                              <Typography
                                sx={{ mb: "0 !important" }}
                                className="state-values"
                              >
                                test{" "}
                              </Typography> */}
                            </Grid>
                            <Grid xs={12} md={6}>
                              <Typography className="state-titles">
                                Expenses:
                                <span>
                                  <span
                                    style={{
                                      position: "absolute",
                                      fontSize: "15px",
                                      cursor: "pointer",
                                    }}
                                    aria-owns={
                                      openExpenses
                                        ? "mouse-over-popover"
                                        : undefined
                                    }
                                    aria-haspopup="true"
                                    onMouseEnter={handlePopoverOpen1Expenses}
                                    onMouseLeave={handlePopoverClose1Expenses}
                                    class="material-symbols-outlined"
                                  >
                                    help
                                  </span>
                                </span>
                              </Typography>
                              <Popover
                                className="charges-box"
                                id="mouse-over-popover"
                                sx={{
                                  pointerEvents: "none",
                                }}
                                open={openExpenses}
                                anchorEl={anchorExpenses}
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "center",
                                }}
                                transformOrigin={{
                                  vertical: "bottom",
                                  horizontal: "center",
                                }}
                                onClose={handlePopoverClose1Expenses}
                                disableRestoreFocus
                              >
                                <Typography className="charges-title">
                                  Total Expenses
                                </Typography>
                                {finalList &&
                                  finalList.map((value, index) => {
                                    let thrs = 0;
                                    let tlodg = 0;
                                    let tcopy = 0;
                                    let tmisc = 0;
                                    let tmileage = 0;
                                    let tmiles = 0;
                                    let tperdiem = 0;
                                    value.selectedperiod
                                      .filter(
                                        (period) => period.InvoiceDetailsID
                                      )
                                      .forEach((period) => {
                                        thrs += period.Hours
                                          ? parseFloat(period.Hours)
                                          : 0;
                                        tlodg += period.Lodging
                                          ? parseFloat(period.Lodging)
                                          : 0;
                                        tcopy += period.Copies
                                          ? parseFloat(period.Copies)
                                          : 0;
                                        tmisc += period.Misc
                                          ? parseFloat(period.Misc)
                                          : 0;
                                        tmiles += period.Miles
                                          ? parseFloat(period.Miles)
                                          : 0;
                                        finaltmileage += period.Mileage
                                          ? parseFloat(period.Mileage)
                                          : 0;
                                        tperdiem += period.PerDiem
                                          ? parseFloat(period.PerDiem)
                                          : 0;
                                      });
                                    return (
                                      <Box>
                                        <Box class="time-flexbox">
                                          <Typography className="charge-price">
                                            {finalList?.length === index + 1
                                              ? "+"
                                              : ""}{" "}
                                            $
                                            {(
                                              Number(tlodg) +
                                              Number(tcopy) +
                                              Number(tmisc)
                                            ).toFixed(2)}
                                          </Typography>
                                          <Typography className="charge-text">
                                            {value.ProjectName}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    );
                                  })}
                                <Divider
                                  sx={{
                                    borderColor: "#F2F4F8",
                                    margin: "5px 0px",
                                  }}
                                />
                                <Box class="time-flexbox time-btn">
                                  <Typography className="charge-price total-charge">
                                    ${totalExpensesCustomer.toFixed(2)}
                                  </Typography>
                                  <Typography className="charge-text">
                                    Total Expenses
                                  </Typography>
                                </Box>
                              </Popover>
                              <Typography className="state-values">
                                ${totalExpensesCustomer.toFixed(2)}
                              </Typography>

                              <Typography
                                sx={{ position: "relative" }}
                                className="state-titles"
                              >
                                Charges:
                                <span>
                                  <span
                                    style={{
                                      position: "absolute",
                                      fontSize: "15px",
                                      cursor: "pointer",
                                    }}
                                    aria-owns={
                                      open1 ? "mouse-over-popover" : undefined
                                    }
                                    aria-haspopup="true"
                                    onMouseEnter={handlePopoverOpen1}
                                    onMouseLeave={handlePopoverClose1}
                                    class="material-symbols-outlined"
                                  >
                                    help
                                  </span>
                                </span>
                              </Typography>
                              <Popover
                                className="charges-box"
                                id="mouse-over-popover"
                                sx={{
                                  pointerEvents: "none",
                                }}
                                open={open1}
                                anchorEl={anchorEl1}
                                // anchorReference="anchorPosition"
                                // anchorPosition={{ top: 420, left: 800 }}
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "center",
                                }}
                                transformOrigin={{
                                  vertical: "bottom",
                                  horizontal: "center",
                                }}
                                onClose={handlePopoverClose1}
                                disableRestoreFocus
                              >
                                <Typography className="charges-title">
                                  Total Charges
                                </Typography>
                                {finalList &&
                                  finalList.map((value, index) => {
                                    const calculatedValue = getProjectChargeTotal(value);

                                    return (
                                      <Box key={index}>
                                        <Box className="time-flexbox">
                                          <Typography className="charge-price">
                                            {finalList?.length === index + 1
                                              ? "+"
                                              : ""}{" "}
                                            ${calculatedValue.toFixed(2)}
                                          </Typography>
                                          <Typography className="charge-text">
                                            {value.ProjectName}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    );
                                  })}

                                <Divider
                                  sx={{
                                    borderColor: "#F2F4F8",
                                    margin: "5px 0px",
                                  }}
                                />
                                <Box class="time-flexbox time-btn">
                                  <Typography className="charge-price total-charge">
                                    ${totalChargesCustomer.toFixed(2)}
                                  </Typography>
                                  <Typography className="charge-text">
                                    Total Charges
                                  </Typography>
                                </Box>
                              </Popover>
                              <Typography className="state-values">
                                ${totalChargesCustomer.toFixed(2)}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Typography
                            className="project-bill-date"
                            sx={{ mt: "37px" }}
                          >
                            Project & Billing Periods:
                          </Typography>

                          {/* {finalList && finalList.length > 0 && (
                          <>
                          {finalList.map((r, i) => (
                          <Typography
                          className="project-bill-text"
                          key={`${i}_proj`}
                          >
                          {r.ProjectName}:{" "}
                          {r.startDate}{" "}
                          -{" "}
                          {r.endDate}
                          </Typography>
                          ))}
                          </>
                          )} */}

                          {finalList && finalList.length > 0 && (
                            <>
                              {finalList
                                .filter((row) => {
                                  const ProjIDFA =
                                    row?.ProjID || row?.InvProjectID;
                                  const PeriodKeyFB =
                                    row?.PeriodKey || row?.InvPeriodKey;

                                  const filteredInvoices =
                                    lineList &&
                                    lineList.filter(
                                      (invoice) =>
                                        invoice.BillingHeaderID === 0 &&
                                        invoice.InvPeriodKey == PeriodKeyFB &&
                                        invoice.InvProjectID == ProjIDFA
                                    );

                                  const hasAttached =
                                    selectedPeriodList &&
                                    selectedPeriodList
                                      .filter(
                                        (t) =>
                                          t.ProjID === ProjIDFA &&
                                          t.PeriodKey === PeriodKeyFB
                                      )
                                      .some((item) => item.IsAttached);

                                  if (
                                    (filteredInvoices &&
                                      filteredInvoices.length > 0) ||
                                    hasAttached
                                  ) {
                                    return row;
                                  }

                                  return false;
                                })
                                .sort((a, b) => {
                                  // First, compare based on ProjID or InvProjectID
                                  const projA = a?.ProjID || a?.InvProjectID;
                                  const projB = b?.ProjID || b?.InvProjectID;

                                  if (projA !== projB) {
                                    // If ProjID (or InvProjectID) is different, sort by ProjID
                                    return projA - projB;
                                  } else {
                                    // If ProjID (or InvProjectID) is the same, sort by startDate, then endDate
                                    const dateAStart = new Date(a.startDate);
                                    const dateBStart = new Date(b.startDate);

                                    const dateAEnd = new Date(a.endDate);
                                    const dateBEnd = new Date(b.endDate);

                                    // Sort by startDate first
                                    if (
                                      dateAStart.getTime() !==
                                      dateBStart.getTime()
                                    ) {
                                      return dateAStart - dateBStart;
                                    }

                                    // If startDate is the same, sort by endDate
                                    return dateAEnd - dateBEnd;
                                  }
                                })
                                .map((r, i) => (
                                  <Typography
                                    className="project-bill-text"
                                    key={`${i}_proj`}
                                  >
                                    {r.ProjectName}: {r.startDate} - {r.endDate}
                                  </Typography>
                                ))}
                            </>
                          )}

                          {/* {selectedPeriodList && (
                            <>
                              {selectedPeriodList
                                .filter(
                                  (r, index, self) =>
                                    index ===
                                    self.findIndex(
                                      (t) =>
                                        t.PeriodKey === r.PeriodKey &&
                                        t.ProjID === r.ProjID
                                    )
                                )
                                .filter(r => {
                                  const hasAttached = selectedPeriodList
                                    .filter(t => t.ProjID === r.ProjID && t.PeriodKey === r.PeriodKey)
                                    .some(item => item.IsAttached);

                                  var additionalCondition = false;
                                  const filteredInvoices = lineList && lineList.filter(invoice => invoice.BillingHeaderID === 0);
                                  if(filteredInvoices && filteredInvoices.length > 0){
                                    const filteredInvoicesRespData =  filteredInvoices.filter((data) => data.InvProjectID == r.ProjID && data.InvPeriodKey ==  r.PeriodKey)
                                    if(filteredInvoicesRespData && filteredInvoicesRespData.length > 0) { additionalCondition = true }
                                  }

                                  return hasAttached || additionalCondition;
                                })
                                ?.sort((a, b) => {
                                  // First, compare based on ProjID or InvProjectID
                                  const projA = a?.ProjID || a?.InvProjectID;
                                  const projB = b?.ProjID || b?.InvProjectID;

                                  if (projA !== projB) {
                                    // If ProjID (or InvProjectID) is different, sort by ProjID
                                    return projA - projB;
                                  } else {
                                    // If ProjID (or InvProjectID) is the same, sort by startDate, then endDate
                                    const dateAStart = new Date(a.BillingStart);
                                    const dateBStart = new Date(b.BillingStart);

                                    const dateAEnd = new Date(a.BillingEnd);
                                    const dateBEnd = new Date(b.BillingEnd);

                                    // Sort by startDate first
                                    if (
                                      dateAStart.getTime() !==
                                      dateBStart.getTime()
                                    ) {
                                      return dateAStart - dateBStart;
                                    }

                                    // If startDate is the same, sort by endDate
                                    return dateAEnd - dateBEnd;
                                  }
                                })
                                .map((r, i) => {
                                  console.log(r, "filtered item");
                                  return (
                                    <Typography
                                      className="project-bill-text"
                                      key={`${i}_proj`}
                                    >
                                      {r.ProjectName}:{" "}
                                      {moment(new Date(r.BillingStart))
                                        .utc()
                                        .format("MM/DD/YYYY")}{" "}
                                      -{" "}
                                      {moment(new Date(r.BillingEnd))
                                        .utc()
                                        .format("MM/DD/YYYY")}
                                    </Typography>
                                  );
                                })}
                            </>
                          )} */}

                          {/* {selectedPeriodList &&
                            selectedPeriodList.map((r, i) => {
                              return (
                                <Typography
                                  className="project-bill-text"
                                  key={`${i}_proj`}
                                >
                                  {r.ProjectName}:{" "}
                                  {moment(new Date(r.BillingStart)).format(
                                    "MM/DD/YYYY"
                                  )}{" "}
                                  -{" "}
                                  {moment(new Date(r.BillingEnd)).format(
                                    "MM/DD/YYYY"
                                  )}
                                </Typography>
                              );
                            })} */}
                        </Grid>
                      </Grid>
                    </Box>
                  </Typography>
                </Box>
                {selectedPeriodList?.length > 0 && (
                  <FormControl
                    className="search-box filter-searchbox"
                    sx={{ m: 1, maxWidth: "357px" }}
                  >
                    <p className="label">Select Project: </p>
                    <Select
                      sx={{
                        ".MuiSelect-select": {
                          color:
                            projectFilterSelect == "All"
                              ? "#898989 !important" // Gray color for placeholder
                              : "#212121 !important", // Black color for selected value
                        },
                        minWidth: "200px",
                        paddingRight:
                          projectFilterSelect !== "All" ? "14px" : "0px",
                      }}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={projectFilterSelect} // Set default value to 'All'                    onChange={handleProjectSelect}
                      IconComponent={KeyboardArrowDownIcon}
                      onChange={handleProjectSelect}
                      displayEmpty
                    >
                      <MenuItem disabled value="" sx={{ color: "darkgray" }}>
                        Select Project
                      </MenuItem>
                      <MenuItem value={"All"}>All</MenuItem>
                      {selectedPeriodList
                        ?.filter(
                          (item, index, self) =>
                            index ===
                            self.findIndex((t) => t.ProjID === item.ProjID)
                        )
                        ?.map((item) => (
                          <MenuItem
                            style={{ maxWidth: "300px" }}
                            value={item.ProjectName}
                            key={item.ProjID}
                          >
                            <span
                              style={{ whiteSpace: "break-spaces" }}
                              className="select-option-text"
                            >
                              {item.ProjectName}
                            </span>
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                )}

                {
                  finalList.length > 0 &&
                    finalList
                      ?.filter((item) => {
                        // If projectFilterSelect is 'All', return all records
                        if (projectFilterSelect === "All") {
                          return true;
                        }
                        // Otherwise, filter based on the project name (assuming `ProjectName` is the field you want to match)
                        return item.ProjectName === projectFilterSelect;
                      })
                      ?.sort((a, b) => {
                        // First, compare based on ProjID or InvProjectID
                        const projA = a?.ProjID || a?.InvProjectID;
                        const projB = b?.ProjID || b?.InvProjectID;

                        if (projA !== projB) {
                          // If ProjID (or InvProjectID) is different, sort by ProjID
                          return projA - projB;
                        } else {
                          // If ProjID (or InvProjectID) is the same, sort by startDate, then endDate
                          const dateAStart = new Date(a.startDate);
                          const dateBStart = new Date(b.startDate);

                          const dateAEnd = new Date(a.endDate);
                          const dateBEnd = new Date(b.endDate);

                          // Sort by startDate first
                          if (dateAStart.getTime() !== dateBStart.getTime()) {
                            return dateAStart - dateBStart;
                          }

                          // If startDate is the same, sort by endDate
                          return dateAEnd - dateBEnd;
                        }
                      })
                      ?.map((rec, index, key) => {
                        const formikLineItemIndex = getFormikLineItemIndex(rec);
                        // Use the stable source index for all Formik-backed
                        // fields in this card. The visible list may be sorted
                        // or filtered independently.
                        index = formikLineItemIndex >= 0 ? formikLineItemIndex : index;
                        const {
                          BillingDetailID,
                          BillingHeaderID,
                          BillingDayRate,
                          BillableDayRate,
                          BillableOfficePerDiem,
                          BillableTravelPerDiem,
                          ProjID,
                          PeriodKey,
                          InvProjectID,
                          InvPeriodKey,
                          startDate,
                          endDate,
                          ProjectName,
                          selectedperiod = [],
                        } = rec;

                        const newLineProjectId =
                          ProjID ||
                          InvProjectID ||
                          rec.ProjectID ||
                          rec.projectId;
                        const newLinePeriodKey =
                          PeriodKey ||
                          InvPeriodKey ||
                          rec.periodKey;
                        const matchedProjectRate =
                          projectDetailsValue.find(
                            (project) =>
                              String(
                                project.ProjectID || project.projectId
                              ) === String(newLineProjectId)
                          ) || {};

                        const newLineItem =
                          formik1.values.lineItems[index] || {};
                        const newLineSelection =
                          newLineItem.selectedDayRate || "Billable Rate";
                        const newLineProjectRate = {
                          ...rec,
                          ...matchedProjectRate,
                          ...getProjectHeaderRate(
                            newLineProjectId,
                            newLinePeriodKey
                          ),
                        };
                        const newLineRate = resolveExistingLineItemDayRate(
                          newLineSelection,
                          newLineProjectRate,
                          newLineProjectRate,
                          getProjectBillableDayRate(rec)
                        ).dayRate;

                        console.log(rec, "BillingDayRateBillingDayRate");

                        const matchedMileAndDayRate = Array.isArray(
                          previousMileageRateDayRateByProject
                        )
                          ? previousMileageRateDayRateByProject.find(
                              (rowval) =>
                                (rowval.projectId == ProjID ||
                                  rowval.projectId == InvProjectID) &&
                                (rowval.periodKey == PeriodKey ||
                                  rowval.periodKey == InvPeriodKey)
                            )
                          : [];

                        console.log(
                          matchedMileAndDayRate,
                          "matchedMileAndDayRatematchedMileAndDayRate"
                        );

                        if (matchedMileAndDayRate) {
                          rec["MatchedDayRate"] = matchedMileAndDayRate.dayRate;
                          rec["MatchedMileageRate"] =
                            matchedMileAndDayRate.mileageRate;
                        }

                        let thrs = 0;
                        let tlodg = 0;
                        let tcopy = 0;
                        let tmisc = 0;
                        let tmileage = 0;
                        let tmiles = 0;
                        let tperdiem = 0;

                        selectedperiod
                          .filter((period) => period.InvoiceDetailsID) // Add your filter condition here
                          .forEach((period) => {
                            thrs += parseFloat(period.Hours);
                            tlodg += parseFloat(period.Lodging);
                            tcopy += parseFloat(period.Copies);
                            tmisc += parseFloat(period.Misc);
                            tmiles += parseFloat(period.Miles);
                            finaltmileage += period.Mileage;
                            tperdiem += parseFloat(period.PerDiem);
                            // final
                            //  finalthrs += period.Hours;
                            // finaltlodg+=period.Lodging;
                            // finaltcopy+=period.Copies
                            // finaltmisc+=period.Misc
                            // finaltmiles+=period.Miles
                            // finaltmileage+=period.Mileage
                            // finaltperdiem+=period.PerDiem
                          });
                        let oldMileageRateDayRateByMatched = Array.isArray(
                          oldMileageRateDayRateByProject
                        )
                          ? oldMileageRateDayRateByProject.find(
                              (val) =>
                                val.projectId ==
                                  (ProjID ? ProjID : InvProjectID) &&
                                val.periodKey ==
                                  (PeriodKey ? PeriodKey : InvPeriodKey)
                            )
                          : null;
                        const projectId = ProjID || InvProjectID;
                        const periodKey = PeriodKey || InvPeriodKey;
                        const projectHeaderRateSource = getProjectHeaderRate(
                          projectId,
                          periodKey
                        );
                        const selectedDayRate = getSelectedDayRate(
                          rec,
                          projectId,
                          periodKey
                        );
                        const dayRateInputValue =
                          pendingDayRateValues[
                            getProjectCardKey(projectId, periodKey)
                          ] ??
                          formatPopulatedDayRate(
                            getDayRateForSelection(
                              selectedDayRate,
                              projectHeaderRateSource,
                              0,
                              true
                            )
                          );
                        const selectedHeaderDayRate = getDayRateForSelection(
                          selectedDayRate,
                          projectHeaderRateSource,
                          0,
                          true
                        );
                        const selectedRateMatchesHeader =
                          dayRateInputValue !== "" &&
                          Number.isFinite(Number(dayRateInputValue)) &&
                          Number.isFinite(Number(selectedHeaderDayRate)) &&
                          Math.abs(
                            Number(dayRateInputValue) -
                              Number(selectedHeaderDayRate)
                          ) < 0.005;
                        // Changing the rate type alone is not a pending edit.
                        // Only a value that differs from that type's saved
                        // project-header rate should enable Save/highlight.
                        const isDayRateUnchanged = selectedRateMatchesHeader;
                        const invoiceChargeBreakdown =
                          getInvoiceLineChargeBreakdown(
                            selectedperiod.filter(
                              (period) => period.InvoiceDetailsID
                            ),
                            projectHeaderRateSource
                          );
                        const invoiceChargeTotal = invoiceChargeBreakdown.reduce(
                          (total, rate) => total + rate.charge,
                          0
                        );
                        // or handle it as per your need if it's not an array
                        console.log(
                          tlodg,
                          tcopy,
                          tmisc,
                          "oldddddddddddddselectedperiod"
                        );
                        return (
                          <React.Fragment
                            key={getProjectCardKey(projectId, periodKey)}
                          >
                            <Box
                              className="bill-form-box"
                              key={`${getProjectCardKey(projectId, periodKey)}_project`}
                              ref={gridRefDay}
                              onBlur={handleDayRateFocusOut}
                            >
                              <Stack
                                className="bill-form-title"
                                direction={{ xs: "column", sm: "row" }}
                                   spacing={{ xs: 1, sm: 1, md: 1 }}
                                justifyContent="space-between"
                                sx={{
                                  alignItems: {
                                    xs: "flex-start",
                                    md: "center",
                                  },
                                  padding: "11px 19px",
                                  background: "#EEF6ED",
                                }}
                              >
                                <Typography className="billing-boxdate-title">
                                  {/* {moment(new Date()).format('MM/DD/YYYY')} */}
                                  {/* {calculateDate(index)} */}
                                  Billing Period:{" "}
                                  {rec.startDate ? rec.startDate : "-"} -{" "}
                                  {rec.endDate ? rec.endDate : "-"}
                                </Typography>

                                <Typography className="billing-boxdate-title">
                                  {/* {moment(new Date()).format('MM/DD/YYYY')} */}
                                  {/* {calculateDate(index)} */}
                                  Project Name: {rec.ProjectName}
                                </Typography>
                              </Stack>

                              <Box className="bill-formbox-inside">
                                <Box
                                  sx={{
                                    display: "flex",
                                    gap: { xs: 2, md: 4 },
                                    width: "100%",
                                    flexWrap: { xs: "wrap", md: "nowrap" },
                                  }}
                                >
                                  <Box
                                    sx={{
                                      flex: { xs: "0 0 100%", md: "0 0 calc(70% - 8px)" },
                                      maxWidth: { xs: "100%", md: "calc(70% - 8px)" },
                                    }}
                                  >
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                      <p className="label" style={{ marginBottom: 0 }}>
                                        Select Day Rate
                                      </p>
                                      <Tooltip
                                        title="Invoice-level configuration: Select a day-rate type and save your changes to apply the selected rate to existing line items and newly created line items on this invoice."
                                        arrow
                                        placement="top"
                                      >
                                        <IconButton
                                          size="small"
                                          aria-label="Select day rate information"
                                          sx={{ p: 0.25 }}
                                        >
                                          <span
                                            className="material-symbols-outlined"
                                            style={{ fontSize: 18 }}
                                          >
                                            help
                                          </span>
                                        </IconButton>
                                      </Tooltip>
                                    </Box>
                                    <Box
                                      sx={{
                                        display: "grid",
                                        gridTemplateColumns: {
                                          xs: "repeat(2, minmax(0, 1fr))",
                                          sm: "repeat(4, minmax(0, 1fr))",
                                        },
                                        maxWidth: "100%",
                                        borderRadius: "4px",
                                        overflow: "hidden",
                                      }}
                                    >
                                      {DAY_RATE_OPTIONS.map((option) => {
                                        return (
                                          <Button
                                            key={option}
                                            type="button"
                                            disabled={invoiceStatus}
                                            onClick={() =>
                                              handleDayRateSelection(
                                                rec,
                                                projectId,
                                                periodKey,
                                                option
                                              )
                                            }
                                            sx={{
                                              minHeight: 38,
                                              border: "1px solid #d7dce2",
                                              borderRadius: 0,
                                              color:
                                                selectedDayRate === option
                                                  ? "#4cae47"
                                                  : "#202124",
                                              backgroundColor:
                                                selectedDayRate === option
                                                  ? "#eef8eb"
                                                  : "#fff",
                                              fontWeight:
                                                selectedDayRate === option ? 600 : 400,
                                              minWidth: 0,
                                              width: "100%",
                                              boxSizing: "border-box",
                                              whiteSpace: "normal",
                                              overflowWrap: "break-word",
                                              lineHeight: 1.2,
                                              textAlign: "center",
                                              fontSize: { xs: 12, md: 13 },
                                              px: 1,
                                              "&:hover": { backgroundColor: "#eef8eb" },
                                            }}
                                          >
                                            {option}
                                          </Button>
                                        );
                                      })}
                                    </Box>
                                  <Box
                                    sx={{
                                      mt: 2,
                                      width: "100%",
                                      display: "grid",
                                      gridTemplateColumns: {
                                        xs: "1fr",
                                        md: "repeat(2, minmax(0, 1fr))",
                                      },
                                      columnGap: { xs: 0, md: 4 },
                                      rowGap: 2,
                                    }}
                                  >
                                    <Box sx={{ minWidth: 0 }}>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "flex-end",
                                        gap: 1,
                                      }}
                                    >
                                    <FormControl variant="standard" sx={{ flex: 1 }}>
                                      <p className="label">Day Rate</p>
                                      <Input
                                        className="default-btn dollar-field"
                                        sx={{
                                          "&.MuiInputBase-root": {
                                            border:
                                              !loading &&
                                              !isDayRateUnchanged
                                                ? "1px solid yellow"
                                                : "",
                                          },
                                          "&:hover:not(.Mui-disabled):before": {
                                            borderBottom:
                                              !loading &&
                                              !isDayRateUnchanged
                                                ? "1px solid yellow"
                                                : "",
                                          },
                                          "&.Mui-focused:after": {
                                            borderBottom:
                                              !loading &&
                                              !isDayRateUnchanged
                                                ? "1px solid yellow"
                                                : "",
                                          },
                                        }}
                                        disabled={invoiceStatus}
                                        name="dayRate"
                                        id="dayRate"
                                        type="dayRate"
                                        onChange={(e) => {
                                          // Allow only numbers with up to two decimals
                                          const value = e.target.value;
                                          const regex =
                                            /^[0-9]*(\.[0-9]{0,2})?$/;

                                          if (regex.test(value)) {
                                            handleChangeDayRate(
                                              e,
                                              "dayRate",
                                              ProjID ? ProjID : InvProjectID,
                                              PeriodKey
                                                ? PeriodKey
                                                : InvPeriodKey,
                                              index
                                            );
                                          }
                                        }}
                                        // value={currentDayRate}
                                        //value={rec.BillableDayRate}
                                        value={dayRateInputValue}
                                        startAdornment={
                                          <InputAdornment position="start">
                                            <span className="dollar-icon">
                                              $
                                            </span>
                                          </InputAdornment>
                                        }
                                      />
                                    </FormControl>
                                    <Button
                                      sx={{ minWidth: 60, mb: "2px" }}
                                      // className={rec.BillableDayRate ? "disable-filter-btn"  : "primary-btn"}
                                      className={
                                        isDayRateUnchanged
                                          ? "disable-filter-btn"
                                          : "primary-btn"
                                      }
                                      onClick={() => {
                                        setLoading(true);
                                        setSaveDayRateValue(true);
                                        setSaveProjID(
                                          ProjID ? ProjID : InvProjectID
                                        );
                                        setSaveCustomerId(rec?.customerId);
                                        setSavePeriodKey(
                                          PeriodKey ? PeriodKey : InvPeriodKey
                                        );
                                        setSaveMatchedDayRate(
                                          dayRateInputValue
                                        );
                                        setSaveSelectedDayRate(
                                          getSelectedDayRate(
                                            rec,
                                            ProjID || InvProjectID,
                                            PeriodKey || InvPeriodKey
                                          )
                                        );
                                        setSaveProjectName(ProjectName);
                                        // dayRateSave(
                                        //   ProjID ? ProjID : InvProjectID,
                                        //   rec?.customerId,
                                        //   PeriodKey ? PeriodKey : InvPeriodKey,
                                        //   rec?.MatchedDayRate,
                                        //   ProjectName
                                        // );
                                      }}
                                      disabled={
                                        invoiceStatus ||
                                        isDayRateUnchanged
                                      }
                                      // onBlur={() => handleBlur("dayRate")}
                                    >
                                      Save
                                    </Button>
                                    </Box>
                                  </Box>
                                  <Box
                                    sx={{
                                      minWidth: 0,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "flex-end",
                                        gap: 1,
                                      }}
                                    >
                                    <FormControl variant="standard" sx={{ flex: 1 }}>
                                      <p className="label">Mileage Rate</p>
                                      <Input
                                        className="default-btn dollar-field"
                                        name="mileageRate"
                                        id="mileageRate"
                                        disabled={invoiceStatus}
                                        sx={{
                                          "&.MuiInputBase-root": {
                                            border:
                                              !loading &&
                                              oldMileageRateDayRateByMatched?.mileageRate !=
                                                rec?.MatchedMileageRate
                                                ? "1px solid yellow"
                                                : "",
                                          },
                                          "&:hover:not(.Mui-disabled):before": {
                                            borderBottom:
                                              !loading &&
                                              oldMileageRateDayRateByMatched?.mileageRate !=
                                                rec?.MatchedMileageRate
                                                ? "1px solid yellow"
                                                : "",
                                          },
                                          "&.Mui-focused:after": {
                                            borderBottom:
                                              !loading &&
                                              oldMileageRateDayRateByMatched?.mileageRate !=
                                                rec?.MatchedMileageRate
                                                ? "1px solid yellow"
                                                : "",
                                          },
                                        }}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          const regex =
                                            /^[0-9]*(\.[0-9]{0,3})?$/;

                                          if (regex.test(value)) {
                                            handleChangeDayRate(
                                              e,
                                              "mileageRate",
                                              ProjID ? ProjID : InvProjectID,
                                              PeriodKey
                                                ? PeriodKey
                                                : InvPeriodKey,
                                              index 
                                            );
                                          }
                                        }}
                                        // onBlur={() => handleBlur("mileageRate")}
                                        type="mileageRate"
                                        //value={currentMileageRate}
                                        // disabled={editFlag}
                                        // value={rec.MileageRate}
                                        value={
                                          rec?.MatchedMileageRate ||
                                          typeof rec?.MatchedMileageRate ==
                                            "number"
                                            ? rec?.MatchedMileageRate
                                            : "0.00"
                                        }
                                        startAdornment={
                                          <InputAdornment position="start">
                                            <span className="dollar-icon">
                                              $
                                            </span>
                                          </InputAdornment>
                                        }
                                      />
                                    </FormControl>
                                    <Button
                                      sx={{ minWidth: 60, mb: "2px" }}
                                      className={
                                        oldMileageRateDayRateByMatched?.mileageRate ==
                                        rec?.MatchedMileageRate
                                          ? "disable-filter-btn"
                                          : "primary-btn"
                                      }
                                      onClick={(e) => {
                                        setLoading(true);
                                        setSaveMileageRateValue(true);
                                        setSaveProjID(
                                          ProjID ? ProjID : InvProjectID
                                        );
                                        setSaveCustomerId(rec?.customerId);
                                        setSavePeriodKey(
                                          PeriodKey ? PeriodKey : InvPeriodKey
                                        );
                                        setSaveMatchedDayRate(
                                          rec?.MatchedMileageRate
                                        );
                                        setSaveProjectName(ProjectName);
                                        // mileageRateSave(
                                        //   ProjID ? ProjID : InvProjectID,
                                        //   rec.customerId,
                                        //   PeriodKey ? PeriodKey : InvPeriodKey,
                                        //   rec?.MatchedMileageRate,
                                        //   ProjectName
                                        // );
                                      }}
                                      disabled={
                                        invoiceStatus ||
                                        oldMileageRateDayRateByMatched?.mileageRate ==
                                          rec?.MatchedMileageRate
                                      }
                                    >
                                      Save
                                    </Button>
                                    </Box>
                                  </Box>
                                  </Box>
                                  </Box>
                                  <Box
                                    sx={{
                                      flex: { xs: "0 0 100%", md: "0 0 calc(30% - 8px)" },
                                      maxWidth: { xs: "100%", md: "calc(30% - 8px)" },
                                    }}
                                  >
                                  <Grid container>
                                  <Grid
                                    sx={{
                                      pl: { xs: "0px", sm: "27px" },
                                      pt: { xs: "15px", sm: "0px" },
                                    }}
                                    xs={6}
                                  >
                                    <Typography className="state-titles">
                                      Per Diem:
                                    </Typography>
                                    <Typography className="state-values">
                                      ${tperdiem.toFixed(2)}{" "}
                                    </Typography>
                                    <Typography
                                      sx={{ position: "relative" }}
                                      className="state-titles"
                                    >
                                      Mileage:
                                      <span>
                                        <span
                                          style={{
                                            position: "absolute",
                                            fontSize: "15px",
                                            cursor: "pointer",
                                          }}
                                          aria-owns={
                                            isPopoverOpen(`Mileage_${index}`)
                                              ? "mouse-over-popover"
                                              : undefined
                                          }
                                          aria-haspopup="true"
                                          onMouseEnter={(e) =>
                                            handlePopoverOpen(
                                              e,
                                              `Mileage_${index}`
                                            )
                                          }
                                          onMouseLeave={handlePopoverClose}
                                          className="material-symbols-outlined"
                                        >
                                          help
                                        </span>
                                      </span>
                                    </Typography>
                                    <Popover
                                      className="charges-box"
                                      id="mouse-over-popover"
                                      sx={{
                                        pointerEvents: "none",
                                      }}
                                      open={isPopoverOpen(`Mileage_${index}`)}
                                      anchorEl={anchorEl}
                                      anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "center",
                                      }}
                                      transformOrigin={{
                                        vertical: "bottom",
                                        horizontal: "center",
                                      }}
                                      onClose={handlePopoverClose}
                                      disableRestoreFocus
                                    >
                                      <Typography className="charges-title">
                                        Mileage Charges
                                      </Typography>
                                      <Box sx={{ minHeight: "88px" }}>
                                        <Box className="time-flexbox">
                                          <Typography className="charge-price">
                                            {tmiles}
                                          </Typography>
                                          <Typography className="charge-text">
                                            miles
                                          </Typography>
                                        </Box>
                                        <Box className="time-flexbox">
                                          <Typography className="charge-price">
                                            x $
                                            {Number(
                                              oldMileageRateDayRateByMatched?.mileageRate ||
                                                typeof oldMileageRateDayRateByMatched?.mileageRate ==
                                                  "number"
                                                ? oldMileageRateDayRateByMatched?.mileageRate
                                                : ""
                                            ).toFixed(3)}
                                          </Typography>
                                          <Typography className="charge-text">
                                            per mile
                                          </Typography>
                                        </Box>
                                        <Divider
                                          sx={{
                                            borderColor: "#F2F4F8",
                                            margin: "5px 0px",
                                          }}
                                        />
                                        <Box className="time-flexbox">
                                          <Typography className="charge-price">
                                            $
                                            {(
                                              Number(tmiles) *
                                              Number(
                                                oldMileageRateDayRateByMatched?.mileageRate ||
                                                  typeof oldMileageRateDayRateByMatched?.mileageRate ==
                                                    "number"
                                                  ? oldMileageRateDayRateByMatched?.mileageRate
                                                  : "0.00"
                                              )
                                            ).toFixed(3)}
                                          </Typography>
                                          <Typography className="charge-text">
                                            total charge
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </Popover>
                                    <Typography className="state-values">
                                      $
                                      {(
                                        Number(tmiles) *
                                        Number(
                                          oldMileageRateDayRateByMatched?.mileageRate ||
                                            typeof oldMileageRateDayRateByMatched?.mileageRate ==
                                              "number"
                                            ? oldMileageRateDayRateByMatched?.mileageRate
                                            : "0.00"
                                        )
                                      ).toFixed(3)}
                                    </Typography>
                                  </Grid>
                                  <Grid xs={6}>
                                    <Typography
                                      sx={{ position: "relative" }}
                                      className="state-titles"
                                    >
                                      Expenses:
                                      <span>
                                        <span
                                          style={{
                                            position: "absolute",
                                            fontSize: "15px",
                                            cursor: "pointer",
                                          }}
                                          aria-owns={
                                            isPopoverOpen(`Expenses_${index}`)
                                              ? "mouse-over-popover"
                                              : undefined
                                          }
                                          aria-haspopup="true"
                                          onMouseEnter={(e) =>
                                            handlePopoverOpen(
                                              e,
                                              `Expenses_${index}`
                                            )
                                          }
                                          onMouseLeave={handlePopoverClose}
                                          className="material-symbols-outlined"
                                        >
                                          help
                                        </span>
                                      </span>
                                    </Typography>
                                    <Popover
                                      className="charges-box"
                                      id="mouse-over-popover"
                                      sx={{
                                        pointerEvents: "none",
                                      }}
                                      open={isPopoverOpen(`Expenses_${index}`)}
                                      anchorEl={anchorEl}
                                      anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "center",
                                      }}
                                      transformOrigin={{
                                        vertical: "bottom",
                                        horizontal: "center",
                                      }}
                                      onClose={handlePopoverClose}
                                      disableRestoreFocus
                                    >
                                      <Typography className="charges-title">
                                        Expenses Charges
                                      </Typography>
                                      <Box>
                                        <Box className="time-flexbox">
                                          <Typography className="charge-price">
                                            $
                                            {/* {tlodg
                                              ? tlodg
                                              : "0.00"} */}
                                            {tlodg
                                              ? parseFloat(tlodg).toFixed(2)
                                              : "0.00"}
                                          </Typography>
                                          <Typography className="charge-text">
                                            lodging
                                          </Typography>
                                        </Box>
                                        <Box className="time-flexbox">
                                          <Typography className="charge-price">
                                            $
                                            {/* {tcopy
                                              ? tcopy
                                              : "0"} */}
                                            {tcopy
                                              ? parseFloat(tcopy).toFixed(2)
                                              : "0.00"}
                                          </Typography>
                                          <Typography className="charge-text">
                                            copies
                                          </Typography>
                                        </Box>
                                        <Divider
                                          sx={{
                                            borderColor: "#F2F4F8",
                                            margin: "5px 0px",
                                          }}
                                        />
                                        <Box className="time-flexbox">
                                          <Typography className="charge-price">
                                            + $
                                            {(parseFloat(tmisc) || 0).toFixed(
                                              2
                                            )}
                                          </Typography>
                                          <Typography className="charge-text">
                                            misc
                                          </Typography>
                                        </Box>
                                        <Box className="time-flexbox time-btn">
                                          <Typography className="charge-price total-charge">
                                            $
                                            {(
                                              parseFloat(tlodg || "0") + // Use parseFloat for better handling of numeric strings
                                              parseFloat(tcopy || "0") +
                                              parseFloat(tmisc || "0")
                                            ).toFixed(2)}
                                          </Typography>
                                          <Typography className="charge-text">
                                            total charge
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </Popover>
                                    <Typography className="state-values">
                                      $
                                      {(
                                        parseFloat(tlodg || "0") + // Use parseFloat for better handling of numeric strings
                                        parseFloat(tcopy || "0") +
                                        parseFloat(tmisc || "0")
                                      ).toFixed(2)}
                                    </Typography>

                                    <Typography
                                      sx={{ position: "relative" }}
                                      className="state-titles"
                                    >
                                      Charges:
                                      <span>
                                        <span
                                          style={{
                                            position: "absolute",
                                            fontSize: "15px",
                                            cursor: "pointer",
                                          }}
                                          aria-owns={
                                            isPopoverOpen(index, "Charges")
                                              ? "mouse-over-popover"
                                              : undefined
                                          }
                                          aria-haspopup="true"
                                          onMouseEnter={(e) =>
                                            handlePopoverOpen(
                                              e,
                                              index,
                                              "Charges"
                                            )
                                          }
                                          onMouseLeave={handlePopoverClose}
                                          className="material-symbols-outlined"
                                        >
                                          help
                                        </span>
                                      </span>
                                    </Typography>
                                    <Popover
                                      className="charges-box"
                                      id="mouse-over-popover"
                                      sx={{
                                        pointerEvents: "none",
                                      }}
                                      open={isPopoverOpen(index, "Charges")}
                                      anchorEl={anchorEl}
                                      anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "center",
                                      }}
                                      transformOrigin={{
                                        vertical: "bottom",
                                        horizontal: "center",
                                      }}
                                      onClose={handlePopoverClose}
                                      disableRestoreFocus
                                    >
                                      <Typography className="charges-title">
                                        Charges
                                      </Typography>
                                      <Box
                                        sx={{
                                          display: "grid",
                                          gridTemplateColumns: {
                                            xs: "minmax(0, 1fr)",
                                            sm:
                                              invoiceChargeBreakdown.length > 1
                                                ? "repeat(2, minmax(150px, 1fr))"
                                                : "minmax(150px, 1fr)",
                                          },
                                          gap: 1,
                                          width: {
                                            xs: "100%",
                                            sm:
                                              invoiceChargeBreakdown.length > 1
                                                ? "100%"
                                                : "50%",
                                          },
                                          minWidth: {
                                            xs: 0,
                                            sm:
                                              invoiceChargeBreakdown.length > 1
                                                ? 320
                                                : 150,
                                          },
                                        }}
                                      >
                                        {invoiceChargeBreakdown.map((rate) => (
                                          <Box
                                            key={rate.selection}
                                            sx={{
                                              border: "1px solid #F2F4F8",
                                              borderRadius: "4px",
                                              p: 1,
                                            }}
                                          >
                                            <Typography
                                              className="charges-title"
                                              sx={{ fontSize: "12px", mb: 0.75 }}
                                            >
                                              {rate.label}
                                            </Typography>
                                            <Box className="time-flexbox">
                                              <Typography className="charge-price">
                                                {rate.hours.toFixed(2)}
                                              </Typography>
                                              <Typography className="charge-text">
                                                hours
                                              </Typography>
                                            </Box>
                                            <Box className="time-flexbox">
                                              <Typography className="charge-price">
                                                /8
                                              </Typography>
                                              <Typography className="charge-text">
                                                hour work day
                                              </Typography>
                                            </Box>
                                            <Divider
                                              sx={{
                                                borderColor: "#F2F4F8",
                                                margin: "5px 0px",
                                              }}
                                            />
                                            <Box className="time-flexbox">
                                              <Typography className="charge-price">
                                                {rate.billableDays.toFixed(3)}
                                              </Typography>
                                              <Typography className="charge-text">
                                                billable days
                                              </Typography>
                                            </Box>
                                            <Box className="time-flexbox">
                                              <Typography className="charge-price">
                                                {rate.rate.toFixed(2)}
                                              </Typography>
                                              <Typography className="charge-text">
                                                day rate
                                              </Typography>
                                            </Box>
                                            <Divider
                                              sx={{
                                                borderColor: "#F2F4F8",
                                                margin: "5px 0px",
                                              }}
                                            />
                                            <Box className="time-flexbox time-btn">
                                              <Typography className="charge-price total-charge">
                                                ${rate.charge.toFixed(2)}
                                              </Typography>
                                              <Typography className="charge-text">
                                                billable
                                              </Typography>
                                            </Box>
                                          </Box>
                                        ))}
                                      </Box>
                                      <Box className="time-flexbox time-btn" sx={{ mt: 1 }}>
                                        <Typography className="charge-price total-charge">
                                          ${invoiceChargeTotal.toFixed(2)}
                                        </Typography>
                                        <Typography className="charge-text">
                                          total charges
                                        </Typography>
                                      </Box>
                                    </Popover>
                                    <Typography className="state-values">
                                      $
                                      {invoiceChargeTotal.toFixed(2)}
                                    </Typography>
                                    {/* <Popover
                          className="charges-box"
                          id="mouse-over-popover"
                          sx={{
                            pointerEvents: "none",
                          }}
                          open={open}
                          anchorEl={anchorEl}
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          onClose={handlePopoverClose}
                          disableRestoreFocus
                        >
                          <Typography className="charges-title">
                            Charges
                          </Typography>
                          <Box>
                            <Box class="time-flexbox">
                              <Typography className="charge-price">
                                test
                              </Typography>
                              <Typography className="charge-text">
                                hours
                              </Typography>
                            </Box>
                            <Box class="time-flexbox">
                              <Typography className="charge-price">
                                /8
                              </Typography>
                              <Typography className="charge-text">
                                hour work day
                              </Typography>
                            </Box>
                            <Divider
                              sx={{
                                borderColor: "#F2F4F8",
                                margin: "5px 0px",
                              }}
                            />
                            <Box class="time-flexbox">
                              <Typography className="charge-price">
                                test
                              </Typography>
                              <Typography className="charge-text">
                                Billable days
                              </Typography>
                            </Box>
                            <Box class="time-flexbox">
                              <Typography className="charge-price">
                                00{" "}
                              </Typography>
                              <Typography className="charge-text">
                                day rate
                              </Typography>
                            </Box>
                            <Box class="time-flexbox time-btn">
                              <Typography className="charge-price total-charge">
                                dfddf
                              </Typography>
                              <Typography className="charge-text">
                                total charge
                              </Typography>
                            </Box>
                          </Box>
                        </Popover> */}
                                  </Grid>
                                  </Grid>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                            <Box className="bill-form-box">
                              <Stack
                                className="bill-form-title"
                                direction={{ xs: "column", sm: "row" }}
                                spacing={{ xs: 1, sm: 1.5, md: 1.5 }}
                                justifyContent="space-between"
                                sx={{
                                  alignItems: {
                                    xs: "flex-start",
                                    md: "center",
                                  },
                                }}
                              >
                                <Typography className="billing-boxdate-title">
                                  Add new line item
                                </Typography>

                                <Stack
                                  className="icon-btn-box"
                                  direction="row"
                                  spacing={1}
                                  alignItems="center"
                                >
                                  <Tooltip title="Save" arrow placement="top">
                                    <IconButton
                                      // disabled={billingStatus}
                                      className="save-icon-btn"
                                      aria-label="fingerprint"
                                      color="secondary"
                                      onClick={() => {
                                        const billingStart = dayjs(
                                          rec.startDate
                                        );
                                        const billingEnd = dayjs(rec.endDate);
                                        const selectedDate = dayjs(
                                          formik1?.values?.lineItems[index]
                                            ?.date,
                                          "MM/DD/YYYY"
                                        );
                                        if (
                                          !selectedDate.isSame(
                                            billingStart,
                                            "day"
                                          ) &&
                                          (selectedDate.isBefore(
                                            billingStart,
                                            "day"
                                          ) ||
                                            selectedDate.isAfter(
                                              billingEnd,
                                              "day"
                                            ))
                                        ) {
                                          showToast(
                                            "Selected date is outside of this invoice's billing period.",
                                            "error"
                                          );
                                        } else {
                                          handleSaveNewItem(
                                            0,
                                            0,
                                            index,
                                            key,
                                            ProjID,
                                            rec.startDate,
                                            PeriodKey,
                                            rec
                                          );
                                          if (
                                            calculatePerDiem(
                                              formik1?.values?.lineItems[index]?.hours,
                                              parseFloat(
                                                formik1?.values?.lineItems[index]
                                                  ?.perDiemRate
                                              )
                                            ) !==
                                            parseFloat(formik1.values.lineItems[index]?.perDiem).toFixed(2)
                                          ) {
                                            console.log(calculatePerDiem(
                                              formik1?.values?.lineItems[index]?.hours,
                                              parseFloat(
                                                formik1?.values?.lineItems[index]
                                                  ?.perDiemRate
                                              )
                                            ),'llallalal',  parseFloat(formik1.values.lineItems[index]?.perDiem).toFixed(2))
                                            // Do something here, e.g. update state, show a warning, etc.
                                            upsertPerDiemLog(formik1.values.lineItems[index], rec);
                                          }
                                        }
                                      }}
                                      // onClick={()=>{formik1.handleSubmit(formik1.values,BillingHeaderID,BillingDetailID)}}
                                      disabled={
                                        invoiceStatus || saveButtonLoading
                                      }
                                    >
                                      <span class="material-symbols-outlined">
                                        save
                                      </span>
                                    </IconButton>
                                  </Tooltip>
                                </Stack>
                              </Stack>

                              <Box className="bill-formbox-inside">
                                <Stack
                                  className="line-item-fields"
                                  direction={{ xs: "column", sm: "row" }}
                                  spacing={{ xs: 1, sm: 1, md: 1 }}
                                  justifyContent="flex-start"
                                  sx={{
                                    alignItems: {
                                      xs: "flex-start",
                                      md: "baseline",
                                    },
                                     width: "100%",
                                     maxWidth: "none",
                                     flexWrap: { xs: "wrap", sm: "nowrap" },
                                  }}
                                >
                                  <FormControl
                                    className="select-broker-field"
                                     sx={{ flex: "1 1 0", minWidth: 0, width: "100%" }}
                                    variant="outlined"
                                  >
                                    <p className="label">Select Broker:</p>
                                    <Select
                                      sx={{
                                        minWidth: 0,
                                        width: "100%",
                                        "& .MuiOutlinedInput-notchedOutline": {
                                          border:
                                            warningHighlightColor &&
                                            formik1?.values?.lineItems[index]
                                              ?.brokerId &&
                                            formik1?.values?.lineItems[index]
                                              ?.brokerId != ""
                                              ? "yellow"
                                              : "",
                                          borderWidth:
                                            warningHighlightColor &&
                                            formik1?.values?.lineItems[index]
                                              ?.brokerId &&
                                            formik1?.values?.lineItems[index]
                                              ?.brokerId != ""
                                              ? "1px"
                                              : "",
                                          outline:
                                            warningHighlightColor &&
                                            formik1?.values?.lineItems[index]
                                              ?.brokerId &&
                                            formik1?.values?.lineItems[index]
                                              ?.brokerId != ""
                                              ? "1px solid yellow"
                                              : "",
                                        },
                                        "& .MuiSelect-select": {
                                          color:
                                            formik1?.values?.lineItems[index]
                                              ?.brokerId === "" ||
                                            formik1?.values?.lineItems[index]
                                              ?.brokerId
                                              ? "#212121"
                                              : "#898989",
                                        },
                                      }}
                                      name={`lineItems[${index}].brokerId`}
                                      value={
                                        formik1?.values?.lineItems[index]
                                          ?.brokerId
                                          ? formik1?.values?.lineItems[index]
                                              ?.brokerId
                                          : "0"
                                      }
                                      onChange={formik1.handleChange}
                                      disabled={invoiceStatus}
                                      IconComponent={KeyboardArrowDownIcon}
                                      error={
                                        !!formik1.errors.lineItems?.[index]
                                          ?.brokerId &&
                                        !!formik1.touched.lineItems?.[index]
                                          ?.brokerId
                                      }
                                    >
                                      {brokerNamesperproject &&
                                        brokerNamesperproject.map((item) => (
                                          <MenuItem
                                            key={item.UserID}
                                            value={item.UserID}
                                          >
                                            <span
                                              style={{
                                                maxWidth: "250px",
                                                whiteSpace: "break-spaces",
                                              }}
                                              className="select-option-text"
                                            >
                                              {item.FirstName} {item.LastName}
                                            </span>
                                          </MenuItem>
                                        ))}
                                    </Select>
                                    <FormHelperText error={true}>
                                      {formik1.errors.lineItems?.[index]
                                        ?.brokerId &&
                                      formik1.touched.lineItems?.[index]
                                        ?.brokerId
                                        ? formik1.errors.lineItems[index]
                                            .brokerId
                                        : ""}
                                    </FormHelperText>
                                  </FormControl>

                                    <Box
                                      sx={{
                                        flex: "1 1 0",
                                        minWidth: 0,
                                        width: "100%",
                                      }}
                                    >
                                    <p
                                      style={{
                                        marginBottom: "8px",
                                      }}
                                      className="label"
                                    >
                                      Date:
                                    </p>

                                    <LocalizationProvider
  className="invoice-date-field"
  sx={{
    width: "100%",
    minWidth: 0,
    overflow: "hidden",
    mt: "0px",
  }}
  dateAdapter={AdapterDayjs}
>
  <DatePicker
    sx={{
      width: "100%",
      minWidth: 0,
    }}
    className={
      formik1.errors.lineItems &&
      formik1.errors.lineItems[index] &&
      formik1.errors.lineItems[index].date &&
      formik1.touched.lineItems &&
      formik1.touched.lineItems[index] &&
      formik1.touched.lineItems[index].date
        ? "error-datefield"
        : ""
    }
    disabled={invoiceStatus}
    views={["year", "month", "day"]}
    name={`lineItems[${index}].date`}
    onChange={(value) => {
      lineDateChange(value, index);
    }}
    value={
      formik1?.values?.lineItems[index]?.date &&
      formik1?.values?.lineItems[index]?.date !== "Invalid Date"
        ? dayjs(
            formik1?.values?.lineItems[index]?.date,
            "MM/DD/YYYY"
          )
        : dayjs(rec.startDate)
    }
    shouldDisableDate={(date) => {
      const billingStart = dayjs(rec.startDate);
      const billingEnd = dayjs(rec.endDate);

      return (
        date.isBefore(billingStart, "day") ||
        date.isAfter(billingEnd, "day")
      );
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        fullWidth
        sx={{
          width: "100%",
          pt: "0px",
        }}
        error={
          formik1.errors.lineItems?.[index]?.date &&
          formik1.touched.lineItems?.[index]?.date
        }
        helperText={
          formik1.errors.lineItems?.[index]?.date &&
          formik1.touched.lineItems?.[index]?.date
            ? formik1.errors.lineItems[index].date
            : ""
        }
      />
    )}
  />
</LocalizationProvider>
                                    <FormHelperText error={true}>
                                      {formik1.errors.lineItems &&
                                      formik1.errors.lineItems[index] &&
                                      formik1.errors.lineItems[index].date &&
                                      formik1.touched.lineItems &&
                                      formik1.touched.lineItems[index] &&
                                      formik1.touched.lineItems[index].date
                                        ? formik1.errors.lineItems[index].date
                                        : ""}
                                    </FormHelperText>
                                  </Box>
                                 <FormControl className="billing-type-input" variant="outlined" sx={{ flex: "1 1 0", minWidth: 0, width: "100%" }}>
                                   <p className="label">Select Day Rate:</p>
                                   <Select
                                     name={`lineItems[${index}].selectedDayRate`}
                                     value={formik1.values.lineItems[index]?.selectedDayRate || "Billable Rate"}
                                     onChange={(event) =>
                                       handleConsolidatedLineRateChange(
                                         index,
                                         event.target.value,
                                         rec
                                       )
                                     }
                                     disabled={invoiceStatus}
                                     className="billing-type-input"
                                     IconComponent={KeyboardArrowDownIcon}
                                   >
                                     {getConsolidatedLineRateOptions(index, formik1.values.lineItems[index]?.brokerId).map((option) => (
                                       <MenuItem key={option} value={option}>{option}</MenuItem>
                                     ))}
                                   </Select>
                                 </FormControl>
                                 </Stack>
                                 <Stack
                                   className="billing-type-box"
                                  direction={{ xs: "column", sm: "row" }}
                                  spacing={{ xs: 1, sm: 1.5, md: 1.5 }}
                                  justifyContent="space-between"
                                  sx={{
                                    alignItems: {
                                      xs: "flex-start",
                                      md: "flex-start",
                                    },
                                    mt: 1.5,
                                    display: {
                                      xs: "unset",
                                      sm: "grid",
                                      md: "grid",
                                      lg: "flex",
                                    },
                                    gridTemplateColumns: {
                                      xs: "unset",
                                      sm: "repeat(3, 1fr)",
                                      md: "repeat(3, 1fr)",
                                      lg: "unset",
                                    },
                                    rowGap: "10px !important",
                                  }}
                                >
                                  <FormControl
                                    className="billing-type-input"
                                    sx={{ minWidth: "152px" }}
                                  >
                                    <p className="label">Billing Type</p>
                                    <Select
                                      sx={{
                                        "& .MuiOutlinedInput-notchedOutline": {
                                          border:
                                            warningHighlightColor &&
                                            formik1?.values?.lineItems[index]
                                              ?.billingType &&
                                            formik1?.values?.lineItems[index]
                                              ?.billingType != ""
                                              ? "yellow"
                                              : "",
                                          borderWidth:
                                            warningHighlightColor &&
                                            formik1?.values?.lineItems[index]
                                              ?.billingType &&
                                            formik1?.values?.lineItems[index]
                                              ?.billingType != ""
                                              ? "1px"
                                              : "",
                                          outline:
                                            warningHighlightColor &&
                                            formik1?.values?.lineItems[index]
                                              ?.billingType &&
                                            formik1?.values?.lineItems[index]
                                              ?.billingType != ""
                                              ? "1px solid yellow"
                                              : "",
                                        },
                                        "& .MuiSelect-select": {
                                          color:
                                            formik1?.values?.lineItems[index]
                                              ?.billingType === "" ||
                                            formik1?.values?.lineItems[index]
                                              ?.billingType
                                              ? "#212121"
                                              : "#898989",
                                        },
                                      }}
                                      name={`lineItems[${index}].billingType`}
                                      onChange={formik1.handleChange}
                                      value={
                                        formik1?.values?.lineItems[index]
                                          ?.billingType
                                      }
                                      error={
                                        formik1.errors.lineItems &&
                                        formik1.errors.lineItems[index] &&
                                        formik1.errors.lineItems[index]
                                          .billingType &&
                                        formik1.touched.lineItems &&
                                        formik1.touched.lineItems[index] &&
                                        formik1.touched.lineItems[index]
                                          .billingType
                                      }
                                      helperText={
                                        formik1.errors.lineItems &&
                                        formik1.errors.lineItems[index] &&
                                        formik1.errors.lineItems[index]
                                          .billingType &&
                                        formik1.touched.lineItems &&
                                        formik1.touched.lineItems[index] &&
                                        formik1.touched.lineItems[index]
                                          .billingType
                                          ? formik1.errors.lineItems[index]
                                              .billingType
                                          : ""
                                      }
                                      IconComponent={KeyboardArrowDownIcon}
                                    >
                                      {billTypeList?.map((rec) => (
                                        <MenuItem key={rec.id} value={rec.id}>
                                          {rec.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                    {formik1.errors.lineItems &&
                                      formik1.errors.lineItems[index] &&
                                      formik1.errors.lineItems[index]
                                        .billingType &&
                                      formik1.touched.lineItems &&
                                      formik1.touched.lineItems[index] &&
                                      formik1.touched.lineItems[index]
                                        .billingType && (
                                        <FormHelperText error={true}>
                                          {
                                            formik1.errors.lineItems[index]
                                              .billingType
                                          }
                                        </FormHelperText>
                                      )}
                                  </FormControl>

                                  <FormControl variant="standard">
                                    <p className="label">Day Rate</p>
                                    <Input
                                      className="default-btn dollar-field"
                                      disabled
                                      name={`lineItems[${index}].dayRate`}
                                      id={`dayRate-${index}`}
                                      type="text"
                                      onChange={(e) => formik1.handleChange(e)}
                                      // value={
                                      //   BillingDayRate
                                      //     ? BillingDayRate
                                      //     : BillableDayRate
                                      // }
                                      value={formatPopulatedDayRate(
                                        newLineRate
                                      )}
                                      startAdornment={
                                        <InputAdornment position="start">
                                          <span className="dollar-icon">$</span>
                                        </InputAdornment>
                                      }
                                      inputProps={{
                                        pattern: "^\\d*(\\.\\d{0,2})?$", // Allows numbers with up to two decimal places
                                      }}
                                    />
                                  </FormControl>
                                  <FormControl variant="standard">
                                    <p className="label">Hours</p>
                                    <Input
                                      sx={{
                                        // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                                        borderColor:
                                          warningHighlightColor &&
                                          formik1?.values?.lineItems[index]
                                            ?.hours &&
                                          formik1?.values?.lineItems[index]
                                            ?.hours != "0.00"
                                            ? "yellow"
                                            : "inherit",
                                        borderWidth:
                                          warningHighlightColor &&
                                          formik1?.values?.lineItems[index]
                                            ?.hours &&
                                          formik1?.values?.lineItems[index]
                                            ?.hours != "0.00"
                                            ? "1px"
                                            : "inherit",
                                        outline:
                                          warningHighlightColor &&
                                          formik1?.values?.lineItems[index]
                                            ?.hours &&
                                          formik1?.values?.lineItems[index]
                                            ?.hours != "0.00"
                                            ? "1px solid yellow"
                                            : "inherit",
                                        border:
                                          warningHighlightColor &&
                                          formik1?.values?.lineItems[index]
                                            ?.hours &&
                                          formik1?.values?.lineItems[index]
                                            ?.hours != "0.00"
                                            ? "1px solid yellow"
                                            : "inherit",
                                      }}
                                      name={`lineItems[${index}].hours`}
                                      disabled={invoiceStatus}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        const numericValue = parseFloat(value);

                                        // Allow only valid number with up to 2 decimal places, and max 24
                                        if (
                                          /^\d*\.?\d{0,2}$/.test(value) &&
                                          (numericValue <= 24 || value === "")
                                        ) {
                                          const { name } = e.target;

                                          // Set the field value using Formik's helper to handle nested structures
                                          formik1.setFieldValue(name, value);

                                          // Get index from the name (e.g., "lineItems[0].hours")
                                          const match = name.match(
                                            /lineItems\[(\d+)\]\.hours/
                                          );
                                          if (match) {
                                            const index = parseInt(
                                              match[1],
                                              10
                                            );
                                            const currentItem =
                                              formik1.values.lineItems[index];

                                            // Update perDiem at the same index
                                            const updatedPerDiem =
                                              calculatePerDiem(
                                                value,
                                                currentItem?.perDiemRate || 0
                                              );
                                            formik1.setFieldValue(
                                              `lineItems[${index}].perDiem`,
                                              updatedPerDiem
                                            );
                                          }
                                        }
                                      }}
                                      value={
                                        formik1?.values?.lineItems[index]?.hours
                                      }
                                    />
                                  </FormControl>
                                  <FormControl
                                    sx={{
                                      marginLeft: {
                                        xs: "auto !important",
                                        sm: "0px !important",
                                        md: "0px !important",
                                        lg: "12px !important",
                                      },
                                    }}
                                    variant="standard"
                                  >
                                    <p className="label">Miles</p>
                                    <Input
                                      name={`lineItems[${index}].miles`}
                                      disabled={invoiceStatus}
                                      onChange={(e) => {
                                        const { name, value } = e.target;
                                        const numericValue = parseInt(value);
                                        const floatRegex = /^\d{1,5}$/;
                                        if (
                                          !isNaN(value) &&
                                          (value === "" ||
                                            floatRegex.test(value)) &&
                                          (numericValue <= 10000 ||
                                            value === "")
                                        ) {
                                          formik1.handleChange(e);
                                        }
                                      }}
                                      value={
                                        formik1?.values?.lineItems[index]?.miles
                                      }
                                      sx={{
                                        // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                                        borderColor:
                                          warningHighlightColor &&
                                          formik1?.values?.lineItems[index]
                                            ?.miles &&
                                          formik1?.values?.lineItems[index]
                                            ?.miles != "0"
                                            ? "yellow"
                                            : "inherit",
                                        borderWidth:
                                          warningHighlightColor &&
                                          formik1?.values?.lineItems[index]
                                            ?.miles &&
                                          formik1?.values?.lineItems[index]
                                            ?.miles != "0"
                                            ? "1px"
                                            : "inherit",
                                        outline:
                                          warningHighlightColor &&
                                          formik1?.values?.lineItems[index]
                                            ?.miles &&
                                          formik1?.values?.lineItems[index]
                                            ?.miles != "0"
                                            ? "1px solid yellow"
                                            : "inherit",
                                        border:
                                          warningHighlightColor &&
                                          formik1?.values?.lineItems[index]
                                            ?.miles &&
                                          formik1?.values?.lineItems[index]
                                            ?.miles != "0"
                                            ? "1px solid yellow"
                                            : "inherit",
                                      }}
                                    />
                                  </FormControl>
                                  <FormControl
                                    sx={{
                                      marginLeft: {
                                        xs: "auto !important",
                                        sm: "0px !important",
                                        md: "0px !important",
                                        lg: "12px !important",
                                      },
                                    }}
                                    variant="standard"
                                  >
                                    <p className="label">Lodging</p>
                                    <Input
                                      className="dollar-field"
                                      name={`lineItems[${index}].lodging`}
                                      disabled={invoiceStatus}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                                          formik1.handleChange(e);
                                        }
                                      }}
                                      value={
                                        formik1?.values?.lineItems[index]
                                          ?.lodging
                                      }
                                      startAdornment={
                                        <InputAdornment position="start">
                                          <span className="dollar-icon">$</span>
                                        </InputAdornment>
                                      }
                                      sx={{
                                        // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                                        borderColor:
                                          warningHighlightColor &&
                                          formik1?.values?.lineItems[index]
                                            ?.lodging &&
                                          formik1?.values?.lineItems[index]
                                            ?.lodging != "0.00"
                                            ? "yellow"
                                            : "inherit",
                                        borderWidth:
                                          warningHighlightColor &&
                                          formik1?.values?.lineItems[index]
                                            ?.lodging &&
                                          formik1?.values?.lineItems[index]
                                            ?.lodging != "0.00"
                                            ? "1px"
                                            : "inherit",
                                        outline:
                                          warningHighlightColor &&
                                          formik1?.values?.lineItems[index]
                                            ?.lodging &&
                                          formik1?.values?.lineItems[index]
                                            ?.lodging != "0.00"
                                            ? "1px solid yellow"
                                            : "inherit",
                                        border:
                                          warningHighlightColor &&
                                          formik1?.values?.lineItems[index]
                                            ?.lodging &&
                                          formik1?.values?.lineItems[index]
                                            ?.lodging != "0.00"
                                            ? "1px solid yellow"
                                            : "inherit",
                                      }}
                                    />
                                  </FormControl>
                                  <FormControl variant="standard">
                                    <p className="label">Copies</p>
                                    <Input
                                      className="dollar-field"
                                      name={`lineItems[${index}].copies`}
                                      disabled={invoiceStatus}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                                          formik1.handleChange(e);
                                        }
                                      }}
                                      value={
                                        formik1?.values?.lineItems[index]
                                          ?.copies
                                      }
                                      startAdornment={
                                        <InputAdornment position="start">
                                          <span className="dollar-icon">$</span>
                                        </InputAdornment>
                                      }
                                      sx={{
                                        // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                                        borderColor:
                                          warningHighlightColor &&
                                          formik1?.values?.lineItems[index]
                                            ?.copies &&
                                          formik1?.values?.lineItems[index]
                                            ?.copies != "0.00"
                                            ? "yellow"
                                            : "inherit",
                                        borderWidth:
                                          warningHighlightColor &&
                                          formik1?.values?.lineItems[index]
                                            ?.copies &&
                                          formik1?.values?.lineItems[index]
                                            ?.copies != "0.00"
                                            ? "1px"
                                            : "inherit",
                                        outline:
                                          warningHighlightColor &&
                                          formik1?.values?.lineItems[index]
                                            ?.copies &&
                                          formik1?.values?.lineItems[index]
                                            ?.copies != "0.00"
                                            ? "1px solid yellow"
                                            : "inherit",
                                        border:
                                          warningHighlightColor &&
                                          formik1?.values?.lineItems[index]
                                            ?.copies &&
                                          formik1?.values?.lineItems[index]
                                            ?.copies != "0.00"
                                            ? "1px solid yellow"
                                            : "inherit",
                                      }}
                                    />
                                  </FormControl>
                                </Stack>
                                <Stack
                                  direction={{ xs: "column", sm: "row" }}
                                  spacing={{ xs: 1, sm: 1.5, md: 1.5 }}
                                  justifyContent="space-between"
                                  sx={{
                                    alignItems: {
                                      xs: "flex-start",
                                      md: "flex-start",
                                    },
                                    mt: "-2px",
                                    display: {
                                      xs: "unset",
                                      sm: "grid",
                                      md: "grid",
                                      lg: "flex",
                                    },
                                    gridTemplateColumns: {
                                      xs: "unset",
                                      sm: "repeat(2, 1fr)",
                                      md: "repeat(2, 1fr)",
                                      lg: "unset",
                                    },
                                    rowGap: "10px !important",
                                  }}
                                >
                                  <FormControl
                                    sx={{
                                      minWidth: { xs: "100%", sm: "290px" },
                                    }}
                                    variant="standard"
                                  >
                                    <p className="label">Description</p>
                                    <textarea
                                      style={{
                                        resize: "vertical",
                                        overflow: "auto",
                                        outline:
                                          warningHighlightColor &&
                                          formik1?.values?.lineItems[index]
                                            ?.description &&
                                          formik1?.values?.lineItems[index]
                                            ?.description != ""
                                            ? "2px solid yellow"
                                            : "",
                                      }}
                                      placeholder="Write Description"
                                      className="upload-textarea"
                                      id="description"
                                      disabled={invoiceStatus}
                                      // multiline
                                      rows={4}
                                      // defaultValue=""
                                      maxLength="1000"
                                      name={`lineItems[${index}].description`}
                                      onChange={formik1.handleChange}
                                      value={
                                        formik1?.values?.lineItems[index]
                                          ?.description
                                      }
                                    />
                                  </FormControl>

                                  <FormControl
                                    sx={{ minWidth: "130px" }}
                                    variant="standard"
                                  >
                                    <p className="label">Per Diem Rate</p>

                                    <Select
                                      sx={{
                                        p: "0px !important",
                                        "& .MuiInputBase-root.MuiInput-root": {
                                          "&:before": {
                                            borderBottom:
                                              warningHighlightColor &&
                                              formik1?.values?.lineItems[index]
                                                ?.perDiemRate &&
                                              formik1?.values?.lineItems[index]
                                                ?.perDiemRate !== "0.00"
                                                ? "2px solid yellow"
                                                : "",
                                          },
                                          "&:hover:not(.Mui-disabled):before": {
                                            borderBottom:
                                              warningHighlightColor &&
                                              formik1?.values?.lineItems[index]
                                                ?.perDiemRate &&
                                              formik1?.values?.lineItems[index]
                                                ?.perDiemRate !== "0.00"
                                                ? "2px solid yellow"
                                                : "",
                                          },
                                          "&.Mui-focused:after": {
                                            borderBottom:
                                              warningHighlightColor &&
                                              formik1?.values?.lineItems[index]
                                                ?.perDiemRate &&
                                              formik1?.values?.lineItems[index]
                                                ?.perDiemRate !== "0.00"
                                                ? "2px solid yellow"
                                                : "",
                                          },
                                        },
                                        "& .MuiSelect-select": {
                                          color:
                                            formik1?.values?.lineItems[index]
                                              ?.perDiemRate === "" ||
                                            formik1?.values?.lineItems[index]
                                              ?.perDiemRate
                                              ? "#212121"
                                              : "#898989",
                                        },
                                      }}
                                      className="dollar-field per-diem-rate-field"
                                      id="grouped-select"
                                      name={`lineItems[${index}].perDiemRate`}
                                      // onChange={formik1?.handleChange}
                                      onChange={(e) => {
                                        formik1.handleChange(e); // Let Formik handle the default change first

                                        const { name, value } = e.target;

                                        // Set the updated field correctly
                                        formik1.setFieldValue(name, value);

                                        // Extract the index from the name (e.g., "lineItems[2].hours")
                                        const match = name.match(
                                          /lineItems\[(\d+)\]\.perDiemRate/
                                        );
                                        console.log(
                                          match,
                                          "matchhhhhhhhhh",
                                          name
                                        );
                                        if (match) {
                                          const index = parseInt(match[1], 10);
                                          const currentItem =
                                            formik1.values.lineItems[index];

                                          console.log(
                                            currentItem,
                                            "currrrrrrrrr"
                                          );
                                          // Calculate updated per diem
                                          const updatedPerDiem =
                                            calculatePerDiem(
                                              currentItem?.hours || 0,
                                              value || 0
                                            );
                                          console.log(
                                            updatedPerDiem,
                                            "ippapppapa"
                                          );
                                          // Update the corresponding perDiem field
                                          formik1.setFieldValue(
                                            `lineItems[${index}].perDiem`,
                                            updatedPerDiem
                                          );
                                        }
                                      }}
                                      IconComponent={KeyboardArrowDownIcon}
                                      value={
                                        !isNaN(
                                          parseFloat(
                                            formik1?.values?.lineItems[index]
                                              ?.perDiemRate
                                          )
                                        )
                                          ? parseFloat(
                                              formik1?.values?.lineItems[index]
                                                ?.perDiemRate
                                            ).toFixed(2)
                                          : "0.00"
                                      }
                                      startAdornment={
                                        <InputAdornment position="start">
                                          <span className="dollar-icon">$</span>
                                        </InputAdornment>
                                      }
                                    >
                                      <ListSubheader className="per-diem-header">
                                        N/A
                                      </ListSubheader>
                                      <MenuItem value="0.00">0.00</MenuItem>
                                      <ListSubheader className="per-diem-header">
                                        Office Per Diem
                                      </ListSubheader>
                                      <MenuItem
                                        value={
                                          !isNaN(
                                            parseFloat(BillableOfficePerDiem)
                                          )
                                            ? parseFloat(
                                                BillableOfficePerDiem
                                              ).toFixed(2)
                                            : "0.00"
                                        }
                                      >
                                        {!isNaN(
                                          parseFloat(BillableOfficePerDiem)
                                        )
                                          ? parseFloat(
                                              BillableOfficePerDiem
                                            ).toFixed(2)
                                          : "0.00"}
                                      </MenuItem>
                                      <ListSubheader className="per-diem-header">
                                        Travel Per Diem
                                      </ListSubheader>
                                      <MenuItem
                                        value={
                                          !isNaN(
                                            parseFloat(BillableTravelPerDiem)
                                          )
                                            ? parseFloat(
                                                BillableTravelPerDiem
                                              ).toFixed(2)
                                            : "0.00"
                                        }
                                      >
                                        {!isNaN(
                                          parseFloat(BillableTravelPerDiem)
                                        )
                                          ? parseFloat(
                                              BillableTravelPerDiem
                                            ).toFixed(2)
                                          : "0.00"}
                                      </MenuItem>
                                    </Select>
                                  </FormControl>

                                  <FormControl
                                    sx={{
                                      marginLeft: {
                                        xs: "auto !important",
                                        sm: "0px !important",
                                        md: "0px !important",
                                        lg: "12px !important",
                                      },
                                    }}
                                    variant="standard"
                                  >
                                    <p className="label">Per Diem</p>
                                    <Input
                                      className="dollar-field"
                                      name={`lineItems[${index}].perDiem`}
                                      // disabled
                                      onChange={(e) => {
                                        const { value } = e.target;
                                      
                                        // Allow empty input or numbers with up to 2 decimal places
                                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                                          formik1.handleChange(e);
                                        }
                                      }}
                                      value={
                                        formik1.values.lineItems[index]?.perDiem
                                      }
                                      // value={calculatePerDiem(
                                      //   formik1?.values?.lineItems[index]
                                      //     ?.hours || 0,
                                      //   formik1?.values?.lineItems[index]
                                      //     ?.perDiemRate || 0
                                      // )}
                                      startAdornment={
                                        <InputAdornment position="start">
                                          <span className="dollar-icon">$</span>
                                        </InputAdornment>
                                      }
                                      sx={{
                                        // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                                        borderColor:
                                          warningHighlightColor &&
                                          formik1?.values.lineItems[index]
                                            ?.perDiem &&
                                          formik1?.values.lineItems[index]
                                            ?.perDiem != "0.00"
                                            ? "yellow"
                                            : "inherit",
                                        borderWidth:
                                          warningHighlightColor &&
                                          formik1?.values.lineItems[index]
                                            ?.perDiem &&
                                          formik1?.values.lineItems[index]
                                            ?.perDiem != "0.00"
                                            ? "1px"
                                            : "inherit",
                                        outline:
                                          warningHighlightColor &&
                                          formik1?.values.lineItems[index]
                                            ?.perDiem &&
                                          formik1?.values.lineItems[index]
                                            ?.perDiem != "0.00"
                                            ? "1px solid yellow"
                                            : "inherit",
                                        border:
                                          warningHighlightColor &&
                                          formik1?.values.lineItems[index]
                                            ?.perDiem &&
                                          formik1?.values.lineItems[index]
                                            ?.perDiem != "0.00"
                                            ? "1px solid yellow"
                                            : "inherit",
                                      }}
                                    />
                                  </FormControl>
                                  <FormControl variant="standard">
                                    <p className="label">Misc</p>
                                    <Input
                                      className="dollar-field"
                                      name={`lineItems[${index}].misc`}
                                      disabled={invoiceStatus}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                                          formik1.handleChange(e);
                                        }
                                      }}
                                      value={
                                        formik1?.values.lineItems[index]?.misc
                                      }
                                      startAdornment={
                                        <InputAdornment position="start">
                                          <span className="dollar-icon">$</span>
                                        </InputAdornment>
                                      }
                                      sx={{
                                        // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                                        borderColor:
                                          warningHighlightColor &&
                                          formik1?.values.lineItems[index]
                                            ?.misc &&
                                          formik1?.values.lineItems[index]
                                            ?.misc != "0.00"
                                            ? "yellow"
                                            : "inherit",
                                        borderWidth:
                                          warningHighlightColor &&
                                          formik1?.values.lineItems[index]
                                            ?.misc &&
                                          formik1?.values.lineItems[index]
                                            ?.misc != "0.00"
                                            ? "1px"
                                            : "inherit",
                                        outline:
                                          warningHighlightColor &&
                                          formik1?.values.lineItems[index]
                                            ?.misc &&
                                          formik1?.values.lineItems[index]
                                            ?.misc != "0.00"
                                            ? "1px solid yellow"
                                            : "inherit",
                                        border:
                                          warningHighlightColor &&
                                          formik1?.values.lineItems[index]
                                            ?.misc &&
                                          formik1?.values.lineItems[index]
                                            ?.misc != "0.00"
                                            ? "1px solid yellow"
                                            : "inherit",
                                      }}
                                    />
                                  </FormControl>
                                </Stack>
                              </Box>
                            </Box>
                            {rec.selectedperiod &&
                              rec.selectedperiod
                                .filter(
                                  (item) =>
                                    item.InvoiceDetailsID &&
                                    item?.BillingType != 0
                                )
                                .sort((a, b) => {
                                  // Parse the 'Date' field using moment for sorting
                                  const dateA = moment(a.Date);
                                  const dateB = moment(b.Date);

                                  // Sort by 'Date'
                                  if (dateA.isBefore(dateB)) {
                                    return -1; // a comes before b
                                  } else if (dateA.isAfter(dateB)) {
                                    return 1; // a comes after b
                                  } else {
                                    return 0; // dates are equal
                                  }
                                }) // Filter out items without InvoiceDetailsID
                                .map((key, index) => {
                                  console.log(key, "keyyeeeeeeeeeeeeeee");
                                  const {
                                    Date,
                                    BillingType,
                                    Hours,
                                    Miles,
                                    Lodging,
                                    Copies,
                                    Misc,
                                    PerDiem,
                                    Description,
                                    BillingStatementID,
                                    BrokerName,
                                    PerDiemRate,
                                    BillableOfficePerDiem,
                                    BillableTravelPerDiem,
                                    DayRate,
                                    BillableDayRate,
                                    BillingDetailID,
                                    InvoiceDetailsID,
                                    ProjID,
                                    PeriodKey,
                                    InvProjectID,
                                    InvPeriodKey,
                                    MatchedHours,
                                    MatchedMiles,
                                    MatchedLodging,
                                    MatchedCopies,
                                    MatchedPerDiem,
                                    MatchedPerDiemRate,
                                    MatchedMisc,
                                  } = key;
                                  const lineProjectId = ProjID || InvProjectID || rec?.ProjID || rec?.InvProjectID;
                                  const linePeriodKey = PeriodKey || InvPeriodKey || rec?.PeriodKey || rec?.InvPeriodKey;
                                  const projectHeaderRate = getProjectHeaderRate(
                                    lineProjectId,
                                    linePeriodKey
                                  );
                                  const lineDayRateValue = resolveExistingLineItemDayRate(
                                    getPersistedSelectedDayRate(key),
                                    {
                                      ...key,
                                      InvoiceDayRate: projectHeaderRate.dayRate,
                                      ...projectHeaderRate,
                                    },
                                    normalizeProjectRateData({
                                      ...rec,
                                      InvoiceDayRate: projectHeaderRate.dayRate,
                                      ...projectHeaderRate,
                                    }),
                                    key?.DayRate ?? key?.BillableDayRate ?? 0
                                  ).dayRate;
                                  console.log(
                                    MatchedPerDiem,
                                    "MatchedPerDiemRateMatchedPerDiemRateMatchedPerDiemRate",
                                    calculatePerDiem(MatchedHours, MatchedPerDiemRate)
                                  );
                                  return (
                                    <React.Fragment
                                      key={`${getProjectCardKey(
                                        lineProjectId,
                                        linePeriodKey
                                      )}-${InvoiceDetailsID || BillingDetailID || Date}`}
                                    >
                                      <Box
                                        className="bill-form-box"
                                        key={`${InvoiceDetailsID || BillingDetailID || Date}_line`}
                                      >
                                        <Stack
                                          className="bill-form-title"
                                          direction={{
                                            xs: "column",
                                            sm: "row",
                                          }}
                                          spacing={{ xs: 1, sm: 1.5, md: 1.5 }}
                                          justifyContent="space-between"
                                          sx={{
                                            alignItems: {
                                              xs: "flex-start",
                                              md: "center",
                                            },
                                          }}
                                        >
                                          <Typography className="billing-boxdate-title">
                                            {/* {moment(new Date()).format('MM/DD/YYYY')} */}
                                            {/* {calculateDate(index)} */}
                                            {BrokerName} -{" "}
                                            {moment
                                              .utc(Date)
                                              .format("MM/DD/YYYY")}
                                          </Typography>

                                          <Stack
                                            className="icon-btn-box"
                                            direction="row"
                                            spacing={1}
                                            alignItems="center"
                                          >
                                            <Tooltip
                                              arrow
                                              className="project-tooltip"
                                              title="Remove this line"
                                              placement="top"
                                            >
                                              <IconButton
                                                className="delete-icon-btn"
                                                aria-label="fingerprint"
                                                color="secondary"
                                                disabled={invoiceStatus}
                                                onClick={() => {
                                                  setDeletedInvoiceLineItemPopup(
                                                    true
                                                  );
                                                  setInvoiceDeleteKey(key);
                                                  setInvoiceDeleteIndex(index);
                                                  setInvoiceDetailsValues(
                                                    InvoiceDetailsID
                                                  );
                                                  setIsAttachDetachLoadedBilling(
                                                    false
                                                  );
                                                  setIsAttachDetachLoaded(
                                                    false
                                                  );
                                                  if (
                                                    key.BillingDetailID === 0 &&
                                                    key.BillingHeaderID === 0
                                                  ) {
                                                    setDeleteLineProjId(
                                                      key.InvProjectID
                                                    );
                                                    setAttachDettachPeriodKey(
                                                      key.InvPeriodKey
                                                    );
                                                  } else {
                                                    setDeleteLineProjId(ProjID);
                                                    setAttachDettachPeriodKey(
                                                      PeriodKey
                                                    );
                                                  }

                                                  // deleteLineItemFromAPI(
                                                  //   InvoiceDetailsID,
                                                  //   key,
                                                  //   index,
                                                  //   ProjID
                                                  // )
                                                }}
                                              >
                                                <span class="material-symbols-outlined">
                                                  delete
                                                </span>
                                              </IconButton>
                                            </Tooltip>
                                            <Tooltip
                                              title="Save"
                                              arrow
                                              placement="top"
                                            >
                                              <IconButton
                                                disabled={
                                                  invoiceStatus ||
                                                  saveButtonLoading
                                                }
                                                className="save-icon-btn"
                                                aria-label="fingerprint"
                                                color="secondary"
                                                onClick={() =>{
                                                  handleUpdateLineItem(
                                                    BillingHeaderID,
                                                    InvoiceDetailsID,
                                                    ProjID
                                                      ? ProjID
                                                      : InvProjectID,
                                                    PeriodKey
                                                      ? PeriodKey
                                                      : InvPeriodKey
                                                  );
                                                  if (
                                                    calculatePerDiem(MatchedHours, MatchedPerDiemRate) !==
                                                    parseFloat(MatchedPerDiem).toFixed(2)
                                                  ) {
                                                    console.log(calculatePerDiem(MatchedHours, MatchedPerDiemRate) ,'calculatePerDiem(MatchedHours, MatchedPerDiemRate)',
                                                    parseFloat(MatchedPerDiem).toFixed(2))
                                                    // Do something here, e.g. update state, show a warning, etc.
                                                    upsertPerDiemLog(key);
                                                  }}
                                                }
                                              >
                                                <span class="material-symbols-outlined">
                                                  save
                                                </span>
                                              </IconButton>
                                            </Tooltip>
                                          </Stack>
                                        </Stack>

                                        <Box className="bill-formbox-inside">
                                          <FormControl className="billing-type-input" variant="outlined" sx={{ minWidth: "180px", mb: 1.5 }}>
                                            <p className="label">Select Day Rate</p>
                                            <Select
                                              value={normalizeSelectedDayRate(getPersistedSelectedDayRate(key))}
                                              onChange={(event) =>
                                                handleExistingConsolidatedLineRateChange(
                                                  InvoiceDetailsID,
                                                  event.target.value,
                                                  ProjID || InvProjectID,
                                                  PeriodKey || InvPeriodKey,
                                                  key
                                                )
                                              }
                                              disabled={invoiceStatus}
                                              IconComponent={KeyboardArrowDownIcon}
                                            >
                                               {getLineDayRateOptions(
                                                 {
                                                   ...findLineBroker(
                                                     getLineBrokerId(key),
                                                     ProjID || InvProjectID
                                                   ),
                                                   ...key,
                                                 },
                                                 normalizeProjectRateData(rec),
                                                 getPersistedSelectedDayRate(key)
                                               ).map((option) => (
                                                <MenuItem key={option} value={option}>
                                                  {option}
                                                </MenuItem>
                                              ))}
                                            </Select>
                                          </FormControl>
                                          <Stack
                                            direction={{
                                              xs: "column",
                                              sm: "row",
                                            }}
                                            spacing={{
                                              xs: 1,
                                              sm: 1.5,
                                              md: 1.5,
                                            }}
                                            justifyContent="space-between"
                                            sx={{
                                              alignItems: {
                                                xs: "flex-start",
                                                md: "flex-start",
                                              },
                                              display: {
                                                xs: "unset",
                                                sm: "grid",
                                                md: "grid",
                                                lg: "flex",
                                              },
                                              gridTemplateColumns: {
                                                xs: "unset",
                                                sm: "repeat(3, 1fr)",
                                                md: "repeat(3, 1fr)",
                                                lg: "unset",
                                              },
                                              rowGap: "10px !important",
                                            }}
                                          >
                                            <FormControl
                                              className="billing-type-input"
                                              sx={{ minWidth: "152px" }}
                                            >
                                              <p className="label">
                                                Billing Type
                                              </p>

                                              <Select
                                                sx={{
                                                  "& .MuiOutlinedInput-notchedOutline":
                                                    {
                                                      border:
                                                        warningHighlightColor &&
                                                        changedFields[
                                                          InvoiceDetailsID
                                                        ]?.BillingType
                                                          ? "yellow"
                                                          : "",
                                                      borderWidth:
                                                        warningHighlightColor &&
                                                        changedFields[
                                                          InvoiceDetailsID
                                                        ]?.BillingType
                                                          ? "1px"
                                                          : "",
                                                      outline:
                                                        warningHighlightColor &&
                                                        changedFields[
                                                          InvoiceDetailsID
                                                        ]?.BillingType
                                                          ? "1px solid yellow"
                                                          : "",
                                                    },
                                                  "& .MuiSelect-select": {
                                                    color:
                                                      BillingType === "" ||
                                                      BillingType
                                                        ? "#212121"
                                                        : "#898989",
                                                  },
                                                }}
                                                name="BillingType"
                                                onChange={(e) => {
                                                  listOnChange(
                                                    e,
                                                    InvoiceDetailsID,
                                                    BillingHeaderID
                                                  );
                                                }}
                                                value={BillingType}
                                                IconComponent={
                                                  KeyboardArrowDownIcon
                                                }
                                              >
                                                {billTypeList?.map((rec) => {
                                                  return (
                                                    <MenuItem value={rec.id}>
                                                      {rec.name}
                                                    </MenuItem>
                                                  );
                                                })}
                                              </Select>
                                            </FormControl>

                                            <FormControl variant="standard">
                                              <p className="label">Day Rate</p>
                                              <Input
                                                className="default-btn dollar-field"
                                                disabled
                                                name="dayRate"
                                                id="dayRate"
                                                type="dayRate"
                                                onChange={(e) => {
                                                  handleChangeDayRate(
                                                    e,
                                                    "dayRate",
                                                    ProjID
                                                  );
                                                }}
                                                value={
                                                  formatPopulatedDayRate(lineDayRateValue ?? 0)
                                                }
                                                startAdornment={
                                                  <InputAdornment position="start">
                                                    <span className="dollar-icon">
                                                      $
                                                    </span>
                                                  </InputAdornment>
                                                }
                                              />
                                            </FormControl>

                                            <FormControl variant="standard">
                                              <p className="label">Hours</p>
                                              <Input
                                                disabled={invoiceStatus}
                                                name="Hours"
                                                onChange={(e) => {
                                                  listOnChange(
                                                    e,
                                                    InvoiceDetailsID,
                                                    BillingHeaderID
                                                  );
                                                }}
                                                value={MatchedHours}
                                                sx={{
                                                  // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                                                  borderColor:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Hours == true
                                                      ? "yellow"
                                                      : "inherit",
                                                  borderWidth:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Hours == true
                                                      ? "1px"
                                                      : "inherit",
                                                  outline:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Hours == true
                                                      ? "1px solid yellow"
                                                      : "inherit",
                                                  border:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Hours == true
                                                      ? "1px solid yellow"
                                                      : "inherit",
                                                }}
                                              />
                                            </FormControl>
                                            <FormControl
                                              sx={{
                                                marginLeft: {
                                                  xs: "auto !important",
                                                  sm: "0px !important",
                                                  md: "0px !important",
                                                  lg: "12px !important",
                                                },
                                              }}
                                              variant="standard"
                                            >
                                              <p className="label">Miles</p>
                                              <Input
                                                disabled={invoiceStatus}
                                                name="Miles"
                                                onChange={(e) => {
                                                  const { name, value } =
                                                    e.target;
                                                  const numericValue =
                                                    parseInt(value);
                                                  const floatRegex =
                                                    /^\d{1,5}$/;
                                                  if (
                                                    !isNaN(value) &&
                                                    (value === "" ||
                                                      floatRegex.test(value)) &&
                                                    (numericValue <= 10000 ||
                                                      value === "")
                                                  ) {
                                                    listOnChange(
                                                      e,
                                                      InvoiceDetailsID,
                                                      BillingHeaderID
                                                    );
                                                  }
                                                }}
                                                value={MatchedMiles}
                                                sx={{
                                                  // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                                                  borderColor:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Miles == true
                                                      ? "yellow"
                                                      : "inherit",
                                                  borderWidth:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Miles == true
                                                      ? "1px"
                                                      : "inherit",
                                                  outline:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Miles == true
                                                      ? "1px solid yellow"
                                                      : "inherit",
                                                  border:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Miles == true
                                                      ? "1px solid yellow"
                                                      : "inherit",
                                                }}
                                              />
                                            </FormControl>
                                            <FormControl variant="standard">
                                              <p className="label">Lodging</p>
                                              <Input
                                                className="dollar-field"
                                                name="Lodging"
                                                disabled={invoiceStatus}
                                                onChange={(e) => {
                                                  listOnChange(
                                                    e,
                                                    InvoiceDetailsID,
                                                    BillingHeaderID
                                                  );
                                                }}
                                                value={MatchedLodging}
                                                startAdornment={
                                                  <InputAdornment position="start">
                                                    <span className="dollar-icon">
                                                      $
                                                    </span>
                                                  </InputAdornment>
                                                }
                                                sx={{
                                                  // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                                                  borderColor:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Lodging == true
                                                      ? "yellow"
                                                      : "inherit",
                                                  borderWidth:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Lodging == true
                                                      ? "1px"
                                                      : "inherit",
                                                  outline:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Lodging == true
                                                      ? "1px solid yellow"
                                                      : "inherit",
                                                  border:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Lodging == true
                                                      ? "1px solid yellow"
                                                      : "inherit",
                                                }}
                                              />
                                            </FormControl>
                                            <FormControl variant="standard">
                                              <p className="label">Copies</p>
                                              <Input
                                                className="dollar-field"
                                                name="Copies"
                                                disabled={invoiceStatus}
                                                onChange={(e) => {
                                                  listOnChange(
                                                    e,
                                                    InvoiceDetailsID,
                                                    BillingHeaderID
                                                  );
                                                }}
                                                value={MatchedCopies}
                                                startAdornment={
                                                  <InputAdornment position="start">
                                                    <span className="dollar-icon">
                                                      $
                                                    </span>
                                                  </InputAdornment>
                                                }
                                                sx={{
                                                  // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                                                  borderColor:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Copies == true
                                                      ? "yellow"
                                                      : "inherit",
                                                  borderWidth:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Copies == true
                                                      ? "1px"
                                                      : "inherit",
                                                  outline:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Copies == true
                                                      ? "1px solid yellow"
                                                      : "inherit",
                                                  border:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Copies == true
                                                      ? "1px solid yellow"
                                                      : "inherit",
                                                }}
                                              />
                                            </FormControl>
                                          </Stack>
                                          <Stack
                                            direction={{
                                              xs: "column",
                                              sm: "row",
                                            }}
                                            spacing={{
                                              xs: 1,
                                              sm: 1.5,
                                              md: 1.5,
                                            }}
                                            justifyContent="space-between"
                                            sx={{
                                              alignItems: {
                                                xs: "flex-start",
                                                md: "flex-start",
                                              },
                                              mt: 1.5,
                                              display: {
                                                xs: "unset",
                                                sm: "grid",
                                                md: "grid",
                                                lg: "flex",
                                              },
                                              gridTemplateColumns: {
                                                xs: "unset",
                                                sm: "repeat(2, 1fr)",
                                                md: "repeat(2, 1fr)",
                                                lg: "unset",
                                              },
                                              rowGap: "10px !important",
                                            }}
                                          >
                                            <FormControl
                                              sx={{
                                                minWidth: {
                                                  xs: "100%",
                                                  sm: "290px",
                                                },
                                              }}
                                              variant="standard"
                                            >
                                              <p className="label">
                                                Description
                                              </p>
                                              <textarea
                                                style={{
                                                  resize: "vertical",
                                                  overflow: "auto",
                                                  outline:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Description
                                                      ? "2px solid yellow"
                                                      : "",
                                                }}
                                                placeholder="Write Description"
                                                className="upload-textarea"
                                                disabled={invoiceStatus}
                                                id="outlined-multiline-static"
                                                // multiline
                                                rows={4}
                                                // defaultValue=""
                                                name="Description"
                                                onChange={(e) => {
                                                  listOnChange(
                                                    e,
                                                    InvoiceDetailsID,
                                                    BillingHeaderID
                                                  );
                                                }}
                                                value={Description}
                                                maxLength="1000"
                                              />
                                            </FormControl>
                                            {invoiceStatus ? (
                                              <FormControl
                                                sx={{ minWidth: "130px" }}
                                                variant="standard"
                                                disabled={invoiceStatus}
                                              >
                                                <p className="label">
                                                  Per Diem Rate
                                                </p>
                                                <Input
                                                  className="dollar-field"
                                                  disabled={invoiceStatus}
                                                  id="grouped-select"
                                                  name="PerDiemRate"
                                                  // onChange={(e) =>
                                                  //   handleChangeCustomFloatNumber(
                                                  //     e,
                                                  //     key,
                                                  //     index
                                                  //   )
                                                  // }
                                                  value={
                                                    MatchedPerDiemRate
                                                      ? MatchedPerDiemRate
                                                      : key?.MatchedPerDiemRate
                                                      ? key?.MatchedPerDiemRate
                                                      : "0"
                                                  }
                                                  startAdornment={
                                                    <InputAdornment position="start">
                                                      <span className="dollar-icon">
                                                        $
                                                      </span>
                                                    </InputAdornment>
                                                  }
                                                />
                                              </FormControl>
                                            ) : (
                                              <FormControl
                                                sx={{ minWidth: "130px" }}
                                                variant="standard"
                                              >
                                                <p className="label">
                                                  Per Diem Rate
                                                </p>

                                                <Select
                                                  className="dollar-field per-diem-rate-field"
                                                  sx={{
                                                    p: "0px !important",
                                                    "& .MuiInputBase-root.MuiInput-root":
                                                      {
                                                        // For the standard variant, use borderBottom to apply the border color
                                                        "&:before": {
                                                          borderBottom:
                                                            warningHighlightColor &&
                                                            changedFields[
                                                              InvoiceDetailsID
                                                            ]?.PerDiemRate
                                                              ? "2px solid yellow"
                                                              : "",
                                                        },
                                                        "&:hover:not(.Mui-disabled):before":
                                                          {
                                                            borderBottom:
                                                              warningHighlightColor &&
                                                              changedFields[
                                                                InvoiceDetailsID
                                                              ]?.PerDiemRate
                                                                ? "2px solid yellow"
                                                                : "",
                                                          },
                                                        "&.Mui-focused:after": {
                                                          borderBottom:
                                                            warningHighlightColor &&
                                                            changedFields[
                                                              InvoiceDetailsID
                                                            ]?.PerDiemRate
                                                              ? "2px solid yellow"
                                                              : "",
                                                        },
                                                      },
                                                    "& .MuiSelect-select": {
                                                      color:
                                                        PerDiemRate === "" ||
                                                        PerDiemRate
                                                          ? "#212121"
                                                          : "#898989",
                                                    },
                                                  }}
                                                  // disabled={billingStatus}
                                                  // defaultValue={item.perDiemRate}
                                                  id="grouped-select"
                                                  name="PerDiemRate"
                                                  IconComponent={
                                                    KeyboardArrowDownIcon
                                                  }
                                                  defaultValue={
                                                    PerDiemRate
                                                      ? PerDiemRate
                                                      : "0"
                                                  }
                                                  onChange={(e) => {
                                                    listOnChange(
                                                      e,
                                                      InvoiceDetailsID,
                                                      BillingHeaderID
                                                    );
                                                  }}
                                                  value={
                                                    MatchedPerDiemRate
                                                      ? parseFloat(
                                                          MatchedPerDiemRate
                                                        ).toFixed(2)
                                                      : "0.00"
                                                  }
                                                  startAdornment={
                                                    <InputAdornment position="start">
                                                      <span className="dollar-icon">
                                                        $
                                                      </span>
                                                    </InputAdornment>
                                                  }
                                                >
                                                  {/* <MenuItem
                                                    value={
                                                      MatchedPerDiemRate?.toString() ||
                                                      ""
                                                    }
                                                    disabled
                                                  >
                                                    {MatchedPerDiemRate?.toString()}
                                                  </MenuItem> */}
                                                  <ListSubheader className="per-diem-header">
                                                    N/A
                                                  </ListSubheader>
                                                  <MenuItem value="0.00">
                                                    0.00
                                                  </MenuItem>
                                                  <ListSubheader className="per-diem-header">
                                                    Office Per Diem
                                                  </ListSubheader>
                                                  <MenuItem
                                                    value={
                                                      BillableOfficePerDiem ||
                                                      "0.00"
                                                    }
                                                  >
                                                    {BillableOfficePerDiem !=
                                                      null &&
                                                    !isNaN(
                                                      parseFloat(
                                                        BillableOfficePerDiem
                                                      )
                                                    )
                                                      ? parseFloat(
                                                          BillableOfficePerDiem
                                                        ).toFixed(2)
                                                      : "0.00"}
                                                  </MenuItem>

                                                  <ListSubheader className="per-diem-header">
                                                    Travel Per Diem
                                                  </ListSubheader>

                                                  <MenuItem
                                                    value={
                                                      BillableTravelPerDiem ||
                                                      "0.00"
                                                    }
                                                  >
                                                    {BillableTravelPerDiem !=
                                                      null &&
                                                    !isNaN(
                                                      Number(
                                                        BillableTravelPerDiem
                                                      )
                                                    )
                                                      ? Number(
                                                          BillableTravelPerDiem
                                                        ).toFixed(2)
                                                      : "0.00"}
                                                  </MenuItem>
                                                </Select>
                                              </FormControl>
                                            )}
                                            <FormControl
                                              sx={{
                                                marginLeft: {
                                                  xs: "auto !important",
                                                  sm: "0px !important",
                                                  md: "0px !important",
                                                  lg: "12px !important",
                                                },
                                              }}
                                              variant="standard"
                                            >
                                              <p className="label">
                                                Per Diem
                                              </p>
                                              <Input
                                                className="dollar-field"
                                                name="PerDiem"
                                                // disabled
                                                onChange={(e) => {
                                                  listOnChange(
                                                    e,
                                                    InvoiceDetailsID,
                                                    BillingHeaderID
                                                  );
                                                }}
                                                value={MatchedPerDiem}
                                                // value={calculatePerDiem(
                                                //   MatchedHours,
                                                //   MatchedPerDiemRate
                                                // )}
                                                startAdornment={
                                                  <InputAdornment position="start">
                                                    <span className="dollar-icon">
                                                      $
                                                    </span>
                                                  </InputAdornment>
                                                }
                                              />
                                            </FormControl>
                                            <FormControl variant="standard">
                                              <p className="label">Misc</p>
                                              <Input
                                                className="dollar-field"
                                                name="Misc"
                                                disabled={invoiceStatus}
                                                onChange={(e) => {
                                                  listOnChange(
                                                    e,
                                                    InvoiceDetailsID,
                                                    BillingHeaderID
                                                  );
                                                }}
                                                value={MatchedMisc}
                                                startAdornment={
                                                  <InputAdornment position="start">
                                                    <span className="dollar-icon">
                                                      $
                                                    </span>
                                                  </InputAdornment>
                                                }
                                                sx={{
                                                  // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                                                  borderColor:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Misc == true
                                                      ? "yellow"
                                                      : "inherit",
                                                  borderWidth:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Misc == true
                                                      ? "1px"
                                                      : "inherit",
                                                  outline:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Misc == true
                                                      ? "1px solid yellow"
                                                      : "inherit",
                                                  border:
                                                    warningHighlightColor &&
                                                    changedFields[
                                                      InvoiceDetailsID
                                                    ]?.Misc == true
                                                      ? "1px solid yellow"
                                                      : "inherit",
                                                }}
                                              />
                                            </FormControl>
                                          </Stack>
                                          <Typography
                                            sx={{
                                              margin: "10px 0px 0px",
                                              fontSize: "13px",
                                              color: "#007FFF",
                                              fontWeight: 400,
                                            }}
                                          >
                                            {key.BillingHeaderID === 0 &&
                                            key.BillingDetailID === 0
                                              ? "This line manually entered."
                                              : "This line imported from billing statement."}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </React.Fragment>
                                  );
                                })}
                          </React.Fragment>
                        );
                      })
                  //   :(
                  //   <Box className="bill-form-box">
                  //   <Stack
                  //     className="bill-form-title"
                  //     direction={{ xs: "column", sm: "row" }}
                  //     spacing={{ xs: 1, sm: 1.5, md: 1.5 }}
                  //     justifyContent="space-between"
                  //     sx={{
                  //       alignItems: {
                  //         xs: "flex-start",
                  //         md: "center",
                  //       },
                  //     }}
                  //   >
                  //     <Typography className="billing-boxdate-title">
                  //       Add new line item
                  //     </Typography>

                  //     <Stack
                  //       className="icon-btn-box"
                  //       direction="row"
                  //       spacing={1}
                  //       alignItems="center"
                  //     >
                  //       <IconButton
                  //         // disabled={billingStatus}
                  //         className="save-icon-btn"
                  //         aria-label="fingerprint"
                  //         color="secondary"
                  //         onClick={() => {
                  //           handleSaveNewItem(
                  //             BillingHeaderID,
                  //             BillingDetailID,
                  //             index,
                  //             key
                  //           );
                  //         }}
                  //         // onClick={()=>{formik1.handleSubmit(formik1.values,BillingHeaderID,BillingDetailID)}}
                  //         disabled={invoiceStatus}
                  //       >
                  //         <span class="material-symbols-outlined">
                  //           save
                  //         </span>
                  //       </IconButton>
                  //     </Stack>
                  //   </Stack>

                  //   <Box className="bill-formbox-inside">
                  //     <Stack
                  //       className="line-item-fields"
                  //       direction={{ xs: "column", sm: "row" }}
                  //       spacing={{ xs: 1, sm: 1.5, md: 1.5 }}
                  //       justifyContent="space-between"
                  //       sx={{
                  //         alignItems: {
                  //           xs: "flex-start",
                  //           md: "baseline",
                  //         },
                  //         maxWidth: "466px",
                  //       }}
                  //     >
                  //       <FormControl
                  //         className="select-broker-field"
                  //         sx={{ width: "100%", maxWidth: "225px" }}
                  //         variant="outlined"
                  //       >
                  //         <p className="label">Select Broker :</p>
                  //         <Select
                  //           name={`lineItems[${index}].brokerId`}
                  //           value={
                  //             formik1?.values?.lineItems[index]?.brokerId
                  //               ? formik1?.values?.lineItems[index]
                  //                   ?.brokerId
                  //               : "0"
                  //           }
                  //           onChange={formik1.handleChange}
                  //           disabled={invoiceStatus}
                  //           IconComponent={KeyboardArrowDownIcon}
                  //           error={
                  //             !!formik1.errors.lineItems?.[index]
                  //               ?.brokerId &&
                  //             !!formik1.touched.lineItems?.[index]
                  //               ?.brokerId
                  //           }
                  //         >
                  //           {brokerNamesperproject &&
                  //             brokerNamesperproject.map((item) => (
                  //               <MenuItem
                  //                 key={item.UserID}
                  //                 value={item.UserID}
                  //               >
                  //                 {item.BrokerName}
                  //               </MenuItem>
                  //             ))}
                  //         </Select>
                  //         <FormHelperText error={true}>
                  //           {formik1.errors.lineItems?.[index]
                  //             ?.brokerId &&
                  //           formik1.touched.lineItems?.[index]?.brokerId
                  //             ? formik1.errors.lineItems[index].brokerId
                  //             : ""}
                  //         </FormHelperText>
                  //       </FormControl>

                  //       <Box>
                  //         <p
                  //           style={{
                  //             marginBottom: "0px",
                  //             maxWidth: "225px",
                  //           }}
                  //           className="label"
                  //         >
                  //           Date:
                  //         </p>

                  //         <LocalizationProvider
                  //           className="invoice-date-field"
                  //           sx={{
                  //             width: "100%",
                  //             overflow: "hidden",
                  //             mt: "0px",
                  //           }}
                  //           dateAdapter={AdapterDayjs}
                  //         >
                  //           <DemoContainer components={["DatePicker"]}>
                  //             <DemoItem>
                  //               <DatePicker
                  //                 disablePast
                  //                 className={
                  //                   formik1.errors.lineItems &&
                  //                   formik1.errors.lineItems[index] &&
                  //                   formik1.errors.lineItems[index]
                  //                     .date &&
                  //                   formik1.touched.lineItems &&
                  //                   formik1.touched.lineItems[index] &&
                  //                   formik1.touched.lineItems[index].date
                  //                     ? "error-datefield"
                  //                     : ""
                  //                 }
                  //                 disabled={invoiceStatus}
                  //                 views={["year", "month", "day"]}
                  //                 name={`lineItems[${index}].date`}
                  //                 onChange={(value) => {
                  //                   formik1.setFieldValue(
                  //                     `lineItems[${index}].date`,
                  //                     value
                  //                       ? moment(value).format(
                  //                           "MM/DD/YYYY"
                  //                         )
                  //                       : ""
                  //                   );
                  //                 }}
                  //                 value={
                  //                   formik1?.values?.lineItems[index]
                  //                     ?.date &&
                  //                   formik1?.values?.lineItems[index]
                  //                     ?.date !== "Invalid Date"
                  //                     ? moment(
                  //                         formik1?.values?.lineItems[
                  //                           index
                  //                         ]?.date,
                  //                         "MM/DD/YYYY"
                  //                       )
                  //                     : null
                  //                 }
                  //                 renderInput={(params) => (
                  //                   <TextField
                  //                     {...params}
                  //                     error={
                  //                       formik1.errors.lineItems &&
                  //                       formik1.errors.lineItems[index] &&
                  //                       formik1.errors.lineItems[index]
                  //                         .date &&
                  //                       formik1.touched.lineItems &&
                  //                       formik1.touched.lineItems[
                  //                         index
                  //                       ] &&
                  //                       formik1.touched.lineItems[index]
                  //                         .date
                  //                     }
                  //                     helperText={
                  //                       formik1.errors.lineItems &&
                  //                       formik1.errors.lineItems[index] &&
                  //                       formik1.errors.lineItems[index]
                  //                         .date &&
                  //                       formik1.touched.lineItems &&
                  //                       formik1.touched.lineItems[
                  //                         index
                  //                       ] &&
                  //                       formik1.touched.lineItems[index]
                  //                         .date
                  //                         ? formik1.errors.lineItems[
                  //                             index
                  //                           ].date
                  //                         : ""
                  //                     }
                  //                   />
                  //                 )}
                  //               />
                  //             </DemoItem>
                  //           </DemoContainer>
                  //         </LocalizationProvider>
                  //         <FormHelperText error={true}>
                  //           {formik1.errors.lineItems &&
                  //           formik1.errors.lineItems[index] &&
                  //           formik1.errors.lineItems[index].date &&
                  //           formik1.touched.lineItems &&
                  //           formik1.touched.lineItems[index] &&
                  //           formik1.touched.lineItems[index].date
                  //             ? formik1.errors.lineItems[index].date
                  //             : ""}
                  //         </FormHelperText>
                  //       </Box>
                  //     </Stack>
                  //     <Stack
                  //       className="billing-type-box"
                  //       direction={{ xs: "column", sm: "row" }}
                  //       spacing={{ xs: 1, sm: 1.5, md: 1.5 }}
                  //       justifyContent="space-between"
                  //       sx={{
                  //         alignItems: {
                  //           xs: "flex-start",
                  //           md: "center",
                  //         },
                  //         mt: "12px",
                  //       }}
                  //     >
                  //       <FormControl
                  //         className="billing-type-input"
                  //         sx={{ minWidth: "152px" }}
                  //       >
                  //         <p className="label">Billing Type</p>
                  //         <Select
                  //           name={`lineItems[${index}].billingType`}
                  //           onChange={formik1.handleChange}
                  //           value={
                  //             formik1?.values?.lineItems[index]
                  //               ?.billingType
                  //           }
                  //           error={
                  //             formik1.errors.lineItems &&
                  //             formik1.errors.lineItems[index] &&
                  //             formik1.errors.lineItems[index]
                  //               .billingType &&
                  //             formik1.touched.lineItems &&
                  //             formik1.touched.lineItems[index] &&
                  //             formik1.touched.lineItems[index].billingType
                  //           }
                  //           helperText={
                  //             formik1.errors.lineItems &&
                  //             formik1.errors.lineItems[index] &&
                  //             formik1.errors.lineItems[index]
                  //               .billingType &&
                  //             formik1.touched.lineItems &&
                  //             formik1.touched.lineItems[index] &&
                  //             formik1.touched.lineItems[index].billingType
                  //               ? formik1.errors.lineItems[index]
                  //                   .billingType
                  //               : ""
                  //           }
                  //         >
                  //           {billTypeList.map((rec) => (
                  //             <MenuItem key={rec.id} value={rec.id}>
                  //               {rec.name}
                  //             </MenuItem>
                  //           ))}
                  //         </Select>
                  //         {formik1.errors.lineItems &&
                  //           formik1.errors.lineItems[index] &&
                  //           formik1.errors.lineItems[index].billingType &&
                  //           formik1.touched.lineItems &&
                  //           formik1.touched.lineItems[index] &&
                  //           formik1.touched.lineItems[index]
                  //             .billingType && (
                  //             <FormHelperText error={true}>
                  //               {
                  //                 formik1.errors.lineItems[index]
                  //                   .billingType
                  //               }
                  //             </FormHelperText>
                  //           )}
                  //       </FormControl>

                  //       <FormControl variant="standard">
                  //         <p className="label">Day Rate</p>
                  //         <Input
                  //           className="default-btn dollar-field"
                  //           disabled
                  //           name={`lineItems[${index}].dayRate`}
                  //           id={`dayRate-${index}`}
                  //           type="text"
                  //           onChange={(e) => formik1.handleChange(e)}
                  //           value={
                  //             BillingDayRate
                  //               ? BillingDayRate
                  //               : BillableDayRate
                  //           }
                  //           startAdornment={
                  //             <InputAdornment position="start">
                  //               <span className="dollar-icon">$</span>
                  //             </InputAdornment>
                  //           }
                  //         />
                  //       </FormControl>
                  //       <FormControl variant="standard">
                  //         <p className="label">Hours</p>
                  //         <Input
                  //           name={`lineItems[${index}].hours`}
                  //           disabled={invoiceStatus}
                  //           onChange={formik1.handleChange}
                  //           value={
                  //             formik1?.values?.lineItems[index]?.hours
                  //           }
                  //         />
                  //       </FormControl>
                  //       <FormControl variant="standard">
                  //         <p className="label">Miles</p>
                  //         <Input
                  //           name={`lineItems[${index}].miles`}
                  //           disabled={invoiceStatus}
                  //           onChange={formik1.handleChange}
                  //           value={
                  //             formik1?.values?.lineItems[index]?.miles
                  //           }
                  //         />
                  //       </FormControl>
                  //       <FormControl variant="standard">
                  //         <p className="label">Lodging</p>
                  //         <Input
                  //           className="dollar-field"
                  //           name={`lineItems[${index}].lodging`}
                  //           disabled={invoiceStatus}
                  //           onChange={formik1.handleChange}
                  //           value={
                  //             formik1?.values?.lineItems[index]?.lodging
                  //           }
                  //           startAdornment={
                  //             <InputAdornment position="start">
                  //               <span className="dollar-icon">$</span>
                  //             </InputAdornment>
                  //           }
                  //         />
                  //       </FormControl>
                  //       <FormControl variant="standard">
                  //         <p className="label">Copies</p>
                  //         <Input
                  //           className="dollar-field"
                  //           name={`lineItems[${index}].copies`}
                  //           disabled={invoiceStatus}
                  //           onChange={formik1.handleChange}
                  //           value={
                  //             formik1?.values?.lineItems[index]?.copies
                  //           }
                  //           startAdornment={
                  //             <InputAdornment position="start">
                  //               <span className="dollar-icon">$</span>
                  //             </InputAdornment>
                  //           }
                  //         />
                  //       </FormControl>
                  //     </Stack>
                  //     <Stack
                  //       direction={{ xs: "column", sm: "row" }}
                  //       spacing={{ xs: 1, sm: 1.5, md: 1.5 }}
                  //       justifyContent="space-between"
                  //       sx={{
                  //         alignItems: {
                  //           xs: "flex-start",
                  //           md: "flex-start",
                  //         },
                  //         mt: "-2px",
                  //       }}
                  //     >
                  //       <FormControl
                  //         sx={{ minWidth: { xs: "100%", sm: "290px" } }}
                  //         variant="standard"
                  //       >
                  //         <p className="label">Description</p>
                  //         <textarea
                  //           style={{
                  //             resize: "vertical",
                  //             overflow: "auto",
                  //           }}
                  //           placeholder="Write Description"
                  //           className="upload-textarea"
                  //           id="description"
                  //           disabled={invoiceStatus}
                  //           // multiline
                  //           rows={4}
                  //           // defaultValue=""
                  //           name={`lineItems[${index}].description`}
                  //           onChange={formik1.handleChange}
                  //           value={
                  //             formik1?.values?.lineItems[index]
                  //               ?.description
                  //           }
                  //         />
                  //       </FormControl>

                  //       <FormControl
                  //         sx={{ minWidth: "100px" }}
                  //         variant="standard"
                  //       >
                  //         <p className="label">Per Diem Rate</p>

                  //         <Select
                  //           className="dollar-field per-diem-rate-field"
                  //           // disabled={billingStatus}
                  //           // defaultValue={item.perDiemRate}
                  //           id="grouped-select"
                  //           name={`lineItems[${index}].perDiemRate`}
                  //           onChange={formik1?.handleChange}
                  //           IconComponent={KeyboardArrowDownIcon}
                  //           value={
                  //             formik1?.values?.lineItems[index]
                  //               ?.perDiemRate
                  //               ? formik1?.values?.lineItems[
                  //                   index
                  //                 ]?.perDiemRate.toString()
                  //               : ""
                  //           }
                  //           startAdornment={
                  //             <InputAdornment position="start">
                  //               <span className="dollar-icon">$</span>
                  //             </InputAdornment>
                  //           }
                  //         >
                  //           <ListSubheader className="per-diem-header">
                  //             Office Per Diem
                  //           </ListSubheader>
                  //           <MenuItem
                  //             value={BillableOfficePerDiem?.toString()}
                  //           >
                  //             {BillableOfficePerDiem?.toString()}
                  //           </MenuItem>
                  //           <ListSubheader className="per-diem-header">
                  //             Travel Per Diem
                  //           </ListSubheader>
                  //           <MenuItem
                  //             value={BillableTravelPerDiem?.toString()}
                  //           >
                  //             {BillableTravelPerDiem?.toString()}
                  //           </MenuItem>
                  //         </Select>
                  //       </FormControl>

                  //       <FormControl variant="standard">
                  //         <p className="label">Per Diem</p>
                  //         <Input
                  //           name={`lineItems[${index}].perDiem`}
                  //           disabled
                  //           // onChange={formik1.handleChange}
                  //           // value={formik1.values.perDiem}
                  //           value={calculatePerDiem(
                  //             formik1?.values?.lineItems[index]?.hours,
                  //             formik1?.values?.lineItems[index]
                  //               ?.perDiemRate
                  //           )}
                  //           startAdornment={
                  //             <InputAdornment position="start">
                  //               <span className="dollar-icon">$</span>
                  //             </InputAdornment>
                  //           }
                  //         />
                  //       </FormControl>
                  //       <FormControl variant="standard">
                  //         <p className="label">Misc</p>
                  //         <Input
                  //           className="dollar-field"
                  //           name={`lineItems[${index}].misc`}
                  //           disabled={invoiceStatus}
                  //           onChange={formik1.handleChange}
                  //           value={formik1?.values.lineItems[index]?.misc}
                  //           startAdornment={
                  //             <InputAdornment position="start">
                  //               <span className="dollar-icon">$</span>
                  //             </InputAdornment>
                  //           }
                  //         />
                  //       </FormControl>
                  //     </Stack>
                  //   </Box>
                  // </Box>)
                }
              </Box>
            </Grid>
            <Grid xs={12} md={3}>
              <Box
                sx={{
                  p: "16px 17px",
                  ml: { xs: "0px", sm: "20px" },
                  mt: "22px",
                  position: { xs: "unset", sm: "sticky" },
                  top: "0px",
                  zIndex: 9,
                }}
                className="bg-box"
              >
                <Button
                  className="viewedit-btn"
                  variant="outlined"
                  // disabled={InvoiceTotalValue != 0.0 ? false : true}
                  startIcon={
                    <span class="material-symbols-outlined">edit</span>
                  }
                  onClick={() => {
                    handleAttachmentOpen(true);
                  }}
                  // disabled={billingStatementDetail.hprojectID ? false : true}
                >
                  View/edit attachments
                </Button>
                <Button
                  className={
                    lineList.every((item) => item.BillingType === "") &&
                    (invoiceGrandTotalVal == "0.00" ||
                      invoiceGrandTotalVal == 0)
                      ? "notopen-btn"
                      : "print-btn"
                  }
                  variant="outlined"
                  // disabled={InvoiceTotalValue != 0.0 ? false : true}
                  startIcon={
                    <span class="material-symbols-outlined">print</span>
                  }
                  onClick={() => {
                    setOpenPrintInvoiceModel(true);
                    // window.open(
                    //   `/print-consolidatedinvoice-form/${invoiceid}`,
                    //   "_blank"
                    // );
                  }}
                  disabled={
                    lineList.every((item) => item.BillingType === "") &&
                    (invoiceGrandTotalVal == "0.00" ||
                      invoiceGrandTotalVal == 0)
                  }
                >
                  Print Invoice
                </Button>
                {invoiceStatus == false ? (
                  <Tooltip
                    title="Cannot reopen an invoiced billing statement."
                    arrow
                    placement="bottom"
                  >
                    <Button
                      className="close-btn"
                      variant="outlined"
                      onClick={handleInvoiceStatus}
                      disabled={invoiceStatus}
                      startIcon={
                        <span class="material-symbols-outlined">
                          description
                        </span>
                      }
                    >
                      Close Invoice
                    </Button>
                  </Tooltip>
                ) : (
                  <Tooltip
                    title="Cannot reopen an invoiced billing statement."
                    arrow
                    placement="bottom"
                  >
                    <Button
                      className="notopen-btn"
                      variant="outlined"
                      startIcon={
                        <span class="material-symbols-outlined">
                          receipt_long
                        </span>
                      }
                      disabled={reOpenLoading}
                      onClick={() => {
                        setReopenLoading(true);
                        showToast(
                          "This invoice is closed and cannot be reopened or edited",
                          "error"
                        );

                        showToast(
                          "This invoice has been closed and can no longer be edited.",
                          "reopenInvoice"
                        );
                        setTimeout(() => {
                          setReopenLoading(false);
                        }, 3000);
                      }}
                    >
                      Cannot Reopen
                    </Button>
                  </Tooltip>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {detachOpen && (
        <DetachConfirmation
          open={detachOpen}
          handleClose={handleClose}
          detachFunCall={detachFunCall}
          attachDettachLoading={attachDettachLoading}
        />
      )}
      {AtachOpen && (
        <AttachConfirmation
          open={AtachOpen}
          handleClose={handleCloseAttach}
          detachFunCall={detachFunCall}
          attachDettachLoading={attachDettachLoading}
        />
      )}

      {openAttachmentFilter && (
        <InvoiceAttachment
          open={openAttachmentFilter}
          handleClose={handleAttachmentOpen}
          setOpenAttachmentFilter={setOpenAttachmentFilter}
          billingStatementDetail={selectedPeriodList}
          selectedNewPeriodList={selectedNewPeriodList}
          getInvoiceDetails={getInvoiceDetails}
          activeStep={activeStep}
          values={values}
        />
      )}
      {showWarning && (
        <Dialog
          className="user-filter-popup project-filters"
          sx={{
            width: "100% !important",
            height: "100%",
            maxHeight: "fit-co",
          }}
          // fullScreen={fullScreen}
          open={showWarning}
          //  onClose={handleChangeno}
        >
          <Stack
            sx={{ p: "25px 25px", pb: "4px" }}
            direction="row"
            alignItems="center"
            spacing={2}
            justifyContent="flex-start"
          >
            <ErrorIcon
              fontSize="inherit"
              style={{ color: "#007FFF", fontSize: "24px" }}
            />
            <Typography className="model-title" sx={{ ml: "5px !important" }}>
              Warning: Unsaved Changes
            </Typography>
          </Stack>
          <Box sx={{ p: "0px 25px 0px 55px" }}>
            <p className="label">
              You have unsaved changes. Unsaved changes will be lost if you
              proceed. Are you sure you want to continue?
            </p>
          </Box>
          <DialogActions
            sx={{
              justifyContent: "flex-start",
              p: "20px 25px",
              pt: "21px",
            }}
          >
            <Button className="filter-btn" onClick={() => handleYesClick()}>
              Proceed
            </Button>
            <Button className="cancel-btn" onClick={handleNoClick}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {deletedInvoicePopup && (
        <Dialog
          className="user-filter-popup project-filters"
          sx={{
            width: "100% !important",
            height: "100%",
            maxHeight: "fit-co",
          }}
          // fullScreen={fullScreen}
          open={deletedInvoicePopup}
          //  onClose={handleChangeno}
        >
          <Stack
            sx={{ p: "25px 25px", pb: "4px" }}
            direction="row"
            alignItems="center"
            spacing={2}
            justifyContent="flex-start"
          >
            <ErrorIcon
              fontSize="inherit"
              style={{ color: "#df0000", fontSize: "24px" }}
            />
            <Typography className="model-title" sx={{ ml: "5px !important" }}>
              Warning
            </Typography>
          </Stack>
          <Box sx={{ p: "5px 25px 0px 54px" }}>
            <p className="label">
              The invoice cannot be closed without any line items. Would you
              like to cancel this invoice?{" "}
            </p>
          </Box>
          <DialogActions
            sx={{
              justifyContent: "flex-start",
              p: "20px 25px",
              pt: "21px",
            }}
          >
            <Button
              className="delete-btn"
              onClick={() => handleDeleteInvoiceYesClick()}
            >
              Delete
            </Button>
            <Button className="cancel-btn" onClick={handleDeleteInvoiceNoClick}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {closingInvoice && (
        <Dialog
          className="user-filter-popup project-filters"
          sx={{
            width: "100% !important",
            height: "100%",
            maxHeight: "fit-co",
          }}
          // fullScreen={fullScreen}
          open={closingInvoice}
          //  onClose={handleChangeno}
        >
          <Stack
            sx={{ p: "25px 25px", pb: "4px" }}
            direction="row"
            alignItems="center"
            spacing={2}
            justifyContent="flex-start"
          >
            {/* <ErrorIcon
              fontSize="inherit"
              style={{ color: "#f95b5b", fontSize: "24px" }}
            /> */}
            <Typography className="model-title">Confirmation</Typography>
          </Stack>
          <Box sx={{ p: "5px 25px 0px 25px" }}>
            <p className="label">
              Are you sure you want to close this invoice?
            </p>
          </Box>
          <DialogActions
            sx={{
              justifyContent: "flex-start",
              p: "20px 25px",
              pt: "21px",
            }}
          >
            <Button
              className="filter-btn"
              onClick={() => handleClosingInvoiceYesClick()}
            >
              Proceed
            </Button>
            <Button
              className="cancel-btn"
              onClick={handleClosingInvoiceNoClick}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {deletedInvoiceLineItemPopup && (
        <Dialog
          className="user-filter-popup project-filters"
          sx={{
            width: "100% !important",
            height: "100%",
            maxHeight: "fit-co",
          }}
          open={deletedInvoiceLineItemPopup}
        >
          <Stack
            sx={{ p: "25px 25px", pb: "4px" }}
            direction="row"
            alignItems="center"
            spacing={2}
            justifyContent="flex-start"
          >
            <Typography className="model-title">Confirmation</Typography>
          </Stack>
          <Box sx={{ p: "5px 25px 0px 25px" }}>
            <p className="label">
              Are you sure you want to delete this line item?
            </p>
          </Box>
          <DialogActions
            sx={{
              justifyContent: "flex-start",
              p: "20px 25px",
              pt: "21px",
            }}
          >
            <Button
              className="delete-btn"
              onClick={() => handleManulyAddYesClick()}
            >
              Delete
            </Button>
            <Button className="cancel-btn" onClick={handleManuallyAddNoClick}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {invoicDatePopup && (
        <Dialog
          className="user-filter-popup project-filters"
          sx={{
            width: "100% !important",
            height: "100%",
            maxHeight: "fit-co",
          }}
          open={invoicDatePopup}
        >
          <Stack
            sx={{ p: "25px 25px", pb: "4px" }}
            direction="row"
            alignItems="center"
            spacing={2}
            justifyContent="flex-start"
          >
            <Typography className="model-title">Confirmation</Typography>
          </Stack>
          <Box sx={{ p: "5px 25px 0px 25px" }}>
            <p className="label">
              Are you sure you want to update the invoice date for this invoice?
            </p>
          </Box>
          <DialogActions
            sx={{
              justifyContent: "flex-start",
              p: "20px 25px",
              pt: "21px",
            }}
          >
            <Button
              className="filter-btn"
              onClick={() => handleInvoiceDatePopupUpdate()}
            >
              Update
            </Button>
            <Button
              className="cancel-btn"
              onClick={handleInvoiceDatePopupClose}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {openPrintInvoiceModel && (
        <PrintConsolidatedInvoiceModel
          open={openPrintInvoiceModel}
          setOpenPrintInvoiceModel={setOpenPrintInvoiceModel}
          billingStatementDetail={selectedPeriodList}
          invoiceNumber={values.invoiceNo}
          // handleClose = {}
        />
      )}

      {saveDayRateValue && (
        <>
          <Dialog
            className="user-filter-popup project-filters"
            sx={{ width: "100%" }}
            // fullScreen={fullScreen}
            open={saveDayRateValue}
            //onClose={""}
            aria-labelledby="responsive-dialog-title"
          >
            <Stack
              sx={{ p: "25px 25px", pb: "8px" }}
              direction="row"
              alignItems="center"
              spacing={2}
              justifyContent="space-between"
            >
              <Typography className="model-title">Save Confirmation</Typography>
            </Stack>
            <Box sx={{ p: "0px 25px 0px 25px" }}>
              <p style={{ marginBottom: "0px" }} className="label">
                Are you sure you want to update the day rate for this invoice?
              </p>
            </Box>
            <DialogActions
              sx={{ justifyContent: "flex-start", p: "20px 25px", pt: "25px" }}
            >
              <Button className="filter-btn" onClick={handleSaveDayRateYes}>
                Yes
              </Button>
              <Button className="cancel-btn" onClick={handleSaveDayRateNo}>
                No
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
      {saveMileageRateValue && (
        <>
          <Dialog
            className="user-filter-popup project-filters"
            sx={{ width: "100%" }}
            // fullScreen={fullScreen}
            open={saveMileageRateValue}
            //onClose={""}
            aria-labelledby="responsive-dialog-title"
          >
            <Stack
              sx={{ p: "25px 25px", pb: "8px" }}
              direction="row"
              alignItems="center"
              spacing={2}
              justifyContent="space-between"
            >
              <Typography className="model-title">Save Confirmation</Typography>
            </Stack>
            <Box sx={{ p: "0px 25px 0px 25px" }}>
              <p style={{ marginBottom: "0px" }} className="label">
                Are you sure you want to update the mileage rate for this
                invoice?
              </p>
            </Box>
            <DialogActions
              sx={{ justifyContent: "flex-start", p: "20px 25px", pt: "25px" }}
            >
              <Button className="filter-btn" onClick={handleSaveMileageRateYes}>
                Yes
              </Button>
              <Button className="cancel-btn" onClick={handleSaveMileageRateNo}>
                No
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </div>
  );
}
